var _style, _path, _g, _g2, _g3, _g4, _g5, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _circle, _path77, _path78, _g6, _path79, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _path80, _circle2, _path81, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _circle3, _g37, _path82, _path83, _path84, _path85, _g38, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _g39, _path95, _path96, _g40, _g41, _g42, _g43, _circle4, _g44, _circle5, _g45, _ellipse, _g46, _g47, _g48, _g49, _g50, _g51, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _g52, _g53, _g54, _g55, _g56, _g57, _g58, _g59, _g60;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTheSolution(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 549 524.6",
    style: {
      enableBackground: "new 0 0 549 524.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;fill:#FFFFFF;}\r\n\t.st1{fill:#CDBCDD;}\r\n\t.st2{fill:#D6CFDD;}\r\n\t.st3{fill:url(#path27292_1_);}\r\n\t.st4{fill:url(#path33122_1_);}\r\n\t.st5{fill:url(#path33124_1_);}\r\n\t.st6{fill:url(#path33126_1_);}\r\n\t.st7{fill:url(#path33128_1_);}\r\n\t.st8{fill:url(#path33130_1_);}\r\n\t.st9{fill:url(#path33132_1_);}\r\n\t.st10{fill:url(#path33134_1_);}\r\n\t.st11{fill:url(#path33136_1_);}\r\n\t.st12{fill:url(#path33138_1_);}\r\n\t.st13{fill:url(#path33140_1_);}\r\n\t.st14{fill:url(#path33142_1_);}\r\n\t.st15{fill:url(#path33144_1_);}\r\n\t.st16{fill:url(#path33146_1_);}\r\n\t.st17{fill:url(#path33148_1_);}\r\n\t.st18{fill:url(#path33150_1_);}\r\n\t.st19{fill:url(#path33152_1_);}\r\n\t.st20{fill:url(#path33154_1_);}\r\n\t.st21{fill:url(#path33156_1_);}\r\n\t.st22{fill:url(#path33158_1_);}\r\n\t.st23{fill:url(#path33160_1_);}\r\n\t.st24{fill:url(#path33162_1_);}\r\n\t.st25{fill:url(#path33164_1_);}\r\n\t.st26{fill:url(#path33166_1_);}\r\n\t.st27{fill:url(#path33168_1_);}\r\n\t.st28{fill:url(#path33170_1_);}\r\n\t.st29{fill:url(#path33172_1_);}\r\n\t.st30{fill:url(#path33174_1_);}\r\n\t.st31{fill:url(#path33176_1_);}\r\n\t.st32{fill:url(#path33178_1_);}\r\n\t.st33{fill:url(#path33180_1_);}\r\n\t.st34{fill:url(#path33182_1_);}\r\n\t.st35{fill:url(#path33184_1_);}\r\n\t.st36{fill:url(#path33186_1_);}\r\n\t.st37{fill:url(#path33188_1_);}\r\n\t.st38{fill:url(#path33190_1_);}\r\n\t.st39{fill:url(#path33192_1_);}\r\n\t.st40{fill:url(#path33194_1_);}\r\n\t.st41{fill:url(#path33196_1_);}\r\n\t.st42{fill:url(#path33198_1_);}\r\n\t.st43{fill:url(#path33200_1_);}\r\n\t.st44{fill:url(#path33202_1_);}\r\n\t.st45{fill:url(#path33204_1_);}\r\n\t.st46{fill:url(#path33206_1_);}\r\n\t.st47{fill:url(#path33208_1_);}\r\n\t.st48{fill:url(#path33210_1_);}\r\n\t.st49{fill:url(#path33212_1_);}\r\n\t.st50{fill:url(#path33214_1_);}\r\n\t.st51{fill:url(#path33216_1_);}\r\n\t.st52{fill:url(#path33218_1_);}\r\n\t.st53{fill:url(#path33220_1_);}\r\n\t.st54{fill:url(#path33222_1_);}\r\n\t.st55{fill:url(#path33224_1_);}\r\n\t.st56{fill:url(#path33226_1_);}\r\n\t.st57{fill:url(#path33228_1_);}\r\n\t.st58{fill:url(#path33230_1_);}\r\n\t.st59{fill:url(#path33232_1_);}\r\n\t.st60{fill:url(#path33234_1_);}\r\n\t.st61{fill:url(#path33236_1_);}\r\n\t.st62{fill:url(#path33238_1_);}\r\n\t.st63{fill:url(#path33240_1_);}\r\n\t.st64{fill:url(#path33242_1_);}\r\n\t.st65{fill:url(#path33244_1_);}\r\n\t.st66{fill:url(#path33246_1_);}\r\n\t.st67{fill:url(#path33248_1_);}\r\n\t.st68{fill:url(#path33250_1_);}\r\n\t.st69{fill:url(#path33252_1_);}\r\n\t.st70{fill:url(#path33254_1_);}\r\n\t.st71{fill:url(#path33256_1_);}\r\n\t.st72{fill:url(#path33258_1_);}\r\n\t.st73{fill:url(#path33260_1_);}\r\n\t.st74{fill:url(#path33262_1_);}\r\n\t.st75{fill:none;stroke:#A856FB;stroke-width:4.000000e-02;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:3.2;}\r\n\t.st76{fill:url(#SVGID_1_);}\r\n\t.st77{opacity:0.1;}\r\n\t.st78{fill:url(#SVGID_2_);}\r\n\t.st79{fill:url(#SVGID_3_);}\r\n\t.st80{opacity:0.2;fill:#FFFFFF;enable-background:new    ;}\r\n\t.st81{fill:none;stroke:#AF6B9C;stroke-width:1.1559;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st82{fill:url(#SVGID_4_);}\r\n\t.st83{opacity:0.2;}\r\n\t.st84{fill:url(#SVGID_5_);}\r\n\t.st85{fill:none;stroke:#64546D;stroke-width:2.2716;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st86{fill:url(#SVGID_6_);}\r\n\t.st87{opacity:0.3;fill:#FFFFFF;enable-background:new    ;}\r\n\t.st88{fill:url(#SVGID_7_);}\r\n\t.st89{opacity:0.15;}\r\n\t.st90{fill:url(#SVGID_8_);}\r\n\t.st91{fill:url(#SVGID_9_);}\r\n\t.st92{opacity:0.21;fill:#FFFFFF;enable-background:new    ;}\r\n\t.st93{fill:url(#SVGID_10_);}\r\n\t.st94{fill:url(#SVGID_11_);}\r\n\t.st95{fill:url(#SVGID_12_);}\r\n\t.st96{fill:none;}\r\n\t.st97{fill-rule:evenodd;clip-rule:evenodd;fill:#7FBF89;}\r\n\t.st98{display:none;}\r\n\t.st99{display:inline;fill-rule:evenodd;clip-rule:evenodd;fill:#E82828;}\r\n\t.st100{display:inline;}\r\n\t.st101{fill-rule:evenodd;clip-rule:evenodd;}\r\n\t.st102{fill:url(#SVGID_13_);}\r\n\t.st103{fill:#5DB06E;}\r\n\t.st104{opacity:0.3;fill:#93AD98;}\r\n\t.st105{opacity:0.4;fill:#5DB06E;}\r\n\t.st106{opacity:0.8;fill:#FFFFFF;}\r\n\t.st107{fill:url(#SVGID_14_);}\r\n\t.st108{fill:#BD0037;}\r\n\t.st109{fill:#DB4672;}\r\n\t.st110{opacity:0.5;fill:#DB517A;}\r\n\t.st111{opacity:0.4;fill:#D44470;}\r\n\t.st112{fill:url(#SVGID_15_);}\r\n\t.st113{fill:#FFA02B;}\r\n\t.st114{fill:#FFA12B;}\r\n\t.st115{opacity:0.3;fill:#FFBE6E;}\r\n\t.st116{opacity:0.72;}\r\n\t.st117{fill:none;stroke:#ED1C24;stroke-width:5;stroke-miterlimit:10;}\r\n\t.st118{fill:#023872;}\r\n\t.st119{fill:#4470C4;}\r\n\t.st120{display:none;fill:url(#path6737_1_);stroke:#002663;stroke-miterlimit:10;}\r\n\t.st121{fill:none;stroke:#002663;stroke-width:1.9;}\r\n\t.st122{fill-rule:evenodd;clip-rule:evenodd;fill:#002663;stroke:#002663;}\r\n\t.st123{fill:#002663;stroke:#002663;stroke-width:3;}\r\n\t.st124{fill:none;stroke:#002663;stroke-width:2.3534;stroke-linecap:round;}\r\n\t.st125{fill:none;stroke:#002663;stroke-width:2.075;stroke-linecap:round;stroke-miterlimit:4;}\r\n\t.st126{fill:none;stroke:#002663;stroke-width:1.25;}\r\n\t.st127{fill:none;stroke:#DB0020;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st128{fill:#DB0020;}\r\n\t.st129{opacity:0.76;}\r\n\t.st130{fill:none;stroke:#DB0020;stroke-miterlimit:10;stroke-dasharray:4;}\r\n\t.st131{opacity:0.7;}\r\n\t.st132{fill:#7FBF89;}\r\n")), /*#__PURE__*/React.createElement("image", {
    style: {
      display: "none",
      overflow: "visible"
    },
    width: 1366,
    height: 768,
    xlinkHref: "F3AD9F7B.jpg",
    transform: "matrix(1 0 0 1 -509.5394 -213.4674)"
  }), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M524.6,214.1h-77.8c-8.9,0-16.1-7.2-16.1-16.1v-88.1c0-8.9,7.2-16.1,16.1-16.1h77.8c8.9,0,16.1,7.2,16.1,16.1 V198C540.6,206.9,533.4,214.1,524.6,214.1z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M338.8,209.1h-2.2l-5.7-9.1v9.1h-2.2v-12.8h2.2l5.7,9.1v-9.1h2.2V209.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.4,209.2c-1.4,0-2.5-0.4-3.3-1.3c-0.8-0.9-1.3-2-1.3-3.4v-0.3c0-0.9,0.2-1.8,0.5-2.5c0.4-0.7,0.9-1.3,1.5-1.7 s1.4-0.6,2.2-0.6c1.3,0,2.3,0.4,3,1.2s1.1,2,1.1,3.5v0.9H343c0.1,0.8,0.3,1.4,0.8,1.9c0.5,0.5,1,0.7,1.7,0.7c1,0,1.8-0.4,2.4-1.2 l1.2,1.1c-0.4,0.6-0.9,1-1.5,1.3C346.9,209.1,346.2,209.2,345.4,209.2z M345.1,201.1c-0.6,0-1.1,0.2-1.4,0.6 c-0.4,0.4-0.6,1-0.7,1.7h4.1v-0.2c0-0.7-0.2-1.3-0.6-1.6S345.7,201.1,345.1,201.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.6,208.1c-0.6,0.7-1.5,1.1-2.7,1.1c-1,0-1.8-0.3-2.3-0.9c-0.5-0.6-0.8-1.5-0.8-2.6v-6.2h2.1v6.1 c0,1.2,0.5,1.8,1.5,1.8c1,0,1.7-0.4,2.1-1.1v-6.8h2.1v9.5h-2L356.6,208.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.6,197.2v2.3h1.7v1.6h-1.7v5.3c0,0.4,0.1,0.6,0.2,0.8c0.1,0.2,0.4,0.2,0.8,0.2c0.2,0,0.5,0,0.7-0.1v1.7 c-0.5,0.1-1,0.2-1.4,0.2c-1.6,0-2.5-0.9-2.5-2.7v-5.4h-1.6v-1.6h1.6v-2.3H363.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.8,201.5c-0.3,0-0.6-0.1-0.9-0.1c-1,0-1.6,0.4-2,1.1v6.5h-2.1v-9.5h2l0.1,1.1c0.5-0.8,1.2-1.2,2.1-1.2 c0.3,0,0.6,0,0.8,0.1L371.8,201.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.5,204.2c0-0.9,0.2-1.8,0.6-2.5s0.9-1.3,1.6-1.7s1.4-0.6,2.3-0.6c1.3,0,2.3,0.4,3.1,1.2c0.8,0.8,1.2,1.9,1.3,3.3 l0,0.5c0,0.9-0.2,1.8-0.5,2.5c-0.4,0.7-0.9,1.3-1.5,1.7c-0.7,0.4-1.4,0.6-2.3,0.6c-1.3,0-2.4-0.4-3.2-1.3s-1.2-2.1-1.2-3.6V204.2 z M374.6,204.4c0,1,0.2,1.7,0.6,2.3c0.4,0.6,1,0.8,1.7,0.8s1.3-0.3,1.7-0.8s0.6-1.4,0.6-2.5c0-1-0.2-1.7-0.6-2.3 c-0.4-0.6-1-0.8-1.7-0.8c-0.7,0-1.3,0.3-1.7,0.8S374.6,203.3,374.6,204.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.4,204.4c0,1.5-0.3,2.6-1,3.5c-0.7,0.9-1.6,1.3-2.7,1.3c-1,0-1.9-0.3-2.5-1v4.5h-2.1v-13.2h2l0.1,1 c0.6-0.8,1.5-1.1,2.6-1.1c1.2,0,2.1,0.4,2.7,1.3c0.7,0.9,1,2.1,1,3.6V204.4z M389.3,204.2c0-0.9-0.2-1.7-0.6-2.3 c-0.4-0.6-0.9-0.8-1.6-0.8c-0.9,0-1.5,0.4-1.9,1.1v4.2c0.4,0.7,1,1.1,1.9,1.1c0.7,0,1.2-0.3,1.6-0.8 C389.1,206.2,389.3,205.3,389.3,204.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.4,200.6c0.7-0.8,1.6-1.2,2.6-1.2c2,0,3.1,1.2,3.1,3.5v6.2H399v-6.1c0-0.7-0.1-1.1-0.4-1.4s-0.7-0.4-1.3-0.4 c-0.9,0-1.5,0.4-1.9,1.1v6.8h-2.1v-13.5h2.1V200.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.3,197.1c0-0.3,0.1-0.6,0.3-0.8s0.5-0.3,0.9-0.3s0.7,0.1,0.9,0.3s0.3,0.5,0.3,0.8c0,0.3-0.1,0.6-0.3,0.8 s-0.5,0.3-0.9,0.3s-0.7-0.1-0.9-0.3S403.3,197.4,403.3,197.1z M405.5,209.1h-2.1v-9.5h2.1V209.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.1,209.1H408v-13.5h2.1V209.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.8,206.5c0-0.4-0.2-0.7-0.5-0.9c-0.3-0.2-0.8-0.4-1.6-0.5s-1.3-0.3-1.8-0.6c-1.1-0.5-1.6-1.3-1.6-2.2 c0-0.8,0.3-1.5,1-2.1s1.6-0.8,2.6-0.8c1.1,0,2.1,0.3,2.8,0.8s1.1,1.3,1.1,2.2h-2.1c0-0.4-0.2-0.8-0.5-1s-0.7-0.4-1.2-0.4 c-0.5,0-0.9,0.1-1.1,0.3s-0.4,0.5-0.4,0.9c0,0.3,0.1,0.6,0.4,0.8s0.8,0.4,1.7,0.5s1.5,0.4,2,0.7c0.5,0.3,0.8,0.6,1.1,0.9 s0.3,0.8,0.3,1.3c0,0.9-0.4,1.5-1.1,2.1s-1.6,0.8-2.8,0.8c-0.8,0-1.5-0.1-2.1-0.4s-1.1-0.7-1.4-1.2s-0.5-1-0.5-1.6h2.1 c0,0.5,0.2,0.9,0.6,1.2c0.4,0.3,0.8,0.4,1.4,0.4c0.6,0,1-0.1,1.3-0.3S417.8,206.8,417.8,206.5z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M456.1,202.5h-5.3v3.9h6.1v1.8h-8.4v-12.8h8.3v1.8h-6.1v3.5h5.3V202.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458,203.4c0-0.9,0.2-1.8,0.6-2.5s0.9-1.3,1.6-1.7s1.4-0.6,2.3-0.6c1.3,0,2.3,0.4,3.1,1.2c0.8,0.8,1.2,1.9,1.3,3.3l0,0.5 c0,0.9-0.2,1.8-0.5,2.5c-0.4,0.7-0.9,1.3-1.5,1.7c-0.7,0.4-1.4,0.6-2.3,0.6c-1.3,0-2.4-0.4-3.2-1.3s-1.2-2.1-1.2-3.6V203.4z  M460.1,203.5c0,1,0.2,1.7,0.6,2.3c0.4,0.6,1,0.8,1.7,0.8s1.3-0.3,1.7-0.8s0.6-1.4,0.6-2.5c0-1-0.2-1.7-0.6-2.3 c-0.4-0.6-1-0.8-1.7-0.8c-0.7,0-1.3,0.3-1.7,0.8S460.1,202.4,460.1,203.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474,205.6c0-0.4-0.2-0.7-0.5-0.9c-0.3-0.2-0.8-0.4-1.6-0.5s-1.3-0.3-1.8-0.6c-1.1-0.5-1.6-1.3-1.6-2.2 c0-0.8,0.3-1.5,1-2.1s1.6-0.8,2.6-0.8c1.1,0,2.1,0.3,2.8,0.8s1.1,1.3,1.1,2.2h-2.1c0-0.4-0.2-0.8-0.5-1s-0.7-0.4-1.2-0.4 c-0.5,0-0.9,0.1-1.1,0.3s-0.4,0.5-0.4,0.9c0,0.3,0.1,0.6,0.4,0.8s0.8,0.4,1.7,0.5s1.5,0.4,2,0.7c0.5,0.3,0.8,0.6,1.1,0.9 s0.3,0.8,0.3,1.3c0,0.9-0.4,1.5-1.1,2.1s-1.6,0.8-2.8,0.8c-0.8,0-1.5-0.1-2.1-0.4s-1.1-0.7-1.4-1.2s-0.5-1-0.5-1.6h2.1 c0,0.5,0.2,0.9,0.6,1.2c0.4,0.3,0.8,0.4,1.4,0.4c0.6,0,1-0.1,1.3-0.3S474,206,474,205.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.9,196.2c0-0.3,0.1-0.6,0.3-0.8s0.5-0.3,0.9-0.3s0.7,0.1,0.9,0.3s0.3,0.5,0.3,0.8c0,0.3-0.1,0.6-0.3,0.8 s-0.5,0.3-0.9,0.3s-0.7-0.1-0.9-0.3S477.9,196.5,477.9,196.2z M480.2,208.2h-2.1v-9.5h2.1V208.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.5,198.7l0.1,1.1c0.7-0.8,1.6-1.3,2.8-1.3c2,0,3,1.1,3,3.4v6.3h-2.1V202c0-0.6-0.1-1.1-0.4-1.3s-0.7-0.4-1.3-0.4 c-0.9,0-1.5,0.4-1.9,1.2v6.8h-2.1v-9.5H484.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.1,203.4c0-0.9,0.2-1.8,0.6-2.5s0.9-1.3,1.6-1.7s1.4-0.6,2.3-0.6c1.3,0,2.3,0.4,3.1,1.2c0.8,0.8,1.2,1.9,1.3,3.3 l0,0.5c0,0.9-0.2,1.8-0.5,2.5c-0.4,0.7-0.9,1.3-1.5,1.7c-0.7,0.4-1.4,0.6-2.3,0.6c-1.3,0-2.4-0.4-3.2-1.3s-1.2-2.1-1.2-3.6V203.4 z M494.3,203.5c0,1,0.2,1.7,0.6,2.3c0.4,0.6,1,0.8,1.7,0.8s1.3-0.3,1.7-0.8s0.6-1.4,0.6-2.5c0-1-0.2-1.7-0.6-2.3 c-0.4-0.6-1-0.8-1.7-0.8c-0.7,0-1.3,0.3-1.7,0.8S494.3,202.4,494.3,203.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.1,203.5c0,1.5-0.3,2.6-1,3.5c-0.7,0.9-1.6,1.3-2.7,1.3c-1,0-1.9-0.3-2.5-1v4.5h-2.1v-13.2h2l0.1,1 c0.6-0.8,1.5-1.1,2.6-1.1c1.2,0,2.1,0.4,2.7,1.3c0.7,0.9,1,2.1,1,3.6V203.5z M509,203.4c0-0.9-0.2-1.7-0.6-2.3 c-0.4-0.6-0.9-0.8-1.6-0.8c-0.9,0-1.5,0.4-1.9,1.1v4.2c0.4,0.7,1,1.1,1.9,1.1c0.7,0,1.2-0.3,1.6-0.8 C508.8,205.3,509,204.5,509,203.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515,199.7c0.7-0.8,1.6-1.2,2.6-1.2c2,0,3.1,1.2,3.1,3.5v6.2h-2.1v-6.1c0-0.7-0.1-1.1-0.4-1.4s-0.7-0.4-1.3-0.4 c-0.9,0-1.5,0.4-1.9,1.1v6.8h-2.1v-13.5h2.1V199.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.9,196.2c0-0.3,0.1-0.6,0.3-0.8s0.5-0.3,0.9-0.3s0.7,0.1,0.9,0.3s0.3,0.5,0.3,0.8c0,0.3-0.1,0.6-0.3,0.8 s-0.5,0.3-0.9,0.3s-0.7-0.1-0.9-0.3S522.9,196.5,522.9,196.2z M525.2,208.2H523v-9.5h2.1V208.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.8,208.2h-2.1v-13.5h2.1V208.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.4,205.6c0-0.4-0.2-0.7-0.5-0.9c-0.3-0.2-0.8-0.4-1.6-0.5s-1.3-0.3-1.8-0.6c-1.1-0.5-1.6-1.3-1.6-2.2 c0-0.8,0.3-1.5,1-2.1s1.6-0.8,2.6-0.8c1.1,0,2.1,0.3,2.8,0.8s1.1,1.3,1.1,2.2h-2.1c0-0.4-0.2-0.8-0.5-1s-0.7-0.4-1.2-0.4 c-0.5,0-0.9,0.1-1.1,0.3s-0.4,0.5-0.4,0.9c0,0.3,0.1,0.6,0.4,0.8s0.8,0.4,1.7,0.5s1.5,0.4,2,0.7c0.5,0.3,0.8,0.6,1.1,0.9 s0.3,0.8,0.3,1.3c0,0.9-0.4,1.5-1.1,2.1s-1.6,0.8-2.8,0.8c-0.8,0-1.5-0.1-2.1-0.4s-1.1-0.7-1.4-1.2s-0.5-1-0.5-1.6h2.1 c0,0.5,0.2,0.9,0.6,1.2c0.4,0.3,0.8,0.4,1.4,0.4c0.6,0,1-0.1,1.3-0.3S537.4,206,537.4,205.6z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M25.5,194.5l3.7,9.8l3.7-9.8h2.9v12.8h-2.2v-4.2l0.2-5.6l-3.8,9.9h-1.6l-3.8-9.9l0.2,5.6v4.2h-2.2v-12.8H25.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8,207.3c-0.1-0.2-0.2-0.5-0.2-0.9c-0.7,0.7-1.5,1.1-2.5,1.1c-1,0-1.7-0.3-2.3-0.8s-0.9-1.2-0.9-2 c0-1,0.4-1.8,1.1-2.3s1.8-0.8,3.2-0.8h1.3v-0.6c0-0.5-0.1-0.9-0.4-1.2s-0.7-0.4-1.3-0.4c-0.5,0-0.9,0.1-1.2,0.4s-0.5,0.6-0.5,0.9 H38c0-0.5,0.2-1,0.5-1.5s0.8-0.8,1.4-1.1s1.3-0.4,2-0.4c1.1,0,2,0.3,2.7,0.8s1,1.3,1,2.4v4.3c0,0.9,0.1,1.5,0.4,2v0.1H43.8z  M41.5,205.8c0.4,0,0.8-0.1,1.2-0.3s0.7-0.5,0.8-0.8v-1.8h-1.2c-0.8,0-1.4,0.1-1.8,0.4S40,204,40,204.5c0,0.4,0.1,0.7,0.4,1 S41,205.8,41.5,205.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8,205.8c0.5,0,1-0.2,1.3-0.5s0.5-0.7,0.6-1.2h2c0,0.6-0.2,1.1-0.6,1.7s-0.8,0.9-1.4,1.2s-1.2,0.4-1.9,0.4 c-1.3,0-2.4-0.4-3.2-1.3s-1.2-2.1-1.2-3.6v-0.2c0-1.4,0.4-2.6,1.2-3.5s1.8-1.3,3.2-1.3c1.1,0,2.1,0.3,2.8,1s1.1,1.5,1.1,2.6h-2 c0-0.5-0.2-1-0.6-1.3s-0.8-0.5-1.3-0.5c-0.7,0-1.2,0.3-1.6,0.8s-0.6,1.3-0.6,2.3v0.3c0,1,0.2,1.8,0.6,2.3S51.1,205.8,51.8,205.8z "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3,199.8c-0.3,0-0.6-0.1-0.9-0.1c-1,0-1.6,0.4-2,1.1v6.5h-2.1v-9.5h2l0.1,1.1c0.5-0.8,1.2-1.2,2.1-1.2 c0.3,0,0.6,0,0.8,0.1L62.3,199.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9,202.5c0-0.9,0.2-1.8,0.6-2.5s0.9-1.3,1.6-1.7s1.4-0.6,2.3-0.6c1.3,0,2.3,0.4,3.1,1.2s1.2,1.9,1.3,3.3l0,0.5 c0,0.9-0.2,1.8-0.5,2.5s-0.9,1.3-1.5,1.7s-1.4,0.6-2.3,0.6c-1.3,0-2.4-0.4-3.2-1.3s-1.2-2.1-1.2-3.6V202.5z M65,202.7 c0,1,0.2,1.7,0.6,2.3s1,0.8,1.7,0.8s1.3-0.3,1.7-0.8s0.6-1.4,0.6-2.5c0-1-0.2-1.7-0.6-2.3s-1-0.8-1.7-0.8c-0.7,0-1.3,0.3-1.7,0.8 S65,201.6,65,202.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.9,202.7c0,1.5-0.3,2.6-1,3.5s-1.6,1.3-2.7,1.3c-1,0-1.9-0.3-2.5-1v4.5h-2.1v-13.2h2l0.1,1c0.6-0.8,1.5-1.1,2.6-1.1 c1.2,0,2.1,0.4,2.7,1.3s1,2.1,1,3.6V202.7z M79.8,202.5c0-0.9-0.2-1.7-0.6-2.3s-0.9-0.8-1.6-0.8c-0.9,0-1.5,0.4-1.9,1.1v4.2 c0.4,0.7,1,1.1,1.9,1.1c0.7,0,1.2-0.3,1.6-0.8S79.8,203.6,79.8,202.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.8,198.9c0.7-0.8,1.6-1.2,2.6-1.2c2,0,3.1,1.2,3.1,3.5v6.2h-2.1v-6.1c0-0.7-0.1-1.1-0.4-1.4s-0.7-0.4-1.3-0.4 c-0.9,0-1.5,0.4-1.9,1.1v6.8h-2.1v-13.5h2.1V198.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.4,207.3c-0.1-0.2-0.2-0.5-0.2-0.9c-0.7,0.7-1.5,1.1-2.5,1.1c-1,0-1.7-0.3-2.3-0.8s-0.9-1.2-0.9-2 c0-1,0.4-1.8,1.1-2.3s1.8-0.8,3.2-0.8h1.3v-0.6c0-0.5-0.1-0.9-0.4-1.2s-0.7-0.4-1.3-0.4c-0.5,0-0.9,0.1-1.2,0.4s-0.5,0.6-0.5,0.9 h-2.1c0-0.5,0.2-1,0.5-1.5s0.8-0.8,1.4-1.1s1.3-0.4,2-0.4c1.1,0,2,0.3,2.7,0.8s1,1.3,1,2.4v4.3c0,0.9,0.1,1.5,0.4,2v0.1H99.4z  M97,205.8c0.4,0,0.8-0.1,1.2-0.3s0.7-0.5,0.8-0.8v-1.8h-1.2c-0.8,0-1.4,0.1-1.8,0.4s-0.6,0.7-0.6,1.2c0,0.4,0.1,0.7,0.4,1 S96.6,205.8,97,205.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.1,202.5c0-1.5,0.3-2.7,1-3.5c0.7-0.9,1.6-1.3,2.8-1.3c1.1,0,1.9,0.4,2.6,1.1l0.1-1h1.9v9.2c0,1.2-0.4,2.2-1.2,3 c-0.8,0.7-1.8,1.1-3.1,1.1c-0.7,0-1.4-0.1-2-0.4c-0.7-0.3-1.2-0.7-1.5-1.1l1-1.3c0.7,0.8,1.5,1.2,2.4,1.2c0.7,0,1.3-0.2,1.7-0.6 s0.6-0.9,0.6-1.7v-0.6c-0.6,0.7-1.4,1-2.5,1c-1.1,0-2-0.4-2.7-1.3S103.1,204.1,103.1,202.5z M105.2,202.7c0,1,0.2,1.7,0.6,2.3 s0.9,0.8,1.6,0.8c0.9,0,1.5-0.4,1.9-1.1v-4.2c-0.4-0.7-1-1.1-1.9-1.1c-0.7,0-1.3,0.3-1.6,0.8S105.2,201.6,105.2,202.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.8,207.5c-1.4,0-2.5-0.4-3.3-1.3s-1.3-2-1.3-3.4v-0.3c0-0.9,0.2-1.8,0.5-2.5c0.4-0.7,0.9-1.3,1.5-1.7 s1.4-0.6,2.2-0.6c1.3,0,2.3,0.4,3,1.2s1.1,2,1.1,3.5v0.9h-6.2c0.1,0.8,0.3,1.4,0.8,1.9c0.5,0.5,1,0.7,1.7,0.7 c1,0,1.8-0.4,2.4-1.2l1.2,1.1c-0.4,0.6-0.9,1-1.5,1.3S118.6,207.5,117.8,207.5z M117.6,199.4c-0.6,0-1.1,0.2-1.4,0.6 c-0.4,0.4-0.6,1-0.7,1.7h4.1v-0.2c0-0.7-0.2-1.3-0.6-1.6S118.2,199.4,117.6,199.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.6,204.8c0-0.4-0.2-0.7-0.5-0.9c-0.3-0.2-0.8-0.4-1.6-0.5s-1.3-0.3-1.8-0.6c-1.1-0.5-1.6-1.3-1.6-2.2 c0-0.8,0.3-1.5,1-2.1s1.6-0.8,2.6-0.8c1.1,0,2.1,0.3,2.8,0.8s1.1,1.3,1.1,2.2h-2.1c0-0.4-0.2-0.8-0.5-1s-0.7-0.4-1.2-0.4 c-0.5,0-0.9,0.1-1.1,0.3s-0.4,0.5-0.4,0.9c0,0.3,0.1,0.6,0.4,0.8s0.8,0.4,1.7,0.5s1.5,0.4,2,0.7c0.5,0.3,0.8,0.6,1.1,0.9 s0.3,0.8,0.3,1.3c0,0.9-0.4,1.5-1.1,2.1s-1.6,0.8-2.8,0.8c-0.8,0-1.5-0.1-2.1-0.4s-1.1-0.7-1.4-1.2s-0.5-1-0.5-1.6h2.1 c0,0.5,0.2,0.9,0.6,1.2s0.8,0.4,1.4,0.4c0.6,0,1-0.1,1.3-0.3S128.6,205.1,128.6,204.8z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M156,207.3v-12.8h4.4c1.4,0,2.5,0.3,3.3,0.9s1.1,1.4,1.1,2.6c0,0.6-0.2,1.1-0.5,1.6s-0.8,0.8-1.4,1.1 c0.7,0.2,1.2,0.5,1.6,1.1c0.4,0.5,0.6,1.1,0.6,1.9c0,1.2-0.4,2.1-1.2,2.8c-0.8,0.6-1.9,1-3.3,1H156z M158.2,199.9h2.2 c0.7,0,1.2-0.2,1.6-0.5c0.4-0.3,0.6-0.8,0.6-1.3c0-0.6-0.2-1.1-0.5-1.4c-0.4-0.3-0.9-0.4-1.7-0.4h-2.2V199.9z M158.2,201.6v4h2.5 c0.7,0,1.2-0.2,1.6-0.5s0.6-0.8,0.6-1.4c0-1.3-0.7-2-2-2H158.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.5,205.8c0.5,0,1-0.2,1.3-0.5s0.5-0.7,0.6-1.2h2c0,0.6-0.2,1.1-0.6,1.7c-0.3,0.5-0.8,0.9-1.4,1.2s-1.2,0.4-1.9,0.4 c-1.3,0-2.4-0.4-3.2-1.3s-1.2-2.1-1.2-3.6v-0.2c0-1.4,0.4-2.6,1.2-3.5s1.8-1.3,3.2-1.3c1.1,0,2.1,0.3,2.8,1 c0.7,0.7,1.1,1.5,1.1,2.6h-2c0-0.5-0.2-1-0.6-1.3s-0.8-0.5-1.3-0.5c-0.7,0-1.2,0.3-1.6,0.8s-0.6,1.3-0.6,2.3v0.3 c0,1,0.2,1.8,0.6,2.3C174.3,205.6,174.8,205.8,175.5,205.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.2,207.5c-1.4,0-2.5-0.4-3.3-1.3c-0.8-0.9-1.3-2-1.3-3.4v-0.3c0-0.9,0.2-1.8,0.5-2.5c0.4-0.7,0.9-1.3,1.5-1.7 s1.4-0.6,2.2-0.6c1.3,0,2.3,0.4,3,1.2s1.1,2,1.1,3.5v0.9h-6.2c0.1,0.8,0.3,1.4,0.8,1.9c0.5,0.5,1,0.7,1.7,0.7 c1,0,1.8-0.4,2.4-1.2l1.2,1.1c-0.4,0.6-0.9,1-1.5,1.3C186.7,207.4,186,207.5,185.2,207.5z M185,199.4c-0.6,0-1.1,0.2-1.4,0.6 c-0.4,0.4-0.6,1-0.7,1.7h4.1v-0.2c0-0.7-0.2-1.3-0.6-1.6S185.5,199.4,185,199.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193,207.3h-2.1v-13.5h2.1V207.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.6,207.3h-2.1v-13.5h2.1V207.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.2,204.8c0-0.4-0.2-0.7-0.5-0.9c-0.3-0.2-0.8-0.4-1.6-0.5s-1.3-0.3-1.8-0.6c-1.1-0.5-1.6-1.3-1.6-2.2 c0-0.8,0.3-1.5,1-2.1s1.6-0.8,2.6-0.8c1.1,0,2.1,0.3,2.8,0.8s1.1,1.3,1.1,2.2h-2.1c0-0.4-0.2-0.8-0.5-1s-0.7-0.4-1.2-0.4 c-0.5,0-0.9,0.1-1.1,0.3s-0.4,0.5-0.4,0.9c0,0.3,0.1,0.6,0.4,0.8s0.8,0.4,1.7,0.5s1.5,0.4,2,0.7c0.5,0.3,0.8,0.6,1.1,0.9 s0.3,0.8,0.3,1.3c0,0.9-0.4,1.5-1.1,2.1c-0.7,0.5-1.6,0.8-2.8,0.8c-0.8,0-1.5-0.1-2.1-0.4s-1.1-0.7-1.4-1.2s-0.5-1-0.5-1.6h2.1 c0,0.5,0.2,0.9,0.6,1.2s0.8,0.4,1.4,0.4c0.6,0,1-0.1,1.3-0.3S205.2,205.1,205.2,204.8z"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M258,197.1h-4v11h-2.2v-11h-4v-1.8H258V197.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.3,206.6c0.5,0,1-0.2,1.3-0.5s0.5-0.7,0.6-1.2h2c0,0.6-0.2,1.1-0.6,1.7s-0.8,0.9-1.4,1.2s-1.2,0.4-1.9,0.4 c-1.3,0-2.4-0.4-3.2-1.3s-1.2-2.1-1.2-3.6v-0.2c0-1.4,0.4-2.6,1.2-3.5s1.8-1.3,3.2-1.3c1.1,0,2.1,0.3,2.8,1 c0.7,0.7,1.1,1.5,1.1,2.6h-2c0-0.5-0.2-1-0.6-1.3s-0.8-0.5-1.3-0.5c-0.7,0-1.2,0.3-1.6,0.8s-0.6,1.3-0.6,2.3v0.3 c0,1,0.2,1.8,0.6,2.3C266.1,206.3,266.6,206.6,267.3,206.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277,208.3c-1.4,0-2.5-0.4-3.3-1.3s-1.3-2-1.3-3.4v-0.3c0-0.9,0.2-1.8,0.5-2.5c0.4-0.7,0.9-1.3,1.5-1.7s1.4-0.6,2.2-0.6 c1.3,0,2.3,0.4,3,1.2s1.1,2,1.1,3.5v0.9h-6.2c0.1,0.8,0.3,1.4,0.8,1.9c0.5,0.5,1,0.7,1.7,0.7c1,0,1.8-0.4,2.4-1.2l1.2,1.1 c-0.4,0.6-0.9,1-1.5,1.3S277.8,208.3,277,208.3z M276.8,200.1c-0.6,0-1.1,0.2-1.4,0.6c-0.4,0.4-0.6,1-0.7,1.7h4.1v-0.2 c0-0.7-0.2-1.3-0.6-1.6S277.4,200.1,276.8,200.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.8,208.1h-2.1v-13.5h2.1V208.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.4,208.1h-2.1v-13.5h2.1V208.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297,205.5c0-0.4-0.2-0.7-0.5-0.9c-0.3-0.2-0.8-0.4-1.6-0.5s-1.3-0.3-1.8-0.6c-1.1-0.5-1.6-1.3-1.6-2.2 c0-0.8,0.3-1.5,1-2.1s1.6-0.8,2.6-0.8c1.1,0,2.1,0.3,2.8,0.8s1.1,1.3,1.1,2.2h-2.1c0-0.4-0.2-0.8-0.5-1s-0.7-0.4-1.2-0.4 c-0.5,0-0.9,0.1-1.1,0.3s-0.4,0.5-0.4,0.9c0,0.3,0.1,0.6,0.4,0.8s0.8,0.4,1.7,0.5s1.5,0.4,2,0.7c0.5,0.3,0.8,0.6,1.1,0.9 s0.3,0.8,0.3,1.3c0,0.9-0.4,1.5-1.1,2.1s-1.6,0.8-2.8,0.8c-0.8,0-1.5-0.1-2.1-0.4s-1.1-0.7-1.4-1.2s-0.5-1-0.5-1.6h2.1 c0,0.5,0.2,0.9,0.6,1.2s0.8,0.4,1.4,0.4c0.6,0,1-0.1,1.3-0.3S297,205.9,297,205.5z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-250.10011,-475.72543)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path24648",
    className: "st1",
    d: "M322.9,583c0.8,0.8,2.2,1.8,4.2,3c2.6,1.5,4.6,2.2,5.9,1.9l5.2-0.1c2.1-0.1,3.9,0.8,5.4,2.8 l2.7,4c1.5,2.1,3,3.5,4.5,4.3c1.1,0.6,2.2,1.6,3.3,3.1c1.2,1.6,1.6,3.1,1.4,4.3c-0.3,1.6-1.3,4.2-3,7.8c-1.4,2.9-2.1,5.7-2.1,8.4 l0.4,5.6c0,2.5-0.6,4.5-1.8,6l-4.9,5.4l-3.2,2.5c-2.1,1.3-4.7,1.8-7.8,1.3l-8.7-2l-6.2,0.3l-4.4,1c-2.2,0.2-3.8,0.3-4.7,0 c-1.2-0.3-2.1-1-2.7-2.3c-1.2-2.2-2.1-3.6-2.8-3.9c-1.1-0.6-3-0.4-5.7,0.8c-1.9,0.8-3.4,0.6-4.4-0.8c-0.9-1.1-1.2-2.5-1-4.3 c0.3-2.4-0.3-4.5-1.8-6.3l-4-3.4c-2.1-2-2.8-3.9-2.1-5.8c0.9-2.4,2.3-4.4,4.3-5.9c0.8-0.6,1.2-1.6,1.4-2.9 c0.1-1.3-0.1-2.4-0.7-3.5c-1.5-2.5-2.2-4.8-2.2-6.7c0-2.3,1.3-4.3,3.8-5.8c2.8-1.6,5.1-2.5,7-2.5l4.6,0.1c1.7,0,3.1-0.3,4.2-0.8 c0.8-0.4,2-1.8,3.4-4.1c1.3-2.1,3-3.4,5.1-3.8C318.3,580.2,320.7,580.9,322.9,583L322.9,583z M326.5,588.3c-1.8-1.1-3.1-2-3.8-2.7 c-1.6-1.5-3.3-2.2-5.2-2.2l-1.6,0.2c-1.9,0.4-3.5,1.5-4.7,3.5c-1.3,2.1-2.4,3.4-3.1,3.7c-1,0.5-2.2,0.7-3.8,0.7l-4.2-0.1 c-1.7,0-3.9,0.7-6.3,2.2c-2.3,1.4-3.4,3.2-3.5,5.3c0,1.8,0.6,3.8,2,6.2c0.5,0.9,0.8,1.9,0.7,3.1c-0.1,1.2-0.6,2-1.3,2.6 c-1.8,1.4-3.1,3.2-3.9,5.4c-0.2,0.4-0.3,0.8-0.2,1.3c0,1.3,0.7,2.7,2.2,4l3.6,3.1c1.3,1.6,1.9,3.5,1.6,5.7 c-0.2,1.6,0.1,2.9,0.9,3.9c0.9,1.2,2.3,1.4,4.1,0.7c2.5-1,4.2-1.3,5.2-0.7c0.6,0.3,1.5,1.5,2.6,3.6c0.6,1.1,1.4,1.8,2.5,2.1 c0.8,0.2,2.2,0.2,4.3,0l4-0.9l5.7-0.2l7.9,1.8l2.2,0.2c1.9,0,3.5-0.5,4.9-1.4l2.9-2.2l4.4-4.9c1.1-1.3,1.7-3.1,1.7-5.5 c-0.2-2.5-0.3-4.2-0.3-5.1c-0.1-2.4,0.6-5,1.9-7.6c1.5-3.3,2.4-5.6,2.7-7.1c0.2-1.1-0.3-2.5-1.3-4c-1-1.4-2-2.3-3-2.8 c-1.4-0.7-2.8-2-4.1-3.9l-2.4-3.7c-1.4-1.8-3-2.7-4.9-2.5l-4.7,0.1C330.6,590.3,328.8,589.7,326.5,588.3L326.5,588.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "path24650",
    className: "st2",
    d: "M322.6,585.5c0.7,0.7,2,1.7,3.8,2.7c2.4,1.4,4.2,2,5.4,1.8l4.7-0.1c1.9-0.1,3.5,0.7,4.9,2.5 l2.4,3.7c1.4,1.9,2.8,3.2,4.1,3.9c1,0.5,2.1,1.5,3,2.8c1,1.5,1.5,2.8,1.3,4c-0.3,1.5-1.2,3.8-2.7,7.1c-1.3,2.7-1.9,5.2-1.9,7.6 c0,0.9,0.1,2.6,0.3,5.1c0,2.3-0.6,4.2-1.7,5.5l-4.4,4.9l-2.9,2.2c-1.4,0.9-3.1,1.4-4.9,1.4l-2.2-0.2l-7.9-1.8l-5.7,0.2l-4,0.9 c-2.1,0.2-3.5,0.2-4.3,0c-1.1-0.2-1.9-0.9-2.5-2.1c-1.1-2.1-2-3.3-2.6-3.6c-1-0.6-2.8-0.3-5.2,0.7c-1.8,0.7-3.2,0.5-4.1-0.7 c-0.8-1-1.1-2.3-0.9-3.9c0.3-2.2-0.3-4.1-1.6-5.7l-3.6-3.1c-1.5-1.3-2.2-2.7-2.2-4c0-0.4,0-0.8,0.2-1.3c0.8-2.2,2.1-4,3.9-5.4 c0.7-0.6,1.2-1.4,1.3-2.6c0.1-1.2-0.1-2.2-0.7-3.1c-1.4-2.3-2.1-4.4-2-6.2c0-2.2,1.2-3.9,3.5-5.3c2.5-1.5,4.6-2.2,6.3-2.2l4.2,0.1 c1.6,0,2.9-0.2,3.8-0.7c0.8-0.4,1.8-1.6,3.1-3.7c1.2-1.9,2.8-3.1,4.7-3.5l1.6-0.2C319.4,583.3,321.1,584,322.6,585.5L322.6,585.5z "
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "path27292_1_",
    cx: 35672.3125,
    cy: -27907.252,
    r: 920.5331,
    gradientTransform: "matrix(1.322024e-02 0 0 -1.322024e-02 -144.188 251.7026)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7F00FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7333,
    style: {
      stopColor: "#7E00FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6A26AE"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "path27292",
    className: "st3",
    d: "M339.5,620.6c0,3.3-1.2,6.2-3.6,8.5c-2.4,2.4-5.2,3.6-8.6,3.6c-3.4,0-6.2-1.2-8.6-3.6 c-2.4-2.3-3.6-5.2-3.6-8.5c0-3.3,1.2-6.2,3.6-8.5c2.4-2.3,5.2-3.5,8.6-3.5c3.4,0,6.2,1.2,8.6,3.5 C338.4,614.5,339.5,617.3,339.5,620.6z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "path33122_1_",
    cx: 284.4075,
    cy: 1704.2441,
    r: 920.5327,
    gradientTransform: "matrix(9.399439e-04 0 0 -9.399439e-04 -144.0186 210.6443)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5412,
    style: {
      stopColor: "#F7F5F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D6CFDD",
      stopOpacity: 0
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "path33122",
    className: "st4",
    d: "M330.7,590.3c0.2,0.2,0.3,0.5,0.3,0.8l-0.3,0.7c-0.1,0.2-0.3,0.3-0.6,0.3s-0.4-0.1-0.6-0.3 c-0.1-0.2-0.2-0.4-0.2-0.7s0.1-0.6,0.2-0.8c0.2-0.2,0.4-0.3,0.6-0.3C330.4,590,330.6,590.1,330.7,590.3z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "path33124_1_",
    cx: 284.4075,
    cy: 1704.2441,
    r: 920.5327,
    gradientTransform: "matrix(1.855472e-03 0 0 -1.855472e-03 -143.7693 216.9431)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5412,
    style: {
      stopColor: "#F7F5F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D6CFDD",
      stopOpacity: 0
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "path33124",
    className: "st5",
    d: "M330.6,595.8c0.2-0.2,0.5-0.2,0.8,0.1c0.3,0.3,0.4,0.6,0.4,1c0,0.4-0.2,0.8-0.5,1.1 c-0.3,0.3-0.7,0.5-1.1,0.5c-0.4,0-1-0.1-1.6-0.4c-0.6-0.3-0.8-0.7-0.5-1.1c0.3-0.4,0.7-0.6,1.3-0.7L330.6,595.8z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "path33126_1_",
    cx: 284.4075,
    cy: 1704.2441,
    r: 920.5327,
    gradientTransform: "matrix(1.904296e-03 0 0 -1.904296e-03 -140.8003 213.4817)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2196,
    style: {
      stopColor: "#7B3EB8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5412,
    style: {
      stopColor: "#873FCF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B183E1",
      stopOpacity: 0.4431
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "path33126",
    className: "st6",
    d: "M334.8,591.6c0.3,0.4,0.5,0.9,0.5,1.4s-0.2,1-0.5,1.3c-0.3,0.4-0.7,0.6-1.2,0.6 c-0.5,0-0.9-0.2-1.2-0.6c-0.3-0.4-0.5-0.8-0.5-1.3s0.2-1,0.5-1.4c0.3-0.4,0.7-0.5,1.2-0.5C334,591,334.5,591.2,334.8,591.6z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "path33128_1_",
    cx: 284.4075,
    cy: 1704.2441,
    r: 920.5327,
    gradientTransform: "matrix(2.978512e-03 0 0 -2.978512e-03 -137.6417 217.6509)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5412,
    style: {
      stopColor: "#F7F5F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D6CFDD",
      stopOpacity: 0
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "path33128",
    className: "st7",
    d: "M335.4,594.7c0.4-0.4,0.9-0.6,1.5-0.6s1.1,0.2,1.5,0.6c0.4,0.4,0.6,0.9,0.6,1.5 c0,0.6-0.2,1-0.6,1.4c-0.4,0.4-0.9,0.6-1.5,0.6s-1.1-0.2-1.5-0.6c-0.4-0.4-0.6-0.9-0.6-1.4C334.8,595.6,335,595.1,335.4,594.7z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "path33130_1_",
    cx: 284.4075,
    cy: 1704.2441,
    r: 920.5327,
    gradientTransform: "matrix(-1.464840e-04 9.277359e-04 1.403808e-03 2.197264e-04 -154.3442 205.8641)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5412,
    style: {
      stopColor: "#F7F5F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D6CFDD",
      stopOpacity: 0
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "path33130",
    className: "st8",
    d: "M320.7,586.4l0.7,0.2c0.2,0.1,0.3,0.3,0.3,0.4l-0.3,0.4l-0.7,0.2l-0.8-0.2l-0.3-0.4 c0-0.2,0.1-0.3,0.3-0.4L320.7,586.4z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "path33132_1_",
    cx: 284.4075,
    cy: 1704.2441,
    r: 920.5327,
    gradientTransform: "matrix(1.000976e-03 8.544960e-04 1.232912e-03 -1.452640e-03 -157.247 211.1776)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2196,
    style: {
      stopColor: "#7B3EB8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5412,
    style: {
      stopColor: "#873FCF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B183E1",
      stopOpacity: 0.4431
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "path33132",
    className: "st9",
    d: "M318.5,590.6c-0.1,0.5-0.4,0.9-0.6,1.1l-1.2,0.7c-0.5,0.2-0.9,0.1-1.1-0.2 c-0.2-0.4-0.3-0.8-0.2-1.3c0.1-0.5,0.3-0.9,0.5-1.1c0.3-0.2,0.6-0.4,1.1-0.5l1.1,0.1C318.5,589.7,318.6,590,318.5,590.6z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "path33134_1_",
    cx: 284.4075,
    cy: 1704.2441,
    r: 920.5327,
    gradientTransform: "matrix(2.941896e-03 0 0 -2.941896e-03 -151.7684 218.967)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5412,
    style: {
      stopColor: "#F7F5F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D6CFDD",
      stopOpacity: 0
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "path33134",
    className: "st10",
    d: "M320.8,595.9c0.9,0.1,1.6,0.3,2.1,0.6c0.5,0.3,0.8,0.7,0.8,1.2c0,0.5-0.3,0.9-0.8,1.2 c-0.5,0.3-1.1,0.5-1.8,0.5c-0.7,0-1.3-0.2-1.8-0.5c-0.5-0.3-0.8-0.8-0.9-1.3c-0.1-0.5,0-1,0.5-1.3 C319.2,595.9,319.9,595.8,320.8,595.9L320.8,595.9z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "path33136_1_",
    cx: 284.4075,
    cy: 1704.2441,
    r: 920.5327,
    gradientTransform: "matrix(-1.220704e-05 1.342776e-03 2.233888e-03 2.441408e-05 -152.7956 211.9752)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5412,
    style: {
      stopColor: "#F7F5F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D6CFDD",
      stopOpacity: 0
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "path33136",
    className: "st11",
    d: "M320.4,593.4c-0.2-0.6-0.2-1.1-0.1-1.7c0.1-0.6,0.9-0.7,2.3-0.3l2.9,1 c0.6,0.3,0.9,0.7,0.9,1.1s-0.3,0.8-0.9,1.1c-0.5,0.3-1.2,0.5-2,0.5c-0.8,0-1.5-0.2-2-0.5C320.9,594.4,320.6,593.9,320.4,593.4 L320.4,593.4z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "path33138_1_",
    cx: 284.4075,
    cy: 1704.2441,
    r: 920.5327,
    gradientTransform: "matrix(1.135256e-03 0 0 -1.135256e-03 -148.3425 220.5987)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5412,
    style: {
      stopColor: "#F7F5F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D6CFDD",
      stopOpacity: 0
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "path33138",
    className: "st12",
    d: "M324.7,601.4c0.2-0.2,0.4-0.3,0.6-0.3c0.2,0,0.4,0.1,0.5,0.3l0.3,0.6l-0.3,0.6l-0.5,0.3 l-0.6-0.3l-0.2-0.6C324.4,601.8,324.5,601.5,324.7,601.4z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "path33140_1_",
    cx: 284.4075,
    cy: 1704.2441,
    r: 920.5327,
    gradientTransform: "matrix(-6.103512e-05 1.000976e-03 1.831056e-03 1.220704e-04 -158.0012 218.5148)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5412,
    style: {
      stopColor: "#F7F5F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D6CFDD",
      stopOpacity: 0
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "path33140",
    className: "st13",
    d: "M318.6,601.1l-0.4,0.4l-1.1,0.2l-1.1-0.2c-0.3-0.1-0.4-0.3-0.4-0.4c0-0.2,0.2-0.4,0.6-0.7 c0.4-0.3,0.7-0.4,1.1-0.3l1,0.4L318.6,601.1z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "path33142_1_",
    cx: 284.4075,
    cy: 1704.2441,
    r: 920.5327,
    gradientTransform: "matrix(1.220704e-04 1.525880e-03 2.856448e-03 -2.319336e-04 -156.998 223.1167)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5412,
    style: {
      stopColor: "#F7F5F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D6CFDD",
      stopOpacity: 0
    }
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "path33142",
    className: "st14",
    d: "M319.4,606.8l-1.9-0.1c-0.4-0.1-0.8-0.4-1-0.8c-0.2-0.4-0.1-0.9,0.5-1.5 c0.6-0.5,1.4-0.8,2.4-0.9c1-0.1,2,0.1,2.9,0.5c0.9,0.4,1.2,0.9,0.9,1.5c-0.3,0.6-0.8,1-1.5,1.1L319.4,606.8L319.4,606.8z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "path33144_1_",
    cx: 284.4075,
    cy: 1704.2441,
    r: 920.5327,
    gradientTransform: "matrix(2.441408e-05 1.171872e-03 1.525880e-03 -3.662112e-05 -142.3392 219.4169)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5412,
    style: {
      stopColor: "#F7F5F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D6CFDD",
      stopOpacity: 0
    }
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "path33144",
    className: "st15",
    d: "M335.5,601.9c0,0.2-0.1,0.4-0.4,0.5l-0.8,0.2l-0.9-0.2c-0.2-0.1-0.3-0.3-0.3-0.5 s0.1-0.4,0.3-0.5l0.9-0.2l0.8,0.2C335.3,601.5,335.5,601.7,335.5,601.9z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "path33146_1_",
    cx: 284.4075,
    cy: 1704.2441,
    r: 920.5327,
    gradientTransform: "matrix(8.300800e-04 0 0 -8.300800e-04 -145.6389 218.9125)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2196,
    style: {
      stopColor: "#7B3EB8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5412,
    style: {
      stopColor: "#873FCF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B183E1",
      stopOpacity: 0.4431
    }
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "path33146",
    className: "st16",
    d: "M328.7,600.1l0.4,0.6c0.2,0.2,0.1,0.4-0.2,0.6l-0.9,0c-0.3-0.2-0.4-0.3-0.3-0.5l0.2-0.4 l0-0.4c-0.1-0.2,0-0.2,0.3-0.2C328.4,599.9,328.6,600,328.7,600.1L328.7,600.1z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "path33148_1_",
    cx: 284.4075,
    cy: 1704.2441,
    r: 920.5327,
    gradientTransform: "matrix(1.318360e-03 0 0 -1.318360e-03 -145.4686 223.2985)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5412,
    style: {
      stopColor: "#F7F5F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D6CFDD",
      stopOpacity: 0
    }
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "path33148",
    className: "st17",
    d: "M329.4,604.8l-0.3,0.6l-0.7,0.3c-0.3,0-0.5-0.1-0.7-0.3c-0.2-0.2-0.3-0.4-0.3-0.6 s0.1-0.4,0.3-0.6c0.2-0.2,0.4-0.3,0.7-0.3l0.7,0.3L329.4,604.8z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "path33150_1_",
    cx: 284.4075,
    cy: 1704.2441,
    r: 920.5327,
    gradientTransform: "matrix(6.347655e-04 -1.220704e-03 -1.416016e-03 -7.446288e-04 -138.6956 224.7442)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2196,
    style: {
      stopColor: "#7B3EB8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5412,
    style: {
      stopColor: "#873FCF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B183E1",
      stopOpacity: 0.4431
    }
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "path33150",
    className: "st18",
    d: "M333.2,606c0.5-0.1,0.9,0.1,1.3,0.5c0.3,0.4,0.6,0.7,0.8,0.6l0.5,0.3l0,0.9l-0.9,0.1 l-1.2-0.7c-0.4-0.2-0.7-0.5-0.8-1C332.5,606.4,332.7,606.1,333.2,606z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "path33152_1_",
    cx: 284.4075,
    cy: 1704.2441,
    r: 920.5327,
    gradientTransform: "matrix(-4.882816e-05 1.245120e-03 2.502440e-03 1.098632e-04 -134.5247 215.6546)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5412,
    style: {
      stopColor: "#F7F5F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D6CFDD",
      stopOpacity: 0
    }
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "path33152",
    className: "st19",
    d: "M342.9,598.5c-0.4-0.2-0.6-0.4-0.6-0.7c0-0.3,0.2-0.5,0.6-0.7l1.5-0.3l1.4,0.3 c0.4,0.2,0.6,0.4,0.6,0.7c0,0.3-0.2,0.5-0.6,0.7l-1.4,0.3L342.9,598.5z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "path33154_1_",
    cx: 284.4075,
    cy: 1704.2441,
    r: 920.5327,
    gradientTransform: "matrix(3.222656e-03 0 0 -3.222656e-03 -134.4365 226.2239)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5412,
    style: {
      stopColor: "#F7F5F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D6CFDD",
      stopOpacity: 0
    }
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "path33154",
    className: "st20",
    d: "M337.9,603.1l2.4-0.3c0.8,0.1,1.6,0.5,2.2,1.2c0.7,0.7,1,1.3,1.1,1.8 c0.1,0.5-0.3,1.1-0.9,1.6c-0.7,0.5-1.5,0.8-2.3,0.8s-1.5-0.3-2.1-0.8c-0.6-0.5-1-1.3-1.2-2.3C336.9,604,337.1,603.3,337.9,603.1 L337.9,603.1z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "path33156_1_",
    cx: 284.4075,
    cy: 1704.2441,
    r: 920.5327,
    gradientTransform: "matrix(3.540040e-04 2.441408e-05 3.662112e-05 -5.371096e-04 -130.1709 220.2054)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7B3EB8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B183E1",
      stopOpacity: 0
    }
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "path33156",
    className: "st21",
    d: "M346.2,600.8c0.3-0.1,0.5,0,0.6,0.2l0.5,1.5c0.3,0.8,0.1,1.2-0.4,1.1l-1.8,0.1 c-0.6,0.1-0.7,0-0.3-0.5c0.4-0.5,0.5-1,0.3-1.3c-0.2-0.4-0.2-0.6,0.2-0.8L346.2,600.8L346.2,600.8z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "path33158_1_",
    cx: 284.4075,
    cy: 1704.2441,
    r: 920.5327,
    gradientTransform: "matrix(2.539064e-03 0 0 -2.539064e-03 -126.2429 225.5635)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5412,
    style: {
      stopColor: "#F7F5F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D6CFDD",
      stopOpacity: 0
    }
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "path33158",
    className: "st22",
    d: "M348.3,604.2l1.5-0.3c0.4,0,0.8,0.2,1.1,0.5c0.3,0.4,0.4,0.8,0.4,1.3c0,0.5-0.1,0.9-0.4,1.3 c-0.3,0.4-0.7,0.5-1.1,0.5s-0.9-0.2-1.4-0.7c-0.5-0.4-0.8-0.9-0.9-1.5C347.4,604.8,347.7,604.4,348.3,604.2z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "path33160_1_",
    cx: 284.4075,
    cy: 1704.2441,
    r: 920.5327,
    gradientTransform: "matrix(1.220704e-03 0 0 -1.220704e-03 -172.9266 214.5413)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5412,
    style: {
      stopColor: "#F7F5F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D6CFDD",
      stopOpacity: 0
    }
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "path33160",
    className: "st23",
    d: "M296.8,595.1c0-0.2,0.1-0.4,0.2-0.6c0.2-0.1,0.4-0.2,0.6-0.2l0.5,0.2l0.3,0.6l-0.3,0.6 c-0.1,0.2-0.3,0.3-0.5,0.3c-0.2,0-0.4-0.1-0.6-0.3L296.8,595.1z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "path33162_1_",
    cx: 284.4075,
    cy: 1704.2441,
    r: 920.5327,
    gradientTransform: "matrix(1.660160e-03 0 0 -1.660160e-03 -175.4054 219.5487)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5412,
    style: {
      stopColor: "#F7F5F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D6CFDD",
      stopOpacity: 0
    }
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "path33162",
    className: "st24",
    d: "M295.9,601.3c-0.3,0.3-0.7,0.5-1.2,0.5c-0.5,0-0.9-0.2-1.3-0.5c-0.3-0.3-0.5-0.7-0.5-1.2 s0.2-0.8,0.5-1.2c0.4-0.3,0.8-0.5,1.3-0.5s0.9,0.2,1.2,0.5c0.4,0.3,0.5,0.7,0.5,1.2S296.3,600.9,295.9,601.3z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "path33164_1_",
    cx: 284.4075,
    cy: 1704.2441,
    r: 920.5327,
    gradientTransform: "matrix(7.568359e-04 0 0 -7.568359e-04 -179.0124 220.6246)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2196,
    style: {
      stopColor: "#7B3EB8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5412,
    style: {
      stopColor: "#873FCF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B183E1",
      stopOpacity: 0.4431
    }
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "path33164",
    className: "st25",
    d: "M290.9,603.2l-0.6-0.2l-0.2-0.4l0.2-0.5l0.7-0.2l1,0.3c0.4,0.1,0.4,0.3,0.2,0.4l-0.7,0.4 L290.9,603.2L290.9,603.2z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "path33166_1_",
    cx: 284.4075,
    cy: 1704.2441,
    r: 920.5327,
    gradientTransform: "matrix(2.343752e-03 0 0 -2.343752e-03 -174.039 226.0491)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5412,
    style: {
      stopColor: "#F7F5F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D6CFDD",
      stopOpacity: 0
    }
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "path33166",
    className: "st26",
    d: "M294.5,605c0.4-0.4,1-0.6,1.6-0.6c0.6,0,1.1,0.2,1.5,0.6c0.4,0.4,0.7,0.9,0.9,1.5 c0.1,0.6,0,1.1-0.4,1.6l-1.8,1.1c-0.9,0.3-1.5,0.1-1.8-0.7c-0.4-0.7-0.5-1.4-0.5-2C293.9,606,294.1,605.5,294.5,605L294.5,605z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "path33168_1_",
    cx: 284.4075,
    cy: 1704.2441,
    r: 920.5327,
    gradientTransform: "matrix(-1.953128e-04 1.086424e-03 1.550296e-03 2.685544e-04 -173.1291 220.1948)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2196,
    style: {
      stopColor: "#7B3EB8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5412,
    style: {
      stopColor: "#873FCF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B183E1",
      stopOpacity: 0.4431
    }
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "path33168",
    className: "st27",
    d: "M298.7,602.4c0.3-0.2,0.7-0.3,1.1-0.3s0.8,0.1,1,0.3l0.6,0.9c0.1,0.3,0.1,0.6,0,0.9 c-0.1,0.3-0.6,0.4-1.3,0.3c-0.7-0.1-1.2-0.3-1.5-0.5c-0.3-0.2-0.4-0.5-0.4-0.8S298.4,602.6,298.7,602.4L298.7,602.4z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "path33170_1_",
    cx: 284.4075,
    cy: 1704.2441,
    r: 920.5327,
    gradientTransform: "matrix(1.953128e-03 0 0 -1.953128e-03 -157.9512 207.6203)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5412,
    style: {
      stopColor: "#F7F5F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D6CFDD",
      stopOpacity: 0
    }
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "path33170",
    className: "st28",
    d: "M315.3,587.3c-0.3,0.3-0.6,0.4-1,0.4c-0.4,0-0.7-0.1-1-0.4c-0.3-0.3-0.4-0.6-0.4-1 s0.1-0.7,0.4-1c0.3-0.3,0.6-0.4,1-0.4c0.4,0,0.7,0.1,1,0.4c0.3,0.3,0.4,0.6,0.4,1C315.7,586.7,315.5,587,315.3,587.3z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "path33172_1_",
    cx: 284.4075,
    cy: 1704.2441,
    r: 920.5327,
    gradientTransform: "matrix(9.399439e-04 0 0 -9.399439e-04 -162.0585 209.0843)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2196,
    style: {
      stopColor: "#7B3EB8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5412,
    style: {
      stopColor: "#873FCF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B183E1",
      stopOpacity: 0.4431
    }
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "path33172",
    className: "st29",
    d: "M308.8,589.3c0-0.3,0.1-0.5,0.3-0.7c0.2-0.2,0.5-0.3,0.8-0.3c0.3,0,0.5,0.1,0.7,0.3l0.3,0.7 l-0.3,0.7c-0.2,0.2-0.4,0.3-0.7,0.3c-0.3,0-0.6-0.1-0.8-0.3C308.9,589.8,308.8,589.6,308.8,589.3z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "path33174_1_",
    cx: 284.4075,
    cy: 1704.2441,
    r: 920.5327,
    gradientTransform: "matrix(1.464840e-03 0 0 -1.464840e-03 -159.3615 212.3143)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5412,
    style: {
      stopColor: "#F7F5F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D6CFDD",
      stopOpacity: 0
    }
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "path33174",
    className: "st30",
    d: "M311.8,592.2c0-0.2,0.1-0.4,0.3-0.6c0.2-0.1,0.5-0.2,0.8-0.2l0.7,0.2 c0.2,0.2,0.3,0.4,0.3,0.6l-0.3,0.6c-0.2,0.2-0.4,0.3-0.7,0.3l-0.8-0.3C311.9,592.7,311.8,592.5,311.8,592.2z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "path33176_1_",
    cx: 284.4075,
    cy: 1704.2441,
    r: 920.5327,
    gradientTransform: "matrix(1.062008e-03 0 0 -1.062008e-03 -157.356 214.5108)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5412,
    style: {
      stopColor: "#F7F5F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D6CFDD",
      stopOpacity: 0
    }
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "path33176",
    className: "st31",
    d: "M314.6,594.8l0.6-0.2l0.5,0.2l0.3,0.5l-0.3,0.4l-0.5,0.2c-0.2,0-0.4-0.1-0.6-0.2l-0.2-0.4 C314.3,595.1,314.4,594.9,314.6,594.8z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "path33178_1_",
    cx: 284.4075,
    cy: 1704.2441,
    r: 920.5327,
    gradientTransform: "matrix(8.789040e-04 0 0 -8.789040e-04 -171.1898 211.4111)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2196,
    style: {
      stopColor: "#7B3EB8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5412,
    style: {
      stopColor: "#873FCF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B183E1",
      stopOpacity: 0.4431
    }
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "path33178",
    className: "st32",
    d: "M300.2,592l-0.2,0.4l-0.4,0.2c-0.1,0-0.3-0.1-0.4-0.2L299,592l0.2-0.4 c0.1-0.1,0.3-0.2,0.4-0.2l0.4,0.2L300.2,592z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "path33180_1_",
    cx: 284.4075,
    cy: 1704.2441,
    r: 920.5327,
    gradientTransform: "matrix(1.171872e-03 0 0 -1.171872e-03 -168.8157 214.6827)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5412,
    style: {
      stopColor: "#F7F5F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D6CFDD",
      stopOpacity: 0
    }
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "path33180",
    className: "st33",
    d: "M302.2,594.7l0.5,0.2l0.3,0.4l-0.3,0.4l-0.5,0.2l-0.6-0.2l-0.2-0.4l0.2-0.4L302.2,594.7z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "path33182_1_",
    cx: 284.4075,
    cy: 1704.2441,
    r: 920.5327,
    gradientTransform: "matrix(0 1.708984e-03 2.539064e-03 0 -168.5196 211.1122)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5412,
    style: {
      stopColor: "#F7F5F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D6CFDD",
      stopOpacity: 0
    }
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "path33182",
    className: "st34",
    d: "M307.5,591.7l0.7,0.9c0.1,0.3,0,0.6-0.2,0.9l-1.4,0.2c-0.7-0.1-1.3-0.3-1.7-0.5 c-0.3-0.2-0.5-0.4-0.5-0.7s0.2-0.6,0.5-0.8c0.4-0.2,0.8-0.3,1.3-0.3C306.7,591.5,307.2,591.6,307.5,591.7L307.5,591.7z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "path33184_1_",
    cx: 284.4075,
    cy: 1704.2441,
    r: 920.5327,
    gradientTransform: "matrix(-2.441408e-05 7.446288e-04 1.306152e-03 3.662112e-05 -167.2444 214.81)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5412,
    style: {
      stopColor: "#F7F5F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D6CFDD",
      stopOpacity: 0
    }
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "path33184",
    className: "st35",
    d: "M306,597.9c-0.4,0-0.8-0.1-1.1-0.4l-0.5-0.7c0-0.1,0.1-0.3,0.4-0.4l1.1-0.2l1.1,0.2l0.5,0.4 l-0.4,0.6C306.8,597.8,306.4,597.9,306,597.9L306,597.9z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "path33186_1_",
    cx: 284.4075,
    cy: 1704.2441,
    r: 920.5327,
    gradientTransform: "matrix(8.300800e-04 0 0 -8.300800e-04 -163.6789 217.1925)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2196,
    style: {
      stopColor: "#7B3EB8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5412,
    style: {
      stopColor: "#873FCF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B183E1",
      stopOpacity: 0.4431
    }
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "path33186",
    className: "st36",
    d: "M307.7,598.3l0.4-0.1l0.5,0.1c0.2,0,0.4,0.1,0.5,0.2l0.2,0.5c0,0.2-0.2,0.2-0.7,0.1l-0.9-0.4 l-0.2-0.2L307.7,598.3L307.7,598.3z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "path33188_1_",
    cx: 284.4075,
    cy: 1704.2441,
    r: 920.5327,
    gradientTransform: "matrix(2.685544e-03 0 0 -2.685544e-03 -164.0558 222.9393)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5412,
    style: {
      stopColor: "#F7F5F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D6CFDD",
      stopOpacity: 0
    }
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "path33188",
    className: "st37",
    d: "M307.4,600.6c0.5,0,0.9,0.2,1.3,0.5c0.4,0.4,0.5,0.8,0.5,1.3c0,0.5-0.2,0.9-0.5,1.3 c-0.3,0.4-0.7,0.5-1.2,0.4c-0.5-0.1-0.9-0.4-1.1-0.9l-0.6-1.1c-0.1-0.3,0-0.6,0.3-0.9C306.4,600.8,306.9,600.6,307.4,600.6 L307.4,600.6z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "path33190_1_",
    cx: 284.4075,
    cy: 1704.2441,
    r: 920.5327,
    gradientTransform: "matrix(-2.075192e-04 1.306152e-03 2.233888e-03 3.662112e-04 -172.4717 217.1982)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5412,
    style: {
      stopColor: "#F7F5F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D6CFDD",
      stopOpacity: 0
    }
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "path33190",
    className: "st38",
    d: "M303.1,599c0.5,0.2,0.7,0.5,0.7,0.9c0,0.4-0.2,0.7-0.6,1.2c-0.4,0.4-0.9,0.5-1.7,0.4 c-0.7-0.1-1.3-0.3-1.8-0.6c-0.5-0.3-0.7-0.6-0.7-1c0-0.4,0.2-0.7,0.7-0.9c0.5-0.2,1-0.4,1.7-0.4S302.6,598.8,303.1,599z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "path33192_1_",
    cx: 284.4075,
    cy: 1704.2441,
    r: 920.5327,
    gradientTransform: "matrix(5.004880e-04 1.220704e-03 1.403808e-03 -5.737304e-04 -169.1446 222.8705)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5412,
    style: {
      stopColor: "#F7F5F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D6CFDD",
      stopOpacity: 0
    }
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "path33192",
    className: "st39",
    d: "M302.6,605c0-0.3,0.1-0.5,0.4-0.7l0.9-0.3c0.4,0,0.7,0.1,0.9,0.3l0.4,0.7l-0.4,0.7 c-0.3,0.2-0.6,0.3-0.9,0.3c-0.4,0-0.7-0.1-0.9-0.3C302.7,605.5,302.6,605.3,302.6,605z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "path33194_1_",
    cx: 284.4075,
    cy: 1704.2441,
    r: 920.5327,
    gradientTransform: "matrix(-9.765600e-05 1.672360e-03 2.771000e-03 1.586912e-04 -163.856 216.475)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5412,
    style: {
      stopColor: "#F7F5F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D6CFDD",
      stopOpacity: 0
    }
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "path33194",
    className: "st40",
    d: "M313.8,598.8c0,0.3-0.2,0.6-0.6,0.9l-1.4,0.4c-0.5,0-1-0.1-1.4-0.4c-0.4-0.2-0.6-0.5-0.6-0.9 c0-0.3,0.2-0.6,0.6-0.9c0.4-0.2,0.9-0.4,1.4-0.4l1.4,0.4C313.6,598.1,313.8,598.4,313.8,598.8z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "path33196_1_",
    cx: 284.4075,
    cy: 1704.2441,
    r: 920.5327,
    gradientTransform: "matrix(1.855472e-03 0 0 -1.855472e-03 -159.2493 222.3831)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5412,
    style: {
      stopColor: "#F7F5F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D6CFDD",
      stopOpacity: 0
    }
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "path33196",
    className: "st41",
    d: "M312,602.1c0.2-0.2,0.5-0.4,0.9-0.4s0.6,0.1,0.9,0.4c0.2,0.3,0.4,0.6,0.4,0.9 c0,0.4-0.1,0.7-0.4,0.9c-0.2,0.3-0.5,0.4-0.9,0.4s-0.6-0.1-0.9-0.4c-0.2-0.2-0.4-0.5-0.4-0.9C311.6,602.7,311.8,602.3,312,602.1z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "path33198_1_",
    cx: 284.4075,
    cy: 1704.2441,
    r: 920.5327,
    gradientTransform: "matrix(2.075192e-04 2.514648e-03 3.393552e-03 -2.685544e-04 -165.5067 225.7035)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5412,
    style: {
      stopColor: "#F7F5F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D6CFDD",
      stopOpacity: 0
    }
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "path33198",
    className: "st42",
    d: "M310.5,605.8l1.8,1.2l0.9,1.4c0.2,0.5,0.1,1-0.4,1.4c-0.4,0.4-1,0.6-1.9,0.5 c-0.9-0.1-1.6-0.5-2.2-1.3l-0.9-1.3c-0.1-0.1,0.2-0.5,0.7-1.3C309.1,605.6,309.8,605.4,310.5,605.8L310.5,605.8z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "path33200_1_",
    cx: 284.4075,
    cy: 1704.2441,
    r: 920.5327,
    gradientTransform: "matrix(2.294920e-03 0 0 -2.294920e-03 -155.688 229.5105)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5412,
    style: {
      stopColor: "#F7F5F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D6CFDD",
      stopOpacity: 0
    }
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "path33200",
    className: "st43",
    d: "M316.8,608.9c0.4,0,0.8,0.1,1.1,0.4c0.3,0.3,0.5,0.7,0.5,1.1c0,0.4-0.2,0.8-0.5,1.1 c-0.3,0.3-0.7,0.4-1.1,0.4c-0.4,0-0.8-0.1-1.2-0.4c-0.3-0.3-0.4-0.7-0.4-1.1c0-0.4,0.1-0.8,0.4-1.1 C315.9,609.1,316.3,608.9,316.8,608.9z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "path33202_1_",
    cx: 284.4075,
    cy: 1704.2441,
    r: 920.5327,
    gradientTransform: "matrix(6.835936e-04 2.343752e-03 2.807616e-03 -8.178720e-04 -164.5555 231.4112)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5412,
    style: {
      stopColor: "#F7F5F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D6CFDD",
      stopOpacity: 0
    }
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "path33202",
    className: "st44",
    d: "M310.9,612.2c0.7,0.1,1.3,0.3,1.8,0.6c0.5,0.3,0.8,0.7,0.8,1.2c0,0.5-0.3,0.9-0.8,1.2 c-0.5,0.3-1.1,0.5-1.8,0.5s-1.3-0.2-1.8-0.5c-0.5-0.3-0.8-0.9-0.9-1.8c-0.1-0.8,0.1-1.3,0.7-1.3L310.9,612.2L310.9,612.2z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "path33204_1_",
    cx: 284.4075,
    cy: 1704.2441,
    r: 920.5327,
    gradientTransform: "matrix(1.391600e-03 0 0 -1.391600e-03 -160.815 235.3064)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5412,
    style: {
      stopColor: "#F7F5F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D6CFDD",
      stopOpacity: 0
    }
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "path33204",
    className: "st45",
    d: "M310.4,617.5c0.2-0.2,0.5-0.3,0.8-0.3c0.3,0,0.6,0.1,0.8,0.3c0.2,0.2,0.4,0.4,0.4,0.6 c0,0.2-0.1,0.4-0.4,0.6c-0.2,0.2-0.5,0.3-0.8,0.3l-0.8-0.3c-0.2-0.2-0.3-0.4-0.3-0.6C310.1,617.9,310.2,617.7,310.4,617.5z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "path33206_1_",
    cx: 284.4075,
    cy: 1704.2441,
    r: 920.5327,
    gradientTransform: "matrix(5.004880e-04 0 0 -5.004880e-04 -165.6598 225.9169)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2196,
    style: {
      stopColor: "#7B3EB8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5412,
    style: {
      stopColor: "#873FCF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B183E1",
      stopOpacity: 0.4431
    }
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "path33206",
    className: "st46",
    d: "M306.4,608.8l-0.1,0.3l-0.3,0.1l-0.3-0.1l-0.1-0.3c0-0.1,0-0.2,0.1-0.3 c0.1-0.1,0.2-0.1,0.3-0.1c0.1,0,0.2,0,0.3,0.1L306.4,608.8z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "path33208_1_",
    cx: 284.4075,
    cy: 1704.2441,
    r: 920.5327,
    gradientTransform: "matrix(1.232912e-03 0 0 -1.232912e-03 -165.7244 230.4759)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5412,
    style: {
      stopColor: "#F7F5F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D6CFDD",
      stopOpacity: 0
    }
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "path33208",
    className: "st47",
    d: "M305.1,612.2c0.2-0.2,0.4-0.3,0.6-0.3c0.2,0,0.4,0.1,0.5,0.3l0.3,0.8l-0.3,0.7 c-0.1,0.2-0.3,0.3-0.5,0.3c-0.2,0-0.4-0.1-0.6-0.3c-0.1-0.2-0.2-0.4-0.2-0.7C304.9,612.7,305,612.4,305.1,612.2L305.1,612.2z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "path33210_1_",
    cx: 284.4075,
    cy: 1704.2441,
    r: 920.5327,
    gradientTransform: "matrix(1.940920e-03 0 0 -1.940920e-03 -169.0335 229.6857)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5412,
    style: {
      stopColor: "#F7F5F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D6CFDD",
      stopOpacity: 0
    }
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "path33210",
    className: "st48",
    d: "M303.3,609.8c0.4,0.4,0.6,0.8,0.6,1.3s-0.2,0.9-0.6,1.3c-0.4,0.4-0.9,0.6-1.5,0.6 c-0.6,0-1.1-0.2-1.5-0.6c-0.4-0.4-0.6-0.8-0.6-1.3c0-0.5,0.2-1,0.6-1.3c0.4-0.4,0.9-0.5,1.5-0.5 C302.4,609.2,302.9,609.4,303.3,609.8z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "path33212_1_",
    cx: 284.4075,
    cy: 1704.2441,
    r: 920.5327,
    gradientTransform: "matrix(4.516600e-04 0 0 -4.516600e-04 -168.6288 231.2983)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2196,
    style: {
      stopColor: "#7B3EB8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5412,
    style: {
      stopColor: "#873FCF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B183E1",
      stopOpacity: 0.4431
    }
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "path33212",
    className: "st49",
    d: "M303.2,614.9l-0.2,0.4l-0.4,0.2c-0.2,0-0.3-0.1-0.4-0.2l-0.2-0.4l0.2-0.4 c0.1-0.1,0.3-0.2,0.4-0.2l0.4,0.2L303.2,614.9z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "path33214_1_",
    cx: 284.4075,
    cy: 1704.2441,
    r: 920.5327,
    gradientTransform: "matrix(1.428224e-03 0 0 -1.428224e-03 -164.3683 235.5503)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5412,
    style: {
      stopColor: "#F7F5F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D6CFDD",
      stopOpacity: 0
    }
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "path33214",
    className: "st50",
    d: "M308.2,617c0.3,0.4,0.4,0.9,0.4,1.4s-0.1,1-0.4,1.4l-1,0.6c-0.4,0-0.8-0.2-1.1-0.6 c-0.3-0.4-0.4-0.9-0.4-1.4c0-0.6,0.1-1,0.4-1.4c0.3-0.4,0.7-0.6,1.1-0.6S307.9,616.6,308.2,617z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "path33216_1_",
    cx: 284.4075,
    cy: 1704.2441,
    r: 920.5327,
    gradientTransform: "matrix(1.428224e-03 0 0 -2.294920e-03 -165.0883 240.9105)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2196,
    style: {
      stopColor: "#7B3EB8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5412,
    style: {
      stopColor: "#873FCF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B183E1",
      stopOpacity: 0.4431
    }
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "path33216",
    className: "st51",
    d: "M305.3,621.8c0.3-0.4,0.7-0.6,1.1-0.6c0.4,0,0.8,0.2,1,0.6c0.3,0.4,0.4,0.9,0.4,1.5 c0,0.6-0.1,1.1-0.4,1.5c-0.3,0.4-0.6,0.6-1,0.6c-0.4,0-0.8-0.2-1.1-0.6c-0.3-0.4-0.4-0.9-0.4-1.5 C304.9,622.7,305,622.2,305.3,621.8z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "path33218_1_",
    cx: 284.4075,
    cy: 1704.2441,
    r: 920.5327,
    gradientTransform: "matrix(1.342776e-03 0 0 -1.342776e-03 -169.5441 236.2878)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5412,
    style: {
      stopColor: "#F7F5F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D6CFDD",
      stopOpacity: 0
    }
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "path33218",
    className: "st52",
    d: "M302.6,619.3c0,0.2-0.1,0.4-0.4,0.6l-0.9,0.3l-0.9-0.3c-0.2-0.1-0.4-0.3-0.4-0.6 c0-0.2,0.1-0.4,0.4-0.6l0.9-0.2l0.9,0.2C302.5,618.9,302.6,619.1,302.6,619.3z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "path33220_1_",
    cx: 284.4075,
    cy: 1704.2441,
    r: 920.5327,
    gradientTransform: "matrix(1.232912e-03 0 0 -1.232912e-03 -168.9644 240.7959)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5412,
    style: {
      stopColor: "#F7F5F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D6CFDD",
      stopOpacity: 0
    }
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "path33220",
    className: "st53",
    d: "M302.7,623.9c0.2,0.2,0.3,0.4,0.3,0.6l-0.3,0.6l-0.7,0.3l-0.7-0.3c-0.2-0.2-0.3-0.4-0.3-0.6 c0-0.2,0.1-0.4,0.3-0.6c0.2-0.2,0.4-0.3,0.7-0.3S302.6,623.7,302.7,623.9z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "path33222_1_",
    cx: 284.4075,
    cy: 1704.2441,
    r: 920.5327,
    gradientTransform: "matrix(7.446288e-04 0 0 -7.446288e-04 -168.6947 242.8899)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2196,
    style: {
      stopColor: "#7B3EB8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5412,
    style: {
      stopColor: "#873FCF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B183E1",
      stopOpacity: 0.4431
    }
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "path33222",
    className: "st54",
    d: "M302.9,628l-0.4,0.2c-0.1,0-0.3-0.1-0.4-0.2l-0.2-0.4l0.2-0.4l0.4-0.2l0.4,0.2l0.2,0.4 L302.9,628z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "path33224_1_",
    cx: 284.4075,
    cy: 1704.2441,
    r: 920.5327,
    gradientTransform: "matrix(2.392576e-03 0 0 -2.392576e-03 -164.11 246.9877)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5412,
    style: {
      stopColor: "#F7F5F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D6CFDD",
      stopOpacity: 0
    }
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "path33224",
    className: "st55",
    d: "M307.5,626.7c0.7-0.4,1.1-0.1,1.4,0.7c0.3,0.8,0.4,1.6,0.4,2.4c0,0.8-0.2,1.5-0.6,2 c-0.4,0.5-0.8,0.8-1.3,0.9l-1.6-0.1c-0.5-0.1-0.7-0.8-0.5-2c0.1-1.2,0.4-2.1,0.7-2.6L307.5,626.7L307.5,626.7z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "path33226_1_",
    cx: 284.4075,
    cy: 1704.2441,
    r: 920.5327,
    gradientTransform: "matrix(1.745608e-03 0 0 -1.745608e-03 -159.9896 240.2512)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5412,
    style: {
      stopColor: "#F7F5F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D6CFDD",
      stopOpacity: 0
    }
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "path33226",
    className: "st56",
    d: "M313.9,623.3c0,0.4-0.2,0.8-0.5,1.2c-0.4,0.3-0.8,0.5-1.3,0.5c-0.5,0-0.9-0.2-1.3-0.5 c-0.4-0.3-0.5-0.7-0.5-1.2s0.2-0.8,0.5-1.2c0.4-0.3,0.8-0.5,1.3-0.5c0.5,0,0.9,0.2,1.3,0.5C313.7,622.4,313.9,622.8,313.9,623.3z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "path33228_1_",
    cx: 284.4075,
    cy: 1704.2441,
    r: 920.5327,
    gradientTransform: "matrix(4.394528e-04 0 0 -6.469727e-04 -174.6711 229.7327)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2196,
    style: {
      stopColor: "#7B3EB8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5412,
    style: {
      stopColor: "#873FCF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B183E1",
      stopOpacity: 0.4431
    }
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "path33228",
    className: "st57",
    d: "M295.8,612.1l0.3,0.2l0.1,0.5l-0.1,0.5l-0.3,0.2l-0.3-0.2l-0.1-0.5c0-0.2,0-0.4,0.1-0.5 L295.8,612.1z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "path33230_1_",
    cx: 284.4075,
    cy: 1704.2441,
    r: 920.5327,
    gradientTransform: "matrix(1.757816e-03 0 0 -1.757816e-03 -177.9873 228.4659)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2196,
    style: {
      stopColor: "#7B3EB8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5412,
    style: {
      stopColor: "#873FCF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B183E1",
      stopOpacity: 0.4431
    }
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "path33230",
    className: "st58",
    d: "M293.2,610c0,0.4-0.1,0.7-0.4,1c-0.3,0.3-0.6,0.4-1,0.4c-0.4,0-0.7-0.1-1-0.4 c-0.3-0.3-0.4-0.6-0.4-1s0.1-0.7,0.4-1c0.3-0.3,0.6-0.4,1-0.4c0.4,0,0.7,0.1,1,0.4C293.1,609.3,293.2,609.6,293.2,610z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "path33232_1_",
    cx: 284.4075,
    cy: 1704.2441,
    r: 920.5327,
    gradientTransform: "matrix(2.539064e-03 0 0 -2.539064e-03 -173.0029 236.9635)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5412,
    style: {
      stopColor: "#F7F5F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D6CFDD",
      stopOpacity: 0
    }
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "path33232",
    className: "st59",
    d: "M295.9,617.2c0.4-0.3,0.8-0.5,1.3-0.5c0.5,0,0.8,0.2,1,0.5l0.3,1.3c0.1,0.5,0,0.9-0.2,1.3 c-0.2,0.3-0.6,0.5-1.1,0.5c-0.5,0-0.9-0.2-1.3-0.5c-0.3-0.3-0.5-0.7-0.5-1.3C295.5,618,295.6,617.5,295.9,617.2L295.9,617.2z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "path33234_1_",
    cx: 284.4075,
    cy: 1704.2441,
    r: 920.5327,
    gradientTransform: "matrix(8.789040e-04 0 0 -8.789040e-04 -180.5498 238.1711)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2196,
    style: {
      stopColor: "#7B3EB8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5412,
    style: {
      stopColor: "#873FCF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B183E1",
      stopOpacity: 0.4431
    }
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    id: "path33234",
    className: "st60",
    d: "M289.6,621.8l0.2,0.3l-0.2,0.2l-0.4,0.1l-0.4-0.1l-0.2-0.2l0.2-0.3l0.4-0.1L289.6,621.8 L289.6,621.8z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "path33236_1_",
    cx: 284.4075,
    cy: 1704.2441,
    r: 920.5327,
    gradientTransform: "matrix(1.391600e-03 0 0 -1.391600e-03 -175.935 240.3864)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5412,
    style: {
      stopColor: "#F7F5F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D6CFDD",
      stopOpacity: 0
    }
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    id: "path33236",
    className: "st61",
    d: "M295.3,623.9c0,0.3-0.1,0.6-0.3,0.8c-0.2,0.2-0.5,0.4-0.8,0.4s-0.6-0.1-0.8-0.4 c-0.2-0.2-0.3-0.5-0.3-0.8c0-0.3,0.1-0.6,0.3-0.8c0.2-0.2,0.5-0.3,0.8-0.3s0.6,0.1,0.8,0.3C295.2,623.3,295.3,623.6,295.3,623.9z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "path33238_1_",
    cx: 284.4075,
    cy: 1704.2441,
    r: 920.5327,
    gradientTransform: "matrix(1.208496e-03 0 0 -1.208496e-03 -173.3289 243.6466)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2196,
    style: {
      stopColor: "#7B3EB8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5412,
    style: {
      stopColor: "#873FCF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B183E1",
      stopOpacity: 0.4431
    }
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    id: "path33238",
    className: "st62",
    d: "M297.9,627c0.2,0.2,0.3,0.5,0.3,0.8s-0.1,0.5-0.3,0.7c-0.2,0.2-0.4,0.3-0.7,0.3 c-0.3,0-0.6-0.1-0.8-0.3c-0.2-0.2-0.3-0.4-0.3-0.7c0-0.3,0.1-0.6,0.3-0.8c0.2-0.2,0.5-0.3,0.8-0.3 C297.5,626.8,297.7,626.8,297.9,627z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "path33240_1_",
    cx: 284.4075,
    cy: 1704.2441,
    r: 920.5327,
    gradientTransform: "matrix(1.843264e-03 0 0 -1.843264e-03 -157.0916 248.0884)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5412,
    style: {
      stopColor: "#F7F5F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D6CFDD",
      stopOpacity: 0
    }
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    id: "path33240",
    className: "st63",
    d: "M313.7,630.8c0.4-0.3,0.9-0.4,1.5-0.4c0.6,0,1.1,0.1,1.5,0.4c0.4,0.3,0.6,0.7,0.6,1.2 c0,0.4-0.2,0.9-0.7,1.3c-0.5,0.4-1.1,0.5-1.7,0.4c-0.6-0.1-1-0.3-1.4-0.6c-0.4-0.3-0.5-0.7-0.5-1.2 C313.1,631.5,313.3,631.1,313.7,630.8L313.7,630.8z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "path33242_1_",
    cx: 284.4075,
    cy: 1704.2441,
    r: 920.5327,
    gradientTransform: "matrix(1.696776e-03 0 0 -2.099608e-03 -160.9586 253.8361)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5412,
    style: {
      stopColor: "#F7F5F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D6CFDD",
      stopOpacity: 0
    }
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    id: "path33242",
    className: "st64",
    d: "M312.3,638l-0.4,1.3c-0.3,0.4-0.6,0.5-0.9,0.5c-0.4,0-0.7-0.2-0.9-0.5 c-0.3-0.3-0.4-0.7-0.4-1.3c0-0.5,0.1-0.9,0.4-1.3c0.3-0.3,0.6-0.5,0.9-0.5c0.4,0,0.7,0.2,0.9,0.5 C312.2,637.1,312.3,637.5,312.3,638z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "path33244_1_",
    cx: 284.4075,
    cy: 1704.2441,
    r: 920.5327,
    gradientTransform: "matrix(1.757816e-03 0 0 -1.757816e-03 -127.4273 229.6659)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5412,
    style: {
      stopColor: "#F7F5F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D6CFDD",
      stopOpacity: 0
    }
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    id: "path33244",
    className: "st65",
    d: "M349.9,611.3c0,0.3-0.1,0.6-0.4,0.9c-0.2,0.2-0.5,0.4-0.9,0.4c-0.4,0-0.7-0.1-0.9-0.4 s-0.4-0.5-0.4-0.9c0-0.3,0.1-0.6,0.4-0.9c0.2-0.2,0.5-0.4,0.9-0.4c0.4,0,0.7,0.1,0.9,0.4C349.8,610.7,349.9,611,349.9,611.3z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "path33246_1_",
    cx: 284.4075,
    cy: 1704.2441,
    r: 920.5327,
    gradientTransform: "matrix(2.331544e-03 0 0 -2.331544e-03 -131.7213 231.8344)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5412,
    style: {
      stopColor: "#F7F5F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D6CFDD",
      stopOpacity: 0
    }
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    id: "path33246",
    className: "st66",
    d: "M345.5,613.1c0,0.5-0.2,0.9-0.6,1.2c-0.4,0.3-0.9,0.5-1.4,0.5c-0.5,0-1-0.2-1.4-0.5 c-0.4-0.3-0.6-0.7-0.6-1.2c0-0.5,0.2-0.9,0.6-1.2c0.4-0.3,0.9-0.5,1.4-0.5c0.5,0,1,0.2,1.4,0.5 C345.3,612.2,345.5,612.6,345.5,613.1L345.5,613.1z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "path33248_1_",
    cx: 284.4075,
    cy: 1704.2441,
    r: 920.5327,
    gradientTransform: "matrix(2.844240e-03 0 0 -2.844240e-03 -129.3865 241.5697)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5412,
    style: {
      stopColor: "#F7F5F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D6CFDD",
      stopOpacity: 0
    }
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    id: "path33248",
    className: "st67",
    d: "M344.4,621.3c0.5-0.5,1.1-0.8,1.8-0.8c0.7,0,1.3,0.3,1.8,0.8c0.5,0.5,0.8,1.2,0.9,2 c0.1,0.8,0,1.5-0.2,2.1c-0.3,0.6-1,0.9-2,1.1c-1,0.1-1.8-0.1-2.2-0.9c-0.5-0.7-0.8-1.5-0.8-2.3 C343.7,622.5,343.9,621.8,344.4,621.3L344.4,621.3z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "path33250_1_",
    cx: 284.4075,
    cy: 1704.2441,
    r: 920.5327,
    gradientTransform: "matrix(1.916504e-03 0 0 -1.916504e-03 -135.438 246.8563)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5412,
    style: {
      stopColor: "#F7F5F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D6CFDD",
      stopOpacity: 0
    }
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    id: "path33250",
    className: "st68",
    d: "M339.6,628.9c0.5,0,0.9,0.1,1.2,0.4c0.4,0.3,0.5,0.7,0.5,1.1c0,0.4-0.2,0.8-0.5,1.1 c-0.3,0.3-0.7,0.4-1.2,0.4c-0.5,0-0.9-0.1-1.3-0.4c-0.3-0.3-0.5-0.7-0.5-1.1c0-0.4,0.2-0.8,0.5-1.1 C338.7,629.1,339.1,628.9,339.6,628.9z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "path33252_1_",
    cx: 284.4075,
    cy: 1704.2441,
    r: 920.5327,
    gradientTransform: "matrix(4.882816e-04 0 0 -4.882816e-04 -132.5421 244.0623)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2196,
    style: {
      stopColor: "#7B3EB8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5412,
    style: {
      stopColor: "#873FCF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B183E1",
      stopOpacity: 0.4431
    }
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    id: "path33252",
    className: "st69",
    d: "M343.5,629.6l-0.4,0.3l-0.5,0.1c-0.1,0-0.2-0.2-0.1-0.5c0-0.4,0.1-0.6,0.2-0.7l0.4-0.1 l0.4,0.1l0.2,0.4L343.5,629.6L343.5,629.6z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "path33254_1_",
    cx: 284.4075,
    cy: 1704.2441,
    r: 920.5327,
    gradientTransform: "matrix(1.562496e-03 0 0 -1.562496e-03 -146.8635 251.1915)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5412,
    style: {
      stopColor: "#F7F5F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D6CFDD",
      stopOpacity: 0
    }
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    id: "path33254",
    className: "st70",
    d: "M327.5,634.9c0.2,0.2,0.3,0.5,0.3,0.9c0,0.4-0.1,0.7-0.3,0.9c-0.2,0.2-0.4,0.4-0.7,0.4 c-0.3,0-0.6-0.1-0.8-0.4c-0.2-0.2-0.3-0.5-0.3-0.9c0-0.4,0.1-0.7,0.3-0.9c0.2-0.2,0.5-0.4,0.8-0.4 C327.1,634.5,327.4,634.7,327.5,634.9z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "path33256_1_",
    cx: 284.4075,
    cy: 1704.2441,
    r: 920.5327,
    gradientTransform: "matrix(2.160648e-03 -2.685544e-04 -2.685544e-04 -2.160648e-03 -139.0706 255.5397)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5412,
    style: {
      stopColor: "#F7F5F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D6CFDD",
      stopOpacity: 0
    }
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    id: "path33256",
    className: "st71",
    d: "M333.5,638.5c0.4-0.4,1-0.5,1.6-0.5s1.1,0.2,1.5,0.5c0.4,0.4,0.7,0.9,0.7,1.4 c0,0.5-0.2,1-0.7,1.3c-0.4,0.4-0.9,0.6-1.5,0.6c-0.6,0-1.1-0.2-1.6-0.6c-0.4-0.4-0.6-0.8-0.6-1.3 C332.9,639.4,333.1,638.9,333.5,638.5z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "path33258_1_",
    cx: 284.4075,
    cy: 1704.2441,
    r: 920.5327,
    gradientTransform: "matrix(9.399439e-04 0 0 -9.399439e-04 -153.2586 251.0843)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2196,
    style: {
      stopColor: "#7B3EB8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5412,
    style: {
      stopColor: "#873FCF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B183E1",
      stopOpacity: 0.4431
    }
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    id: "path33258",
    className: "st72",
    d: "M320.5,637l-0.7,0.2L319,637c-0.2-0.1-0.3-0.3-0.3-0.5c0-0.2,0.1-0.4,0.3-0.5l0.8-0.2 l0.7,0.2c0.2,0.1,0.3,0.3,0.3,0.5L320.5,637z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "path33260_1_",
    cx: 284.4075,
    cy: 1704.2441,
    r: 920.5327,
    gradientTransform: "matrix(1.049808e-03 0 0 -1.049808e-03 -129.9183 247.3362)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5412,
    style: {
      stopColor: "#F7F5F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D6CFDD",
      stopOpacity: 0
    }
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    id: "path33260",
    className: "st73",
    d: "M346,630.8l0.9,0.4c0.3,0.2,0.5,0.5,0.5,0.9c0,0.4-0.1,0.7-0.4,1l-0.9,0.4 c-0.3,0-0.6-0.1-0.8-0.4c-0.2-0.2-0.3-0.5-0.3-0.9c0-0.4,0.1-0.7,0.3-0.9C345.4,631,345.7,630.8,346,630.8z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "path33262_1_",
    cx: 284.4075,
    cy: 1704.2441,
    r: 920.5327,
    gradientTransform: "matrix(4.150392e-04 0 0 -4.150392e-04 -136.0756 250.0143)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5412,
    style: {
      stopColor: "#F7F5F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D6CFDD",
      stopOpacity: 0
    }
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    id: "path33262",
    className: "st74",
    d: "M339.6,636.4l-0.4,0.2c-0.1,0-0.3-0.1-0.4-0.2l-0.2-0.4l0.2-0.4c0.1-0.1,0.3-0.2,0.4-0.2 l0.4,0.2l0.2,0.4L339.6,636.4z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    id: "path34054",
    className: "st75",
    d: "M319.3,618.3c0.3-2.7,2-4.6,5.2-5.6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "B_cell"
  }, /*#__PURE__*/React.createElement("g", {
    id: "B_cell_art_2_"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 182.2774,
    cy: 318.795,
    r: 27.1599,
    gradientTransform: "matrix(1 0 0 -1 0 448.8571)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    style: {
      stopColor: "#D4C2BC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.074,
    style: {
      stopColor: "#CFBCB5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476,
    style: {
      stopColor: "#B2978F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.799,
    style: {
      stopColor: "#A08078"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9A786F"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st76",
    cx: 178.6,
    cy: 137.9,
    r: 27.2
  })), /*#__PURE__*/React.createElement("g", {
    className: "st77"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 151.4262,
    y1: 306.761,
    x2: 205.7303,
    y2: 306.761,
    gradientTransform: "matrix(1 0 0 -1 0 448.8571)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776,
    style: {
      stopColor: "#020102",
      stopOpacity: 0.224
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#060405",
      stopOpacity: 0
    }
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "st78",
    d: "M181,157.5c-14,0-25.4-11.4-25.4-25.4c0-4.7,1.3-9.1,3.6-12.9c-4.7,4.9-7.6,11.5-7.6,18.9 c0,15,12.2,27.2,27.2,27.2c15,0,27.2-12.2,27.2-27.2c0-0.1,0-0.1,0-0.2C203.1,149,193.1,157.5,181,157.5L181,157.5z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 164.9414,
    y1: 304.2368,
    x2: 196.4406,
    y2: 319.8043,
    gradientTransform: "matrix(1 0 0 -1 0 448.8571)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6B568F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8C7BA8"
    }
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "st79",
    d: "M180.1,121.1c-9.4,0-17,7.6-17,17c0,6.1,7.6,15.3,17,15.3c9.4,0,17-9.2,17-15.3 C197,128.7,189.4,121.1,180.1,121.1z"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "st77"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196.2,132.8c0,0.5,0.1,1,0.1,1.5c0,5.5-6.8,13.7-15.2,13.7c-8.4,0-15.2-8.2-15.2-13.7c0-3.2,1-6.2,2.8-8.7 c-3.4,3.1-5.6,7.6-5.6,12.5c0,6.1,7.6,15.3,17,15.3s17-9.2,17-15.3C197,136.2,196.7,134.5,196.2,132.8L196.2,132.8z"
  }))), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "st80",
    d: "M183.5,126.1c-1.9-0.2-3.5,0.9-3.5,2c0,1.1,1.6,1.5,3.5,2c4.2,1,5.8,4,5.8,4c1.5,1.2,1.8,1.9,2.9,1.7 c1.4-0.3,1.1-2.5,0.1-4.9C192.2,130.9,191,127,183.5,126.1z"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st81",
    d: "M203.9,148.7l4.5,3.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st81",
    d: "M210.5,151.1c-0.8,0-1.6,0.4-2.1,1.2c-0.5,0.8-0.6,1.7-0.2,2.4"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st81",
    d: "M186.9,162l1.6,7.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st81",
    d: "M190.8,170c-0.5-0.6-1.3-0.9-2.3-0.8c-0.9,0.1-1.7,0.7-2,1.4"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st81",
    d: "M162.4,158.4l-3.6,5.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st81",
    d: "M160.2,165.6c-0.1-0.8-0.6-1.5-1.5-1.9c-0.9-0.4-1.8-0.3-2.4,0.1"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st81",
    d: "M154.6,149.3l-6.3,2.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st81",
    d: "M148.3,154.6c0.4-0.6,0.5-1.6,0.1-2.4c-0.4-0.9-1.2-1.4-1.9-1.5"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st81",
    d: "M152.3,137.4l-6.4-0.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st81",
    d: "M144.6,139.4c0.7-0.3,1.2-1.1,1.3-2.1c0.1-0.9-0.3-1.8-0.9-2.2"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st81",
    d: "M155.1,124.7l-5-3.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st81",
    d: "M148,122c0.8,0.1,1.6-0.3,2.2-1s0.7-1.7,0.4-2.4"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st81",
    d: "M163.6,115.3l-3.4-5.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st81",
    d: "M157.8,110.5c0.7,0.3,1.6,0.2,2.4-0.4s1.2-1.4,1.1-2.2"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st81",
    d: "M195.3,116.1l4-4.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st81",
    d: "M198.5,109.5c-0.2,0.7,0.2,1.6,0.9,2.3c0.7,0.6,1.6,0.8,2.3,0.6"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st81",
    d: "M202.2,125.6l6-2.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st81",
    d: "M208.3,121c-0.4,0.6-0.5,1.6-0.1,2.4c0.4,0.9,1.2,1.4,1.9,1.5"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st81",
    d: "M205.5,139l5.9-0.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st81",
    d: "M212.7,136.8c-0.7,0.3-1.2,1.1-1.3,2c-0.1,0.9,0.3,1.8,0.9,2.2"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st81",
    d: "M173.4,110.9l-1.2-6.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st81",
    d: "M170,103.5c0.5,0.6,1.3,1,2.3,0.9c0.9-0.1,1.7-0.6,2-1.3"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st81",
    d: "M187.2,112.1l2.1-5.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st81",
    d: "M187.7,104.3c0.1,0.8,0.6,1.5,1.5,1.9s1.8,0.3,2.4-0.2"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st81",
    d: "M196.9,156.9l3.8,4.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st81",
    d: "M203.1,161.3c-0.7-0.3-1.6-0.2-2.4,0.3c-0.8,0.6-1.2,1.4-1.1,2.2"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st81",
    d: "M174.5,162.3l0.1,6.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st81",
    d: "M176.8,170.2c-0.4-0.6-1.2-1.1-2.2-1c-0.9,0-1.8,0.5-2.1,1.2"
  })))), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "st80",
    d: "M190.5,116.4c0,0,2.6,0.9,4.4,2.5c1.8,1.7,2.9,3.8,3.2,4.7c0.4,0.9-0.4,0.6-0.8,0.2 c-1.3-1.6-2.3-3.5-4.1-4.6c-2-1.2-4.5-1.9-6.9-1.8C182.7,117.6,185.6,114.6,190.5,116.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "T_cell"
  }, /*#__PURE__*/React.createElement("g", {
    id: "T_cell_art_14_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_4_",
    cx: 277.8875,
    cy: 315.2904,
    r: 26.8051,
    gradientTransform: "matrix(1 0 0 -1 0 448.8571)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CACCA4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.321,
    style: {
      stopColor: "#C4C69A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BABC88"
    }
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st82",
    cx: 270.9,
    cy: 142.9,
    r: 24.1
  })), /*#__PURE__*/React.createElement("g", {
    className: "st83"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 246.8729,
    y1: 302.3483,
    x2: 294.9246,
    y2: 302.3483,
    gradientTransform: "matrix(1 0 0 -1 0 448.8571)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776,
    style: {
      stopColor: "#020102",
      stopOpacity: 0.224
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#060405",
      stopOpacity: 0
    }
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "st84",
    d: "M273,160.1c-12.4,0-22.5-10.1-22.5-22.5c0-4.2,1.2-8.1,3.2-11.5c-4.2,4.3-6.8,10.2-6.8,16.7 c0,13.3,10.8,24,24,24c13.3,0,24-10.8,24-24c0-0.1,0-0.1,0-0.2C292.6,152.7,283.7,160.1,273,160.1z"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st85",
    d: "M255.3,124.8l-4.8-6.5"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st85",
    d: "M258.5,122.7l-4.9-6.7"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st85",
    d: "M285.8,125.3l5.5-6"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st85",
    d: "M288.6,128.1l5.7-6"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st85",
    d: "M286.6,159l6,5.5"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st85",
    d: "M283.8,161.7l6,5.7"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st85",
    d: "M254.5,159.2l-5.5,6"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st85",
    d: "M251.8,156.4l-5.7,6"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st85",
    d: "M273.7,165.9l1.1,8"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st85",
    d: "M269.9,166.2l1,8.2"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st85",
    d: "M294.5,142.6l8.1-0.1"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st85",
    d: "M294.4,146.5h8.3"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st85",
    d: "M269.9,119.6l-0.1-8.1"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st85",
    d: "M273.8,119.8v-8.3"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st85",
    d: "M247.7,142.3l-8.1,0.1"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st85",
    d: "M247.8,138.4h-8.3"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 279.7552,
    y1: 315.5696,
    x2: 260.222,
    y2: 294.1752,
    gradientTransform: "matrix(1 0 0 -1 0 448.8571)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7D9CBF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4773A1"
    }
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st86",
    cx: 271.4,
    cy: 142.5,
    r: 13.2
  })), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    className: "st77"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M272.5,152c-6.8,0-12.3-5.5-12.3-12.3c0-2.3,0.6-4.4,1.7-6.3c-2.4,2.5-3.7,5.7-3.7,9.2c0,7.3,5.9,13.2,13.2,13.2 c7.3,0,13.2-5.9,13.2-13.2v-0.1C283.3,148,278.3,152,272.5,152z"
  })))))), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "st87",
    d: "M274,132.7c0,0-2,0.6-2,1.6c0.1,1,1.2,1.4,1.2,1.4s1.9,0.3,3.4,2.7c1.3,2.1,1.3,3.3,1.4,4.7s1.8,1.7,2.5,1 c0.8-0.6,1.7-2.6,1.3-4.7c-0.4-2.6-2.2-5.1-4.4-6.3C275.4,132.1,274,132.7,274,132.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Neutrophil"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_7_",
    cx: -147.8332,
    cy: 835.7408,
    r: 42.418,
    gradientTransform: "matrix(0.3656 -0.9308 0.9308 0.3656 -347.3663 -307.465)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.001,
    style: {
      stopColor: "#BA8CB1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    style: {
      stopColor: "#987392"
    }
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "st88",
    d: "M386.7,168.1c-1.7,0.8-5.2,0-6.9,0.6c-2.5,1-3.6,4.9-6.2,4.5c-1.2-0.2-2.2-1.3-3.4-1.3c-1.5,0-2.6,1.6-4,1.7 c-1.8,0.1-2.9-1.8-4.5-2.5c-1.8-0.7-3.8,0.2-5.6,0.9c-1.8,0.7-4.3,0.9-5.3-0.7c-0.4-0.6-0.5-1.4-0.9-2.1c-0.8-1.4-2.5-1.9-4.1-2.2 c-1.6-0.3-3.3-0.4-4.5-1.5c-1.2-1.1-1.7-1.7,0.2-5c-1.7-0.6-3.6-0.2-4.9-1.4c-1.4-1.2-2.2-3.2-1.6-4.9c0.3-0.9,1-1.7,1.2-2.6 c0.6-3.1-4.5-5.5-3.2-8.4c0.3-0.7,0.9-1.2,1.2-1.8c2.1-3.4-0.7-10.7,2.4-13.2c1.8-1.4,4.6-0.5,6.3-2c1.3-1.2,1.2-3.2,1.8-4.9 c1.2-3.4,6.3-4.7,9-2.3c-0.2-4.1,4.3-7.6,8.2-6.3c1.1,0.4,2.2,1,3.3,0.9c2-0.2,3.2-2.6,5.2-2.8c1.8-0.2,3.3,1.5,5,1.9 c1,0.2,2.1-0.1,3.2-0.3c3.3-0.5,6.7,0.3,9.9,1.1c1,0.2,2,0.5,2.8,1.1c1.9,1.3,1.3,5.9,3.4,6.7c0.8,0.3,1.7,0.3,2.3,0.9 c1.2,1.1,0.3,3.1,1.1,4.5c1.1,1.9,4.5,1.4,5.3,3.4c0.7,1.7-1.2,3.4-1.2,5.2c0,2.1,2.4,3.5,2.7,5.6c0.3,2-1.5,3.7-2,5.6 c-0.5,2.2,2.8,4.3,0.9,6.2c-3.6,3.6-4.6,5.5-4.9,6.5c-1.6,4.9-3.5,1.6-6.7,3.8C389.9,164.6,388.9,167.2,386.7,168.1L386.7,168.1z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st89"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_8_",
    cx: 353.5563,
    cy: 270.7775,
    r: 48.7664,
    gradientTransform: "matrix(1 0 0 -1 0 448.8571)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776,
    style: {
      stopColor: "#020102",
      stopOpacity: 0.224
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#060405",
      stopOpacity: 0
    }
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "st90",
    d: "M399,155.4c-0.3,0.7-0.6,1.5-1.2,1.9c-0.9,0.6-2.1,0.3-3.2,0.5c-1.8,0.3-2.7,1.8-3.8,3 c-1,1-1.8,1.7-2.9,2.1c-0.6,0.2-1.3,0.4-2.1,0.5c-2,0.2-4.2,0.2-5.8,1.5c-1.3,1-2.2,2.8-3.8,2.9c-1.1,0.1-2.1-0.6-3.1-0.8 c-1.2-0.2-2.3,0.2-3.5,0.4c-2.5,0.5-4.2-1.5-6.7-1.4c-2,0-3.9,1.6-5.8,1.2c-2.2-0.4-3.2-3-5.2-4.2c-1.6-0.9-3.6-0.8-5-1.9 c-1.6-1.3-1.8-3.6-3.2-5.1c-1.1-1.1-2.8-1.7-3.5-3c-0.8-1.4-0.3-3.1,0-4.6c0.5-3.2-3.3-5.2-2.4-8.1c0.2-0.7,0.7-1.2,1-1.8 c1.9-3.1-0.3-8.3,1.5-11.3c-1.4,0.2-2.8,0.2-3.9,1.1c-3.1,2.5-0.3,9.8-2.4,13.2c-0.4,0.6-1,1.1-1.2,1.8c-1.2,2.9,3.8,5.3,3.2,8.4 c-0.2,1-0.9,1.7-1.2,2.6c-0.6,1.7,0.3,3.7,1.6,4.9s3.2,0.9,4.9,1.4c-1.9,3.3-1.4,3.9-0.2,5c1.2,1.1,2.9,1.2,4.5,1.5 c1.6,0.3,3.3,0.8,4.1,2.2c0.4,0.7,0.5,1.5,0.9,2.1c1.1,1.6,3.5,1.4,5.3,0.7c1.8-0.7,3.8-1.7,5.6-0.9c1.6,0.7,2.8,2.6,4.5,2.5 c1.5-0.1,2.6-1.7,4-1.7c1.2,0,2.2,1.2,3.4,1.3c2.6,0.4,3.8-3.6,6.2-4.5c1.8-0.7,5.2,0.1,6.9-0.6c2.3-1,3.3-3.6,5.5-5 c3.3-2.2,5.1,1.1,6.7-3.8c0.3-1,1.3-3,4.9-6.5c1.1-1.1,0.4-2.3-0.2-3.6C401.6,151,400.1,152.9,399,155.4L399,155.4z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_9_",
    cx: -159.1216,
    cy: 831.5862,
    r: 25.6364,
    gradientTransform: "matrix(0.3656 -0.9308 0.9308 0.3656 -347.3663 -307.465)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.002,
    style: {
      stopColor: "#8672A5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#563781"
    }
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "M375.2,149.8c-0.4,2.1-3,6.7-4.5,8.2c-1.7,1.7-0.8,1.2-3,0.3c-2.9-1.2-3.8-4.5-6.5-5.9 c-3.7-2-7.3-1.1-9.9-0.6c-0.9,0.2-2.1,0.1-2.3-0.8c-0.1-0.9,0.4-3.2,1.1-3.7c3.3-2.6,5.3-6.9,5.1-11.2c-0.2-4.3-0.2-9.8-3.8-12 c-4.6,1.4-6,4.1-7.9,6.8c-0.6,0.8-1.5,4.3-1.7,5.2c-0.7,3.2,1.9,6,5.7,9.4c1.3,1.2-1.1,3.6-0.5,5.3c0.4,1,1.2,1.8,1.6,2.8 c0.6,1.3,0.2,2.9,0.3,4.3c0.3,4.4,8,7.6,12.3,6.6c1.8-0.4,3.3-1.5,4.9-2.3c5.4-2.9,7.4,0.7,13.5,0.9c2.6,0.1,5.4-0.3,7.6-1.9 c0,0,16.6-8.7,7.9-26.4c0,0-2.6-1.6-2.8-4.9c0,0-3,0.3-2,5.1C390.4,134.8,378.4,135,375.2,149.8L375.2,149.8z"
  })), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    className: "st83"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M397.2,140.2c2,12.6-9.8,18.8-9.8,18.8c-2.1,1.5-4.8,1.9-7.3,1.8c-5.9-0.2-7.8-3.6-13.1-0.8c-1.5,0.8-3,1.8-4.7,2.2 c-4.1,1-11.6-2.2-11.9-6.4c-0.1-1.4-0.1-1.4-0.6-2.7c-0.4-1-1.6-2.3-1.2-4.1c0.3-1.7,1.8-4,0.5-5.2c-3.7-3.3-6.2-6-5.5-9.1 c0.2-0.9,1.1-4.3,1.7-5.1c0.7-1,1.4-2.2,2.1-3.5c-1.5,1.3-2.5,2.9-3.6,4.5c-0.6,0.8-1.5,4.3-1.7,5.2c-0.7,3.2,1.9,6,5.7,9.4 c1.3,1.2-1.1,3.6-0.5,5.3c0.4,1,1.2,1.8,1.6,2.8c0.6,1.3,0.2,2.9,0.3,4.3c0.3,4.4,8,7.6,12.3,6.6c1.8-0.4,3.3-1.5,4.9-2.3 c5.4-2.9,7.4,0.7,13.5,0.9c2.6,0.1,5.4-0.3,7.6-1.9C387.3,161.1,400.4,154.2,397.2,140.2L397.2,140.2z"
  }))), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "st92",
    d: "M385.2,138.7c0.8-0.7,1.7-1.3,2.7-1.7c1-0.4,2.2-0.4,3.1,0c0.4,0.2,0.8,0.5,0.9,0.9c0.3,0.7-0.1,1.5-0.6,2 c-0.6,0.5-1.3,0.8-2,1.1c-2,0.9-4,2.1-5.2,3.9c-0.6,1-1.4,2.7-2.9,2.6c-1.2-0.1-0.9-2.1-0.8-3.2C380.9,142,383.6,140,385.2,138.7 L385.2,138.7z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "st92",
    d: "M355.6,152.4c1-0.8,2.5-0.4,3.7,0.1c0.7,0.3,1.3,0.6,1.7,1.2c0.4,0.6,0.3,1.6-0.4,1.9 c-0.7,0.4-1.5-0.2-2.3-0.5c-0.6-0.2-1.2-0.2-1.8-0.3c-0.6-0.1-1.2-0.4-1.5-0.9C354.7,153.3,355,152.5,355.6,152.4"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "st92",
    d: "M353.2,129.7c0.2,0.5,0.4,1,0.4,1.5c0,0.6-0.2,1.3-0.4,1.8c-0.2,0.6-0.5,1.1-0.9,1.6c-0.2,0.4-0.5,0.7-1,0.8 c-0.4,0.1-0.9-0.1-1-0.5c0-0.2,0.1-0.5,0.2-0.7c0.2-0.4,0.4-0.9,0.4-1.4c0-0.7-0.2-1.3-0.4-1.9c-0.2-0.6-0.4-1.3-0.2-1.9 c0.1-0.6,0.8-1.4,1.5-1.2C352.4,128,352.9,129.1,353.2,129.7L353.2,129.7z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "st80",
    d: "M391,121.2c0,0-0.9-1.3-1.5-3.2s-3-2.6-4.9-2.8s-5.6-0.9-6.8-0.6c-1.3,0.2-3.6,0.4-0.6,1.5s8.8-0.2,10.9,2.3 C390.1,121,391,121.2,391,121.2z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "st80",
    d: "M400.6,129.9c0,0-1.3,0.3-2.7-0.9c-1.4-1.2-1.4-1.8-1.4-1.8s-0.6,1.5,0.5,2.7c1.2,1.2,2.1,1.6,2.9,1.4 C400.6,131.1,401.6,130.7,400.6,129.9z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "st80",
    d: "M351.4,119.3c0,0-0.9-0.8-2.5-0.5c-1.6,0.2-2.6,1.3-1.6,1.7c0.5,0.2,2.4-0.3,3.4-0.1s1.4,0.2,2.1,0.5 S352.5,119.5,351.4,119.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Eosinophil"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_10_",
    cx: 1501.17,
    cy: 521.3407,
    r: 69.9921,
    gradientTransform: "matrix(-0.8992 0.1553 7.838770e-02 0.8674 1796.2559 -573.6754)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C1B1AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AC8784"
    }
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "st93",
    d: "M441.8,140.5c1.1,9.8,7.2,18.2,13.6,23.4c18.3,14.8,55.6,18.7,59.3-19.9c0.9-9.7-1.8-14.5-6.3-21.8 c-4.1-6.7-15-11.2-19.3-12.2c-12.4-2.9-27-2.4-38.1,6.9c-4.7,3.9-8.5,10.3-9.3,17.7C441.6,136.6,441.6,138.5,441.8,140.5 L441.8,140.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st77"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 444.8571,
    y1: 300.3006,
    x2: 513.593,
    y2: 300.3006,
    gradientTransform: "matrix(1 0 0 -1 0 448.8571)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776,
    style: {
      stopColor: "#020102",
      stopOpacity: 0.224
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#060405",
      stopOpacity: 0
    }
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "st94",
    d: "M460,155c-6.1-4.3-11.9-11.3-12.9-19.4c-0.2-1.6-0.2-3.3,0-4.9c0.1-0.9,0.3-1.7,0.5-2.5 c-1.3,2.3-2.2,4.9-2.5,7.6c-0.2,1.7-0.2,3.3,0,5c1.1,8.2,6.8,15.2,13,19.5c16.5,11.6,48.9,15.2,55.6-11.3 C504.2,169.6,475.2,165.7,460,155z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_12_",
    cx: 470.9178,
    cy: 205.175,
    r: 18.8699,
    gradientTransform: "matrix(0.9803 -0.1973 -0.1973 -0.9803 49.8057 434.9836)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.002,
    style: {
      stopColor: "#A5729F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#813775"
    }
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "st95",
    d: "M479.7,160.3c0.6,0,1.2,0.1,1.5-0.2s0.7-0.5,0-1.6c-0.7-1.1-0.9-3-1.6-4.1c-0.2-0.4-0.5-0.7-0.6-1 c-2.1-3.1-7.6-7.7-11.7-8.4c-2.6-0.5-4.3-1.2-5.5-1.9c-1-1.2-0.7-1.6-0.8-3.1c0-0.6,0.6-2.1,0.8-2.5c1.5-0.9,3.9-3.2,12.1-3.7 c8-0.5,12.5-8.3,9.6-12c-2.9-3.7-10.8-3.6-17.7,0.1c-5.8,3.1-7.4,11.3-6.7,14.5c0.3,2.2,0.2,4.4-1,6.9c-0.1,0.2-0.2,0.5-0.3,0.7 c-1.8,4.4-3.9,10.5,3.5,13.8c3.7,1.7,8.9,3.3,12.7,2.7C478.1,160,479.2,160.3,479.7,160.3L479.7,160.3z"
  })), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    className: "st83"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M474.5,132.6c-9.1-0.5-10.6,1.1-12.1,3.7c-0.1,0.2-0.2,0.5-0.4,0.9c1.5-1,4.1-3,11.8-3.5c3.5-0.2,6.4-1.9,8.2-4 C480.2,131.5,477.6,132.7,474.5,132.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.8,159.2c-3.3,0-8.5-0.9-12-3c-5.1-3-5.4-8.7-3.6-13.2c0.1-0.3,0.2-0.5,0.3-0.7c1.2-2.5,0.7-5,0.3-7.2 c-0.3-1.4-0.2-4.2,0.6-7c-1.3,3.1-1.6,6.4-1.2,8.1c0.3,2.2,0.2,4.4-1,6.9c-0.1,0.2-0.2,0.5-0.3,0.7c-1.8,4.4-3.9,10.5,3.5,13.8 c3.7,1.7,8.9,3.3,12.7,2.7c4-0.3,5.1,0,5.6,0c0.6,0,1.2,0.1,1.5-0.2c0,0,0.1-0.1,0.1-0.1C480.6,159.8,478.7,159.1,474.8,159.2 L474.8,159.2z"
  }))), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "st92",
    d: "M463.9,126.1c0,0-0.8,1,0.1,2c0.9,1,3.3-1.5,5.4-2.5c2.1-1,6.8-2.3,10.1-1.8c3.2,0.5,2.2-2.4-1.5-2.6 c5.3,0.3-6.6,0.5-10.2,2.1C465.2,124.4,463.9,126.1,463.9,126.1L463.9,126.1z"
  }))), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "st80",
    d: "M504.3,131.2c0,0-2.1-2.6-5.9-4.6c-2.7-1.4-4.7-1.6-6.3-1.5c-1.2,0.1-1.3,1.4-0.5,1.6 c0.8,0.3,5.7,0.8,11,5.6c1.7,1.5,2.8,3.9,3.4,5.4c0.2,0.4,0.7,0.3,0.7-0.1C506.8,136.2,507,133.7,504.3,131.2z"
  })))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 9.7,
    y: 277.7,
    className: "st96",
    width: 506.2,
    height: 87.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M9.7,325.7c0-0.1,0.2-0.1,0.4-0.1c0.1-0.3,1.1-0.7,2.4-0.6C11.4,325.1,11,325.6,9.7,325.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M18.8,332.1c0.2-0.3,1.2-0.1,1.8-0.1C19.9,332.1,19.2,332.4,18.8,332.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M21.9,331.2c0-0.4,1-0.2,1.6-0.3C23.5,331.4,22.4,331.2,21.9,331.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M23.3,331.8c-0.5-0.2,1.2-0.1,1.4-0.3c0,0.1,0,0.2,0,0.4c1.3,0.2,1.5-0.4,2.8-0.3 C26.7,332.5,24.6,332,23.3,331.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M23.7,331.1c0-0.4,0.7-0.4,1.4-0.4C24.7,330.9,24.2,331,23.7,331.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M24.7,331.2c0.7-0.3,1.8-0.5,2.6-0.1C26.9,331.4,26,331,24.7,331.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M24.2,311.3c0.1-0.3,0.9-0.1,0.8-0.5c0.2,0,0.2,0,0.2,0.1c0.1,0,0.3,0,0.4,0 C25.4,311.2,24.8,311.2,24.2,311.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M26.8,311.9c0.2-0.3,0.6-0.4,1.2-0.4C27.8,311.8,27.4,311.9,26.8,311.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M27,297.9c0.6-0.3,1.6-0.2,2.2-0.1C28.9,298,27.7,297.8,27,297.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M29.7,331.8c0.8-0.5,1.9-0.1,2.4,0.1C31.6,332.2,30.6,331.7,29.7,331.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M32.5,311.7c-0.4-0.3-0.7,0.1-1.4,0c-0.1-0.3,1.4-0.2,0.8-0.5c0.1-0.3,1.1-0.1,1.6-0.1 C33.2,311.3,32.6,311.3,32.5,311.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M33.2,298.1c-0.3-0.1,2.7-0.4,2.8,0.1C35.2,298.1,34.4,298.1,33.2,298.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M39.2,311.1c0.3-0.2,1-0.4,1.4-0.1C40.6,311.2,39.7,311,39.2,311.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M40.4,332.6c0-0.6,1.1-0.1,1.2,0.1C41.2,333.1,41.1,332.4,40.4,332.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M52.1,332.5c-0.6-0.2,1.1-0.2,1.2,0C53,333,52.8,332.3,52.1,332.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M52,331.3c0-0.2,0.6,0,0.6-0.2c0.3,0.2,2.4,0,2,0.2C53.7,331.3,52.9,331.3,52,331.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M62.6,332.9c0.2-0.3,3-0.3,3.2,0.2C64.8,332.9,63.8,332.8,62.6,332.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M67.4,312.9C66.7,313.3,64.6,312.7,67.4,312.9L67.4,312.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M72.9,333.8c0.6-0.6,1.7-0.4,3-0.3C75.2,334.1,73.8,333.6,72.9,333.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M76.6,315.6c0.2-0.2,0.3-0.4,0.8-0.4c0.5,0.3-0.1,0.5,0,0.8C76.4,316.1,77.3,315.6,76.6,315.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M89.4,315.6c0.1-0.3,1-0.1,1.4-0.1C90.7,315.9,90,315.5,89.4,315.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M90.1,334.4c0-0.2,1.5-0.5,1.4,0C90.9,334.2,90.8,334.4,90.1,334.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M90.3,309.4c-0.1-0.4,1.6-0.2,1.4,0.2C90.9,309.7,90.9,309.4,90.3,309.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M92.3,334.3c1.6-0.5,1.5-0.3,3.7-0.4C95.4,334.3,93.7,334.2,92.3,334.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M96.1,336.5c0.4-0.3,0.9,0.4,1.8,0.2C97.4,337,96.3,336.7,96.1,336.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M98.3,336.8c0-0.2,0.7-0.1,0.8-0.4c0.3,0,0.2,0.3,0.2,0.5C99.1,336.8,98.8,336.8,98.3,336.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M98.4,333.6c0.7,0.5,1.9,0.2,3.2,0.2C100.9,334.2,98.8,334.5,98.4,333.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M100.1,360.2c-0.2-0.4,0.6-0.2,0.8-0.1C102.7,360,100.2,360.4,100.1,360.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M99.9,315.9c-0.6-0.2,0.2-0.5,0.8-0.4C101,316,99.9,315.6,99.9,315.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M104,329.3c0-0.5,1.3-0.5,2-0.4C105.6,329.4,104.6,328.9,104,329.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M104.7,332.3c0.1-0.1,0.5-0.2,0.2-0.2c0.2-0.3,0.9,0.1,0.8,0.4c-0.2,0.1-0.4,0.1-0.8,0.1 C104.9,332.4,104.9,332.4,104.7,332.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M108,327.9c-0.6-0.2,1.1-0.2,1.2,0c0,0.1-0.1,0.1-0.2,0.1c-0.2,0-0.2,0-0.2,0.1 C108.4,328,108.6,327.7,108,327.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M110.4,315.8c-0.4-0.2,1.4-0.1,2-0.1C111.9,316.1,111.4,315.8,110.4,315.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M112.9,321.1c0.3,0,0.5,0,0.8,0C113.9,321.5,112.8,321.6,112.9,321.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M116.9,320.8c0.4-0.7,1.4,0.1,2.2,0C118.7,321,117.2,321,116.9,320.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M121.2,340.8c0.6,0,0.6,0.3,1.2,0.2C122.3,341.4,121.1,341.2,121.2,340.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M127.3,325.4c0.3-0.4,1.3-0.3,1.8-0.3C128.7,325.4,127.8,325.3,127.3,325.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M130.3,325.4c0.2-0.4,1.7,0,2.6-0.3C132.5,325.5,130.6,325.4,130.3,325.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M134.8,341.9c0.3-0.3,1.5-0.1,1.2,0.3C135.4,342.3,135.7,341.7,134.8,341.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M135.2,326.3c0.2-0.4,1.2-0.3,2-0.4c0.2,0.3-1.3,0.2-0.6,0.5C136.4,326.7,135.7,326.2,135.2,326.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M138.8,325.8c0.4,0.2-0.1,0.2-0.2,0.5c-0.3-0.1-1.1,0-1-0.4c0.2,0.1,0.3,0.1,0.6,0.1 C138.4,325.9,138.4,325.7,138.8,325.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M138.6,325.7c0.5-0.3,1.2,0.4,2,0C140.3,326.2,138.9,326,138.6,325.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M142,305.8c-0.1-0.5,1-0.2,1,0C142.9,306.2,142.5,305.7,142,305.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M146.4,315.5c-0.2-0.5,1.3-0.3,1,0.1C147.2,315.5,146.9,315.5,146.4,315.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M150.3,309.9c0.3-0.2,1-0.4,1.4-0.1C151.6,310.1,150.7,309.9,150.3,309.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M153.3,289.3c0.1-0.2,0.4-0.2,0.8-0.2c0,0.2,0.2,0.3,0.2,0.5c-0.2,0-0.4,0-0.6,0 C154,289.3,153.9,289.2,153.3,289.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M162.4,321.7c2.7-0.4,5.3,0,8.3,0C168,323,165.2,321.3,162.4,321.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M161.9,301.2c-0.1-0.4,1.1-0.6,1,0C162.6,301.2,162.2,301.2,161.9,301.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M163.2,296c0.1-0.3,1.2-0.1,1.4,0C164.3,296.4,163.7,295.9,163.2,296z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M165.7,301c0.3-0.2,0.8-0.3,1.4-0.3C167.2,301.2,166.1,300.9,165.7,301z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M168.2,299.6c-0.9-0.2,1.3-0.5,1,0C168.7,299.7,168.4,299.2,168.2,299.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M169.6,299.6c-0.1-0.3,1.7-0.4,1.6,0C170.6,299.4,170.5,299.6,169.6,299.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M171,322.1c-0.1-0.5,1.4-0.1,1.4-0.6c0.5,0.1,0.9,0.2,1,0.5C172.7,322.3,171.5,321.9,171,322.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M173.8,316.7c-0.7-0.3,0.9-0.2,1.4-0.3c0,0.1-0.1,0.1-0.2,0.1c0,0.1,0,0.2,0,0.2 C174.5,316.9,173.9,316.4,173.8,316.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M177.4,317.3c0.3-0.3,0.5-0.6,1.4-0.5C178.2,316.9,178,317.2,177.4,317.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M178.3,305.6c0.2-0.2,0.7-0.2,1.2-0.3C179.5,305.7,178.6,305.8,178.3,305.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M178.5,299c0-0.1,0.4-0.1,0.4-0.2c0.4,0.3,0.5,0.3,1,0.4C179.6,299.4,178.7,299.1,178.5,299z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M179.2,289.2c-0.2-0.5,0.9-0.2,1.4-0.3C180.6,289.2,179.8,289.1,179.2,289.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M187.8,346.8c0.2-0.3,0.6-0.5,1.2-0.6c0.1,0.2-0.8,0.3-0.2,0.4C188.6,346.7,188.3,346.8,187.8,346.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M187.4,301.1c0.4-0.2,1.9-0.1,2,0.2C188.8,301.2,188.2,301.1,187.4,301.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M191.4,349.3c0.1-0.1,0.2-0.2,0.2-0.4c1,0.4,1.1,0.2,2.6,0.1C193.7,349.6,192.3,349.5,191.4,349.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M192.5,344.8c0.3-0.4,1.5-0.2,2.4-0.3C194.4,344.9,193.7,344.8,192.5,344.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M194.6,349.3c-0.1-0.7,1.3,0.1,1-0.4c0-0.3,0.7,0,0.6,0.1c2.7-0.1,0.9,0.3-0.2,0.1c-0.2,0-0.1,0.1-0.2,0.2 C195.2,349.5,195.2,349.2,194.6,349.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M193.8,295.6c0.2-0.3,0.8-0.5,1.2-0.3C194.8,295.5,194.3,295.6,193.8,295.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M195,300.8c0.6,0.5,1.4,0.1,2-0.1c-0.2,0.1-0.2,0.3-0.2,0.5c-0.7,0-1.1,0.1-1.6,0.1 C195,301.1,194.9,301,195,300.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M195.3,299.3c1.5-0.2,2.8-1.1,4.1-0.6c0,0.3-0.8,0.1-1.2,0.1c0,0.3,0.8,0.2,1.4,0.2 C198.8,299.3,196.4,299.6,195.3,299.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M198.8,349.2c0-0.3,0.8-0.2,1.4-0.3C200,349.2,199.4,349.2,198.8,349.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M200.5,349.3c-0.1-0.4,0.4-0.4,1-0.4C201.4,349.2,201.2,349.4,200.5,349.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M201.9,349.1c0-0.6,2.7,0.6,2.2-0.4c0.3,0.2,0.5,0.5,0.2,0.7C203.1,349.3,203.1,349.2,201.9,349.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M202.6,298.9c0-0.1,0-0.2,0-0.4c0.5,0.2,1.1,0.3,2,0.2c0.1,0.3-1.1-0.1-0.8,0.4 C203.5,299,203.3,298.8,202.6,298.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M203.3,319c0.7,0,1.5-0.1,1.6,0.3C204.2,319.4,203.3,319.5,203.3,319z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M204.6,299.4c0.3-0.3,0.4-0.2,0.2-0.6c0.4,0.3,0.9,0.1,1-0.2c0.6-0.1,0.1,0.6,0.8,0.5 C205.9,299.1,205.5,299.3,204.6,299.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M205.1,296.8c0.1-0.3,1.3-0.4,1.2,0.1C206.1,296.8,205.6,296.8,205.1,296.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M206.8,299.2c0.4-0.3,0.9-0.4,1.6-0.3C208.1,299.2,207.5,299.2,206.8,299.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M207.2,299.7c0.2-0.4,0.7-0.3,1.2-0.1C208.4,299.8,207.5,299.6,207.2,299.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M209.3,296.7c-0.3-0.1,1.8-0.3,2-0.1C211,296.8,209.9,296.6,209.3,296.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M211,348.1c0-0.3,0.5-0.3,1-0.2c0.2,0.4-0.2,0.4-0.2,0.7C211.5,348.5,211.5,348.2,211,348.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M210.8,300.4c-0.3-0.4,2.2-0.6,2.4-0.4C213.2,300.1,211.1,300.2,210.8,300.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M212.7,290.6c0.2,0,0.4,0,0.6,0c0.2,0.1,0.2,0.6-0.4,0.6C213.1,290.9,212.6,290.9,212.7,290.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M214.3,346.1c0.2-0.2,0.2-0.5,0.8-0.5C215,345.9,215,346.1,214.3,346.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M216.9,346c0-0.4,0.7-0.3,1.2-0.4C218.1,346,217.4,346,216.9,346z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M217.1,298.9c0.3-0.2,0-0.2,0-0.5c0.3,0.1,0.9,0.1,0.8,0.5C217.6,298.9,217.3,298.9,217.1,298.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M220.1,299.7c0.1,0.2-0.1,0.2-0.4,0.2c0,0.1,0,0.2,0.2,0.2C219.2,300.6,219.2,299.6,220.1,299.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M219.7,293.7c1.1-0.3,1.4,0.2,2.6-0.1C222.3,294.2,220,294,219.7,293.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M221.3,299.9c0.1-0.4,0.7-0.4,1.2-0.6c-0.1,0.1-0.4,0.4,0.2,0.4c0.1,0.2-0.8,0.3-0.2,0.4 C221.8,300.5,222,299.5,221.3,299.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M221.2,298.5c0.4-0.6,2.1,0,2.8,0C222.9,298.8,222.3,298.2,221.2,298.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M223.2,346.8c0.5-0.3,1.3,0.2,2.2,0.1C224.9,347.2,223.8,346.9,223.2,346.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M227.8,293.9c-0.2,0-0.2-0.2-0.2-0.4c0.6,0.1,1.3-0.4,1-0.5c0.9-0.3,1.8,0.1,3-0.1 c-0.2,0.1-0.2,0.3-0.2,0.5C229.8,292.9,229.2,293.7,227.8,293.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M229.5,298.9c0.5-0.2,2.1-0.4,1.4,0.2C230.7,298.7,230,299.2,229.5,298.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M231.1,292.1c-0.3-0.4,1.3-0.4,1,0C231.8,292.1,231.5,292.1,231.1,292.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M231.7,298.6c-0.3-0.2,1.6-0.1,2-0.3C233.4,298.9,232.6,298.6,231.7,298.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M231.9,299c1.1-0.2,2.8,0.3,3.6,0.7C234.6,300,233.3,299.1,231.9,299z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M232,293.2c0.2-0.7,1.2,0.4,1.2-0.3c0.3,0,0.2,0.3,0.2,0.5C232.6,293.3,232.5,293.3,232,293.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M232.9,297.5c0-0.3,0.7-0.1,1-0.1c-0.1,0.4-0.1,0.2,0,0.6C233.4,297.9,233.3,297.6,232.9,297.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M234,296.7c0.2-0.3,0.8-0.6,1-0.2C234.9,296.6,234.5,296.7,234,296.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M236,297.5c0.5-0.3,1.9-0.6,2.4-0.3c-0.3,0.2-0.7,0-0.4,0.5C237.7,297.4,236.9,297.5,236,297.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M241.1,323.4c-0.2,0-0.2-0.2-0.2-0.4c0.6-0.1,0.6,0.2,1,0.2C241.8,323.7,241,323,241.1,323.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M241.6,297.7c-0.4-0.6,3.6-0.6,3,0.2c-0.2,0-0.2-0.2-0.2-0.4C243.6,297.8,242.4,297.3,241.6,297.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M244.8,324.7c0.3-0.1,0.6-0.5,1-0.3c0,0.1,0,0.2,0,0.4C245.4,324.8,245.1,324.8,244.8,324.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M247,322.8c-0.2-0.1,1.4-0.3,2.2-0.3C248.8,322.9,247.8,322.8,247,322.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M249.6,348c0.6,0,0.7,0.3,1.2,0.3C250.6,348.6,249.6,348.3,249.6,348z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M250.8,324.5c0.3-0.3,0.5-0.7,1.4-0.6C251.8,324.1,251.5,324.4,250.8,324.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M252.2,296.6c0.1-0.3,1-0.1,1.4-0.1C253.4,296.8,252.8,296.8,252.2,296.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M253.5,323.6c0-0.2,0.7-0.1,0.8-0.4c0.2,0,0.2,0,0.2,0.1c0,0.1,0.1,0.1,0.2,0.1 C254.6,323.7,253.9,323.8,253.5,323.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M257.7,348.3c0-0.1,0-0.2,0-0.4c0.5,0.1,4-0.1,1.4,0.1C258.7,348.2,258.4,348.4,257.7,348.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M258.6,352.6c0.2-0.3,1.1-0.3,1.6-0.1C260.1,352.7,259.1,352.5,258.6,352.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M261.8,323.1c0-0.5,2-0.3,2.4-0.1C263.9,323.1,262.4,322.8,261.8,323.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M263.4,352.7c0.6-0.1,0.9-0.5,1.2-0.1C264.1,352.8,263.8,353,263.4,352.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M265,353.2c0-0.1,0-0.2,0-0.4c0.3,0.1,0.9,0.1,0.8,0.5C265.4,353.3,265.3,353.1,265,353.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M266.5,296c0.2-0.3,0.5-0.4,1.2-0.4C267.6,295.9,266.9,295.9,266.5,296z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M268.4,348c-0.8-0.3,0.7-0.2,0.6-0.5c0.3,0,0.5,0.2,0.4,0.5C268.9,348.1,268.6,347.6,268.4,348z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M269.1,352.4c0-0.5,0.7,0,1.2-0.3c0,0.1,0,0.2,0,0.4C269.7,352.6,269.7,352.3,269.1,352.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M270.1,351.1c-0.6-0.2,1.4,0.1,1-0.5C272,350.8,271,351.2,270.1,351.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M272.3,353c0-0.1,0.2-0.1,0.4-0.1c0.2,0,0.1-0.1,0-0.1c0.1-0.2,0.5-0.1,0.8-0.1 C273.6,353,272.9,353,272.3,353z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M275,350.9c0-0.2,0-0.3,0-0.5c0.3,0.2,0.9,0.1,1.4,0.1C276.4,350.9,275.5,350.8,275,350.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M280,353.5c0.7-0.2,1.3-0.4,2-0.5C281.7,353.4,281,353.5,280,353.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M278.5,295.5c0.3-0.4,1.7,0,2.6,0c0.1,0.3-1.1-0.1-0.8,0.4C279.8,295.4,279.5,295.7,278.5,295.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M299.8,353.2c0-0.2,0-0.3,0-0.5c-0.1,0.3,1.2,0.5,0.6,0.1c0.3-0.4,0.5,0.2,1,0.1 C301.1,353.1,300.5,353.2,299.8,353.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M310.5,353.1c0.2-0.2,0.8-0.3,1.4-0.3C311.3,353,311.1,353.3,310.5,353.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M310.1,290.8c0-0.2,0.9,0,1-0.2c-0.1-0.1-0.4-0.2-0.6-0.2c0.3-0.4,1.1,0.1,0.8,0.5 C310.6,290.7,310.4,291,310.1,290.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M314,350.3c0.1-0.1,0.2-0.2,0-0.2c0.4-0.3,0.4,0.3,1.2,0C315.2,350.3,314.5,350.3,314,350.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M314.6,351.6c0.3-0.2,1.7-0.2,2,0C316.3,351.8,314.9,351.7,314.6,351.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M315.4,350c0.6-0.1,1.3,0,2.2,0c-0.4,0.3-1.6,0-2,0.3C315.6,350.1,315.5,350.1,315.4,350z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M325.2,354.6c0.5-0.3,1.2,0.2,1.8-0.1C327,355.2,325.8,354.6,325.2,354.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M325.2,353.4c-0.3-0.4,0.6-0.1,0.4-0.5c0.5,0,0.2,0.3,0.6,0.4C326,353.7,325.8,353.4,325.2,353.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M325.8,355.3c0.3,0.2,0.9,0.1,1.2,0.2C326.6,355.9,325.8,355.8,325.8,355.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M328.7,353.4c0.6-0.3,2.5-0.5,3-0.1c-0.1,0.2-0.5,0.3-1,0.4c0.8-0.3-1.7-0.5-1.2,0.1 C329,353.8,329.3,353.3,328.7,353.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M335.8,352.6c0-0.1,0-0.2,0-0.4c0.7-0.1,0.3,0.4,1,0.4C336.8,352.9,335.9,352.7,335.8,352.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M339.4,353.8c0.2-0.6,1.1-0.1,1.8-0.4C341.1,353.8,339.9,353.6,339.4,353.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M340.1,356.4c0-0.1,0-0.2,0-0.4c0.2,0.3,1.4-0.1,1.2,0.3C340.9,356.4,340.5,356.4,340.1,356.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M349.1,291.2c0.1-0.3,0.9-0.3,1.8-0.4c-0.1,0.2,0.2,0.2,0.4,0.2C350.8,291.2,349.8,290.9,349.1,291.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M352.4,358.8c0.3-0.2,1.2-0.1,1.6-0.3C353.8,359,352.9,358.9,352.4,358.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M369.5,291c0.1-0.2,0.5-0.3,1-0.4C370.7,291.1,370,291,369.5,291z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M388,289.7c0.1-0.1,0.5-0.2,0.2-0.2c0.9-0.3,2.2-0.2,3.2,0C390.2,289.6,389.5,289.6,388,289.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M388.5,291.3c0.4-0.3,1.1-0.4,1.6-0.7C389.9,291.2,389.4,291.2,388.5,291.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M391.6,290.4c0-0.1-0.4-0.1-0.6-0.1c0.2-0.3,1.1-0.3,1.4-0.6c0.3,0.1,0.1,0.3-0.2,0.2 c0.2,0.4,0,0.3,0.2,0.7c-0.7,0-1.2,0.2-1.8,0.4c-0.3-0.1-0.4-0.3-0.4-0.6C390.8,290,391.2,290.7,391.6,290.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M392.6,289.3c0.3-0.5,0.9-0.2,1.4-0.3c0.7-0.2-0.2-0.7,0.8,0C393.9,289.3,393.5,289.1,392.6,289.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M395.8,359c0.1-0.8,0.9,0.1,1.6-0.3C397.5,359.2,396.3,358.9,395.8,359z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M398.7,289.2c-0.2-0.2,1.5-0.2,2.2-0.3C400.4,289.2,399.6,289.3,398.7,289.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M402.7,290c0.4,0.2,0.5,0,1,0C403.9,290.5,402.5,290.5,402.7,290z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M404.7,292.1c0.3-0.2,0.5,0,1.2-0.1C406.1,292.4,404.9,292.2,404.7,292.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M410.5,361c0.7,0.2,0.9-0.1,1.6-0.1C412,361.2,410.5,361.7,410.5,361z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M409.4,304.7c0-0.1,0-0.2,0-0.4c0.5-0.3,1.2,0,1.8,0C410.5,304.5,410.2,304.7,409.4,304.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M417,300.4c0-0.2,0.3-0.3,0.8-0.2c0,0.1,0,0.2,0.2,0.2C418,300.6,417.1,300.4,417,300.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M417.6,299.8c0.3-0.2,0.7,0,1.4-0.1c0.1,0.4-0.6,0.4-1.2,0.4C417.8,299.8,417.8,299.8,417.6,299.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M419.9,296.2c0.6-0.2,0.9-0.2,1.8-0.5c0.1,0.1,0.2,0.2,0.4,0.2c0.1,0.3-0.9-0.1-0.6,0.4 C420.9,296.2,420.8,296.3,419.9,296.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M427.1,309.1c-0.1-0.7,1.3,0,2-0.4c0.1-0.5-0.9-0.3-1.4-0.2c0.2-0.9,2.1,0.4,2-0.6c0.5,0.1,0.9,0.2,1.6,0.1 c0.2,0.4-0.8,0.2-1.2,0.3c0.7,0.5-0.7,0.4,0.2,1C429.3,309,428.4,309,427.1,309.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M431.6,360.9c-0.1-0.7,1,0.1,1.2-0.5c0.4,0.2-0.6,0.7,0.2,1C432.4,361.9,432.2,360.9,431.6,360.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M437.3,359.1c1-0.3-0.6-0.6,1.2-0.7c0,0.2,0,0.4,0,0.6C437.8,359,438,359.3,437.3,359.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M438.3,360c1.1-0.2,1.4-1,2.7-1.1c0.1-0.2-0.2-0.2-0.2-0.4c-0.5,0.2-1.1,0.2-1.6,0.4 c-0.1-0.3,0.5-1.1-0.8-1.2c1-0.6,1.5,0.8,3,0.7c0,0.5,0.4,0.8,0.8,1.1c-0.4,0.3-0.8,0.6-1.4,0.9c-0.7,0-1-0.2-1.2-0.5 C439.3,360.2,439.2,360,438.3,360z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M440.6,356.3c1.4-0.1,0.1,0.7,1.4,0.7c-0.4,0.1-0.5,0.3-1,0.4C441.2,356.8,440.5,356.8,440.6,356.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M445.4,303.3c0.5-0.3,0.1-0.3,0-0.7c0.4,0,0.4-0.2,0.8-0.1C445.8,302.7,446.4,303.5,445.4,303.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M447,296.5c0.3-0.2,1.2-0.4,1,0.2C447.4,296.8,447.6,296.4,447,296.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M452.9,293.9c-0.1-0.4,1.8-0.3,2-0.1c0.5-0.1,0.4-0.5,0.6-0.7c0.5,0.2,0.7,0.7,1,1.1 c-0.4,0.2-2.3,0.1-1.8-0.2C454,293.9,453.5,294,452.9,293.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M456.2,306.8c0.3-0.3,1.4-0.1,1.6,0.1C457.5,307.2,456.7,306.8,456.2,306.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M462,309.9c0.6-0.1,1.1-0.4,1.8-0.5C463.7,310,462.7,310,462,309.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M463.6,326.6c0-0.1,0-0.2,0-0.4c0.3,0.1,1-0.1,1,0.1C464.8,326.7,464,326.5,463.6,326.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M464.8,327.5c0.1-0.3,0.5-0.4,1-0.5c0,0.4,0.7,0.4,0.2,0.7C465.4,327.8,465.6,327.4,464.8,327.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M468.8,360.7c0.9-0.1,1.2-0.3,2,0c0,0.2-0.6,0.2-0.6,0c-0.3,0.1-0.6,0.2-0.6,0.5 C469.1,361.2,468.9,361,468.8,360.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M469.2,361.3c1.3,0.6,3.2,0.1,4.2,1C472.7,362.1,469.7,362.1,469.2,361.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M471.3,317.1c0.4-0.1,1.4-0.3,1.4,0.2C472.1,317.3,471.8,317.1,471.3,317.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M475.1,359.1c0.1-0.4,0.3-0.7,1-0.7c0,0.3,0.1,0.7-0.2,0.8C475.7,359.1,475.5,359.1,475.1,359.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M474.6,321.8c1.8-0.6,4.9,0.1,5.8,1.1C478.8,322.8,477.1,321.7,474.6,321.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M482.4,326.3c0.2-0.5,0.8,0,1.6-0.1c0-0.3-0.2-0.4-0.6-0.4c0.5-0.4,1.1,0.3,1.4,0.5 c0.2,0.4-0.5,0.2-0.4,0.6C483.5,326.8,483.1,326.4,482.4,326.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M487.8,352.5c0.9-0.3,2.2,0.2,3,0.3C489.9,353.1,489,352.4,487.8,352.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M514.7,349.8c0.1-0.2,0.3-0.3,0.4-0.5c0.5,0.2,1.2,0.4,0.8,0.8C515.3,350.2,515.1,349.9,514.7,349.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M14.1,324.3c-0.3,0-0.7,0-1,0c0-0.2,0-0.3-0.2-0.4c0.3-0.1,0.3-0.4,0.8-0.4c-0.2,0.5,1.6,1,0.2,1.2 C14,324.7,14.1,324.5,14.1,324.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M48,334.8c0.9-0.3,2.7-0.2,3.2,0.2C50.4,334.9,49.1,334.9,48,334.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M58.2,332.7c-0.4-0.1-0.6-0.3-1.2-0.2c0.2-0.3,0.4-0.8-0.6-0.7c0.6-0.2,1.3-0.3,1.8-0.5 c-0.2,0.5,0.7,0.9-0.4,1c0.1,0.4,0.5,0.2,1,0.1C59.4,332.4,58,332.3,58.2,332.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M68.4,337.8c-0.1-0.7,1.6-0.9,1.8-0.4C68.5,337.3,69.4,337.5,68.4,337.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M71.1,333.3c0,0.4-1.3,0.3-1.6,0.1c0.1-0.2,0.3-0.2,0.4-0.4C70,333.3,70.2,333.4,71.1,333.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M95.8,338.7c1.8,0.2,4.1,0.4,5.3,0.2c0.7,0.9,4-0.3,4.4,1c0.8,0,0.3-0.7,1.2-0.6c0.6,0.2,1.1,0.4,1.8,0.6 c0.6-0.4,1.7-0.2,2,0.2c-0.3,0-0.2,0.2-0.4,0.2c-0.8-0.4-2.8-0.3-3.6,0c1.4,0,3.3,0.3,4.5,0c-0.2,0-0.6,0-0.6-0.1 c0.6,0,0.6-0.3,1.2-0.3c0.1,0.3-0.6,0.4,0.2,0.4c0.3-0.1,0.4-0.3,0.8-0.4c1.3,0.3,3.3,0.5,4.6,0.2c1.8,1,5.6-0.3,6,1.3 c1.6-0.3,3.2-0.3,4.8,0.2c0.4,0,0.1-0.4,0.6-0.4c1.6,0.7,4-0.4,5.9-0.1c-0.1,0.5-2-0.1-1.4,0.5c2.8-0.5,5.1,0.5,7.3,0.4 c-0.1,0.3-0.9,0.1-0.8,0.5c0.6,0,2,0.2,2.8,0c0.1,0.2,0.3,0.2,0.2,0.5c1.5-0.3,2.7,0.2,4.4,0.4c0.3-0.3-0.5-0.4,0-0.5 c0.4,0,0.8,0,1.2,0c-0.3,0.2-0.2,0.5,0.2,0.5c1.7-0.2,3.8,0.1,5.3-0.4c-0.6,0.5,0.5,0.1,0.6,0.1c0,0,0,0.2,0,0.2 c3,0.5,9.1-0.7,10.5,0c-0.3-0.3,0.9-0.8,1.6-0.4c0.2,0.3-0.4,0.2-0.4,0.5c4.8-0.3,10,0,15.6-0.1c-0.2,0-0.4,0-0.4-0.1 c2.6,0.1,3.7,0.5,5.9,0.2c2,0.2,5.7,0,6.7,0.1c-0.2-0.1-1.1-0.2-0.6-0.4c2.1,0.8,4,0.7,6.9,0.7c0.2,0.6,2.4,0.6,2.4,0 c-0.6-0.1-1,0-1.2,0.3c-0.3-0.2-1,0-0.8-0.5c1,0,4.2-0.2,2.6,0.3c3.1-0.5,4,0.4,6.7,0.1c0.5,1.2,4.2,0.2,4,0.8 c0.7-0.3,1.8-0.3,2.6,0.2c-1.7,0.3-2.9,0.1-3.9,0.4c0.7,0,1.2,0,1.4,0.2c0.9-0.4,1.8-0.4,2.6,0c0-0.5,0.8-0.1,1,0 c0.2-0.4-0.6-0.1-0.4-0.5c1.3-0.2,2.9,0,4.2,0.3c-0.4,0-0.7,0.1-0.8,0.2c1.1-0.2,2.4,0.4,2.6-0.3c-0.4-0.1-1.3,0.2-1.4-0.1 c1.4-0.2,2.5-0.1,3.4,0.2c-0.3,0-1.4,0-0.8,0.1c0.9,0.1,1.2-0.2,1.8-0.3c2,0.9,3.5,0.5,5.6,0.8c0.3-0.4,1.5-0.3,2.4-0.4 c0,0.2,0.1,0.3,0.2,0.4c0.1,0.3-0.8,0.1-0.6,0.5c0.8,0,2.6-0.2,3.8,0.3c0.5-0.3,2.9-0.6,3.2,0.2c-1.4,0.1-2.6,0.3-3.4,0 c-0.2,0.4-4.1-0.2-3.7,0.5c-0.2-0.2-0.3-0.4-0.8-0.4c-0.3,0.2-0.9,0.4-1.4,0.7c0.1-0.9-1.2,0.4-1.4-0.3c-0.6-0.1-0.4,0.3-0.8,0.4 c-0.5-0.1-0.8-0.4-1.4-0.5c-4.5,1-9.6-0.1-14,0.3c1,0.1,2.3,0.1,2.8,0.5c-0.3,0-1-0.3-1.2,0c0.3,0.1,1,0,1.2,0.2 c-1.1,0.2-1.8-0.4-2.2-0.2c1.1,0,0,0.5,0,0.5c0.4,0.2,1-0.1,1.6,0.3c0-0.2-0.2-0.3-0.2-0.5c0.4,0,0.4,0.3,0.8,0.4 c2.7-1.2,7-0.2,10.3-0.8c0.2,0.6,0.9,0.3,0.8,0c0.9,0.2,1,0.4,1.4,0.7c0.8-0.8,3.2,0,4.3-0.5c1.2,0.7,4-0.1,5.3-0.1 c-0.2,0-0.2-0.1-0.2-0.2c0.7-0.1,1.1-0.2,1.6,0.1c-0.5,0.3-0.4-0.2-1-0.1c1.4,0.8,3.7,0.2,5.8,0.4c0.3-0.2,0.8-0.3,1.2-0.4 c0.4,0.3,1.5,0.2,2.4,0.2c0.1-0.3,0.5-0.6,1.4-0.5c-1-0.8-2.9-0.6-4.2-0.4c0.7-0.5-0.4-0.5,0.4-0.8c0.6,0.7,3.7,0.2,4.6,0.3 c-0.4,0-0.9,0-0.8-0.4c0.6,0,1.7-0.3,2.2,0c-1-0.1-0.8,0.4-1.4,0c0.4,0.4,0.9,0.7,1.6,0.8c0.1-0.4-0.7-0.1-0.4-0.6 c0.2,0,0.2-0.1,0.4-0.1c0.3,0.3,2.2,0.1,1.6,0.6c1.4-0.2,3.6-0.1,4.2,0.6c2.4-0.3,4.3-0.7,6.7-0.4c0,0.2-0.1,0.4,0.2,0.5 c0.1-0.3,0.7-0.3,1-0.5c0.1,0.4,0.5,0,0.6,0.2c-0.3,0-0.2,0.3-0.4,0.4c0.5,0,0.8,0,1,0.1c0.1-0.4-0.7-0.1-0.4-0.6 c0.5,0,0.6-0.2,1-0.2c0.8,0.4,2-0.4,3.4,0.1c-0.1,0.2-0.3,0.2-0.2,0.5c0.7,0,0.7-0.5,1.4-0.6c0,0.2-0.3,0.2-0.4,0.4 c1-0.9,3.3,0.1,4,0.1c-0.2,0-0.5-0.2-0.2-0.2c3.2,0.2,5.9-0.1,8.9-0.1c0,0.1-0.3,0.2,0,0.2c1.3-0.1,8.2-1.5,6.9-0.1 c0.2,0,0.4,0,0.4,0.1c-0.2,0-0.6,0-0.6,0.1c0.6,0.2,1.7-0.2,2.6-0.3c0.2,0.2,0.3,0.4,0.6,0.5c1.4-0.9,2.5,0.4,4,0.1 c0.1,0.3-0.8,0.1-0.6,0.5c2-1,5.5-0.2,8.3-0.6c0.1,0.3-1.1-0.1-0.8,0.4c2.1-0.4,5.9,0,8.5-0.3c-0.6,0.4,0.7,0.2,0.8,0.5 c-1.7,0.8-3.6,0.1-5.9,0.8c0.1,0.2-0.2,0.6,0.2,0.6c0.6-1.1,3.1-0.5,4.7-0.9c0.1,0.2,0.6,0.1,0.4,0.5c1.5-0.7,4.6-0.6,6.9-0.2 c0.6-0.5,1.9,0.1,3-0.3c-0.4,0.2-0.3,0.7-1,0.7c-0.2-0.3,0.6-0.5-0.2-0.5c-0.2,0.9-2.8,0.3-3.3,0.6c0.5,0-0.3,0.2,0,0.5 c0.8-0.3,1.6,0,2.4-0.4c0.4,0.4,2.1,0.7,1.2,0c0.7,0.7,2.3,0.1,3,0.7c-2.2-0.1-2.9,0.5-4.5,0.5c0.9,0.4,1.5,0.2,2.4,0.2 c0,0.2-0.1,0.3-0.2,0.4c2.9,0,4.8-0.1,6.9,0.7c0-0.1,0-0.3,0.2-0.4c1.3,0.5,3.6,0.3,5,0.2c-0.2,0-0.5,0-0.4-0.2 c0.9,0,1.9-0.1,2,0.3c0.5,0,0.2-0.5,0.8-0.5c0.6,0.3,0.9,0.7,1.6,0.9c-0.6-0.5,2.7-0.7,1.8,0.1c1.2,0.1,1.9-0.3,2.8,0.3 c0.4-0.2,0.7-0.5,1.2-0.6c-0.2-1.1,0.3-1.3,0.1-2.2c-1,0.3-1.8,0.4-2.2-0.3c-0.2,0.3-1.8,0.3-2.2,0c-1.3,0.8-3.2-0.2-5.3-0.1 c0.1-0.6-0.7-0.1-1-0.6c0.7-0.1,1.3-0.2,2-0.3c-0.3,0.4,0,0.5,0.4,0.7c0.3-0.4,1.3-0.3,1.6,0c0.2-0.5-0.8-0.2-1-0.5 c0.8-0.2,1.7-0.3,2.4-0.5c0.4,0.7,1.9,0.6,2.8,0.3c0.4,0.3,0.4,0.3,0,0.6c1.8-0.5,4.1-0.4,5.3,0.1c0.5-0.9,2.1,0.3,2.8,0 c-0.3-0.1-0.5-0.2-0.6-0.4c0.6,0.1,0.6-0.2,1.2-0.1c0,0.5,0.7,0.4,1.2,0.6c0.2-0.2-0.6-0.4,0-0.5c1.7,0.1,2.3,0.2,3.6-0.2 c0.2,0.4,0,0.7,1.2,0.7c0-0.2,0-0.4,0.2-0.5c-0.5-0.2-0.8,0.4-1,0c1.1-0.2,2,0.5,3-0.3c0.3,0.1,0.8,0.1,0.6,0.5 c-0.4,0-0.2-0.5-0.8-0.4c0.3,0.6-0.8,0.6-1.4,0.6c1.3,0,2.1,1.3,2.6,0.5c2,0.3,3.3,0.8,5.4,1.1c0,0.2-0.3,0.2-0.4,0.4 c1,0.2,1.7-0.6,1.8,0.1c-1,0-2.1-0.1-2.6,0.3c0.4,0,0.7,0.1,0.8,0.2c-0.9-0.3-0.2,0.5-1.8,0.3c0.2,0.5-0.6,0.4-0.6,0.7 c0.5,0.2,1.3,0.1,1.6,0.5c-1.5,0.4-2.5,0.3-3.4-0.2c0.3-0.1,1,0.1,1-0.1c-1.1,0.1,0.7-0.4-0.4-0.4c-0.6,0.5-1.3,0.5-2,0.7 c0.4-0.5-0.9,0.3-1.2-0.3c-0.3,0.1-0.4,0.4-0.8,0.5c-1.6-0.7-4.6-0.6-6.2-0.8c0.3,0.1,0.9,0.1,0.8,0.5c-0.2,0-0.2,0.1-0.4,0.1 c-0.6-0.5-1.9,0.1-2.2-0.6c-1,0-1,0.1-1.6-0.1c-0.2,0.3,0.1,0.6-1,0.5c0.1-0.2,0.5-0.2,0.6-0.5c-1.6,0-4.4,0.4-5.4-0.2 c-2.5,1.9-6.6-0.7-8.7,0.7c0-0.2-0.3-0.1-0.4-0.2c0.5,0.1,0.7-0.1,0.6-0.4c-1,0-1,0-2.4-0.2c0.3,0.7,1.8,0.6,2.4,1.1 c-0.4,0.2-1.4,0.1-2.2,0.1c0.3,0.3,2,0.3,2.6,0.3c0,0,0.1-0.4,0.4-0.4c0.3,0,0.5,0.3,0.8,0.4c1.3,0.1,3.2-0.5,4,0.2 c-0.7-0.1-1,0.1-1.2,0.4c3.3-0.3,5.3,0,9.1-0.1c0,0.1-0.2,0.1-0.2,0.2c1.3-0.3,2.7,0.2,4.1-0.4c0,0.2-0.3,0.2-0.4,0.4 c0.8-0.1,1.5-0.3,2.2-0.5c-0.4,0.3,0.7,0.4,0.8,0.7c0-0.3,0.2-0.4,0.6-0.4c0.4,0.2-0.2,0.3,0.2,0.4c1-0.2,2.2-0.2,3-0.5 c0,0.2-1,0.4-0.4,0.6c1.2-0.6,4.6,0.2,5.7,0.3c-0.6-0.1,0.6-0.4,0.8-0.1c0.3-0.3-0.8-0.4-0.2-0.5c0.3,0.5,1.6,0.1,1.8,0.3 c0.3,0.4-0.7,0.1-0.6,0.4c0.8,0.3,1.7,0.5,2.8,0.6c-1.8,0.5-5.5-0.4-8.1,0.6c0.2,0.3,0.9-0.1,1.2-0.1c0.2,0.8,0.7,0.1,1.2,0.3 c-0.5,1-2.1,0-3,0.3c0.2,0,0.5,0,0.4,0.2c-0.2,0-0.2,0.1-0.4,0.1c-1.2-0.1-3.4-0.5-3.6,0.2c-1,0-1.7-0.9-2.6-0.6 c1,0.2,2,0.5,2.4,1.1c0,0.2-1.4,0.1-0.8,0.2c1.4-0.4,2-0.3,3.4-0.4c-0.2-0.2-1,0-0.8-0.4c0.6,0,1.5-0.1,1.6,0.2 c-0.6,0.2,0.3,0.6,0.4,0.4c-0.5-0.1,0.2-0.4,0.4-0.5c0,0.2,0.5,0.1,0.8,0.1c0,0.2,0.1,0.4,0.2,0.5c0.6,0,0.9-0.2,1.4-0.3 c2.5,0.6,6.1-0.7,8.5-0.3c-0.1,0-0.2,0-0.2,0.1c0.4-0.5,1.6-0.1,1.6-0.5c0.2,0.1,1.3,0.3,1.4,0.1c-0.1-0.2-0.9,0-1-0.2 c0-0.1,0.2-0.2,0.4-0.2c0.5,0.3,0.6,0.2,1.2,0c0.2,0.1,0.4,0.2,0.6,0.4c1.2-0.2,1.8-0.2,3-0.3c0,0.2-0.1,0.3-0.2,0.4 c0.5-0.1,1-0.1,1.4,0.1c-0.6,0.1-1,0.4-1.4,0.6c0.9-0.2,2.3-0.1,2.6-0.6c-0.4-0.1-0.8,0.4-1,0c0.6-0.1,1.1-0.3,1.6-0.5 c0,0.2,0.2,0.3,0.6,0.2c-0.4,0.3,0.2,0.7,0.6,0.8c0.1-0.4-0.4-0.5-0.4-0.8c0.9,0.1,0.2-0.2,0.6-0.2c1-0.1,1.1,0.4,2,0.5 c-0.2,0.4-1,0.4-1.4,0.7c1.1,0.1,1.2-0.5,2.2-0.5c0,0.3-0.4,0.4,0.2,0.5c1.2-0.8,3.8-0.5,5.3-0.7c-0.3-0.3-0.6,0.2-0.8-0.1 c0-0.2,0.4-0.1,0.6-0.2c0.1,0.3,0.8,0.2,0.6,0.7c1.1-0.4,2.3-0.1,3.8-0.3c0.2,0.2,0.5,0.9,1,0.5c-0.2,0-0.5,0-0.4-0.2 c0.8-0.1,1.4-0.1,2.8-0.1c0.1,0.8,1.8,0.8,2.6,1.2c0.4-0.2-0.3-0.3,0.2-0.4c2,0.6,3.3,0.5,6,0.8c-1.3,0.2,1.2,0.2,0.4,0.5 c0.9-0.3,2.4-0.5,3-0.3c-0.3,0.1-0.3-0.6,0-0.5c0.4,0.2,0.1,0.4,0.8,0.2c-0.1,0.4,0.1,0.7,0.6,0.7c0.3-0.1,0-0.5,0.4-0.5 c0.6,0.2,0.8,0.1,1.2,0.2c-0.3,0.1-0.5,0.2-0.6,0.4c0.7-0.1,0.3,0.2,0.2,0.4c0.6,0.1,1.2,0.2,1.6,0.5c0-0.6-0.5-0.9,0-1.3 c-0.6-0.1-0.6-0.5-0.8-0.8c2.9-0.1,6.8,0.3,9.3,1.2c-0.4,0.4-0.4,0.7,0.2,1.1c1.1-2.3,5,0.3,7.5-0.7c0.3-0.7-0.2-0.7-0.2-1.4 c1.6,0.1,1.9-0.5,2.5-1c1.2-0.2,1.7-0.1,3-0.3c0,0.1,0.1,0.3,0.4,0.2c0.5-0.1-0.5-0.2-0.2-0.6c1.3-0.1,1.6-1.2,2.9-1 c-0.4-0.7,0-1.1,0.2-1.3c0,0.2,0.6,0.1,0.6,0c-0.3,0,0-0.2,0.4-0.1c-0.4,0.2,1,0.9,1.2,0.3c-0.7-0.2-2-0.4-1.4-1.1 c-0.7,0.1-1-0.1-1.2-0.3c0.2-0.2,0.5-0.3,0.8-0.5c-0.2-0.3-0.6-0.4-0.8-0.6c0.9-0.4,3.1-0.7,4.2,0.1c0.8-0.2,1.6-1.2,2.4-0.4 c-0.3,0-0.9,0.3-1.2,0.6c0.8,0,1.8-0.8,2.4-0.1c-1.6,0.8-4.2,1.3-6.5,1c1.5,0.7,4.2,0.1,6.1-0.4c0.8,0.3,2.7,0.1,3.8-0.3 c0.5,0.1,0.5,0.4,1,0.5c1.5-0.1,4.9-1.2,4.8,0.2c0.7,0.2,0.1-0.4,0.6-0.4c0.3,0.1,0.7,0.2,0.6,0.6c-1.9,1.1-4.6,1.7-6.7,2.7 c0.5,0.3,1.4,0.4,1.4,1.1c4.4,0,5.9-2.9,10.4-2.9c-0.7-1.1,1.2-1.6,0.1-2.6c0.3,0,0.6,0,0.8-0.1c-0.2-1-0.6-1.6,0.3-2.3 c0-0.2-0.6-0.1-0.6-0.2c0.7,0,0.5-0.5,0.8-0.7c-0.1-0.2-0.8,0-0.8-0.2c-0.9-2.7-2.1-4-3.9-6.8c-1.6-0.6-2.3-1.7-3.8-2.2 c0.5-0.5-1-1-0.4-1.6c-0.5,0-0.7,0-0.8-0.2c0.5,0,0.7,0,0.8-0.2c-1,0.1-0.4-0.6-0.4-0.6c-0.6-0.9-2.2-1.7-2.6-2.7 c2.1-0.5,4.2,1.1,5.9,0.4c0.7,0.3,1.9,0.4,2,1.1c-0.6,0-1.2,0.1-1.2,0.5c1.4,0.4,2.8,0.8,4.8,0.9c0.3,1.1,2.9,0.7,4.4,1 c0,0.2-0.5,0.2-0.4,0.5c2.1-0.2,4.8,0,6.9,0.4c0.8,1.4,5.3,1.1,5.4,2.5c1,0.1,2,0.2,2.4,0.7c-0.3,0.6-1,0.9-0.7,1.8 c0.5,0.6,2.2,0.6,3,1.1c0.1-0.4,1.2-0.8,2-0.5c-0.1,0.2-0.6,0.3-0.8,0.5c0.8,0.7,0.6,1.3,1.2,2c0.7,0,1.7-0.2,1.8,0.3 c-0.4,0.1-0.8-0.3-1,0c0.6,0,0.6,0.4,1.2,0.5c0-0.8,0.8,0,1.2,0c0.6-0.3-0.1-0.6,0.4-1c2.5-0.1,4.3,2.2,6,1 c-0.3-0.2-0.9-0.1-1.4-0.1c-1.3-1-3.1-1.7-4.8-2.5c0.1-0.2,0.3-0.2,0.2-0.5c-0.7,0.1-1,0.3-1.8,0.4c-0.3-0.2-0.6-0.5-1.4-0.3 c0.8-0.6-0.6-0.5-0.6-1c0.6-0.2,0.6-0.2,0.4-0.7c0.4,0,0.2-0.3,0.8-0.2c1.8,0.3,3.8,0.7,6.2,0.7c-0.9-0.8-2.8-0.9-4.2-1.4 c0.3-1.1-0.5-1.4-1.6-2.1c-0.6-0.1-0.1,0.4-0.8,0.2c-0.6-1.2-2.5-2.1-2.1-3.6c2.5,0.1,2.4-1.3,4.9-1.2c0-0.5,0.8-0.6,1-1.1 c-0.1-0.2-0.4-0.3-0.6-0.5c0.1-0.3,0.6-0.4,1-0.6c0.6-1.6-2-1.2-2-2.4c1.7-0.3,4.3-0.2,5.5-0.8c-0.8-0.1-1.1-0.9-0.4-1.2 c-1.1-0.4-1.3-1.3-2.4-1.7c-1.9,0.6-1.8,2-4.1,2.6c-1.3-1.9-7.1-1.6-9-2c0.3,0,0.4,0.2,0.4,0.4c-1,0.1-1.4-0.1-2-0.2 c0.2,0.5-1,0.2-1.2,0.5c0.3,0.1,0.6,0.2,0.6,0.5c-3.1,0-4.8,0.7-7.9,0.9c0,0.1,0,0.3-0.2,0.4c-4.2-0.1-7,0.5-10.9,0.8 c0,0.1,0,0.3-0.2,0.4c-0.8-0.2-1.9-0.2-2.4-0.2c0.2,0,0.2,0.1,0.2,0.2c-3.1-0.2-7.1,0.5-7.8-1.2c0.3,0.1,0.5,0.1,0.6-0.1 c-0.6-0.2-1.6-0.6-1-1.1c-1,0.2-1.7-0.5-1.2-0.9c-0.1-0.2-0.3-0.2-0.2-0.5c-0.6-0.1-0.4-0.1-0.8,0.1c0-0.2-0.1-0.3-0.2-0.4 c0.3,0,0.7,0,0.6-0.2c-1.3,0.1-0.3-0.5-0.8-0.8c-0.8,0.1-0.5,0.8-1.6,0.6c0.5-0.3-0.1-0.5,0-0.8c0.1,0,0.8,0.3,0.8,0 c-0.5,0-0.3-0.4-0.6-0.6c-0.3,0-0.6,0-0.8,0.1c0.7-0.4-1,0-0.6-0.6c1.3,0.3,2.4,0.1,3.8-0.2c0.5,0.8,2.9,0.5,3.4,1.3 c-0.2,0.1-0.4,0.1-0.6,0.2c0.4,0.1,0.5,0.4,0.8,0.6c2.2-0.2,2.5,1.8,4.8,1.9c0-0.6,1-0.7,2-0.5c0-0.6,0.6-0.5,1.4-0.4 c-0.5-1.1,1.7-1.3,0.9-2.2c0.3,0.2,0.7,0.2,0.8-0.1c-0.2-0.2-1,0-0.8-0.4c0-0.2,0.5-0.1,0.8-0.1c-0.1-1.3-2.4-1.2-3.2-2 c3.1-0.7,4.6,1,7.1,0.7c0,0.2,0,0.3,0,0.5c2.4,0.4,2.3-1.6,4.3-1.4c1-0.7,2.4-1.3,4.1-1.6c-0.2-0.2,1.2-0.4,1.4-0.7 c3.3,0,0-2.3,0.5-3c-0.6-0.5-1.5-0.8-1.8-1.4c0.7,0,0.6-0.2,0.2-0.4c0.3,0,0.5,0,0.8,0c-0.1-0.8,0.6-0.8-0.2-1.2 c-1.9,0.4-3.7-0.1-4.6-1.2c0.3,0,0.1-0.3,0.6-0.2c0.2-0.5-1-0.3-1-0.7c1.4,0.2,1.5,1.1,2.8,1.3c-0.2-0.3,0.3-0.3,0.2-0.6 c-0.4,0-0.4,0.1-0.8,0.1c0.4-0.2-0.4-0.4-0.4-0.7c-0.9,0-0.7-0.2-1.6-0.3c-0.1,0.2-1.2,0.4-1.4,0.1c1.2,0-0.3-0.3,0.6-0.5 c-1.7-0.2-2.2-0.5-3.2-0.4c0.7-0.2,1.1-0.4,1.2-1c-0.5,0.1-0.4-0.2-0.6-0.4c-2.5-0.2-3.6-1.4-6.6-1.6c0.8-0.7,2.6-0.3,4.5-0.5 c0.3-0.4,0.9-0.6,0.8-1.2c-2.1,0.1-4.8-0.8-7.1-0.1c-1.3-0.7-4.4,0.4-6.7,0.2c-0.9-0.1-3.1,0-3.5,0.8c-2.8,0-5.7,0.4-9.3,0.4 c-0.2-0.3,0.6-0.5-0.2-0.5c-1,0.6-3.3,0.3-4.3,0.6c3.4,0.1,6.3,0.3,9.7,0.3c0,0.2,0.3,0.2,0.4,0.4c-2.1-0.2-4.9,1.6-4.5,0.6 c-0.2,0.2-1.1-0.3-1.8-0.2c-0.5,1.1-2.1,0-3.4,0.2c0.1,0.3-0.8,0.1-0.6,0.5c0.1,0.4,0.8,0.3,0.8,0.7c-1.2,0.8-2.5,0.3-4.3,0.4 c-0.1-0.2-0.2-0.2,0-0.4c-0.5,0.1-1.9,0.4-1.8-0.2c1-0.2,0.3,0,1,0.1c0.4-0.4,0-0.7-0.6-0.8c0.6-0.2,0.5-0.9,1.4-1 c-0.4,0-0.7-0.1-0.8-0.2c0.1-0.3,0.7-0.3,0.8-0.6c-0.7,0.1-1.7,0.1-2.6-0.2c0,0.6-1.2,0.4-1.6,0.4c0.2-0.3,0.8-0.4,1.4-0.3 c-0.4-0.5,0.8-0.2,0.6-0.6c-0.8-0.2-2.9,1.3-4,0.3c1.8,0.2,2.1-0.5,3.1-0.7c0.6-1.6-1.8-1.1-3-1.7c-1.7,0.2-4.2-0.5-5.5-0.1 c0.6,0.1,2-0.1,2.2,0.6c-0.4,0.6-1.2-0.3-1.4,0.3c0.9,0.2,1.2-0.1,1.6,0.3c-0.3,0-0.2,0.2-0.4,0.2c-0.8-0.1-1.7-0.5-1.6-0.8 c0.1,0.4-0.6-0.3-0.6,0.1c0.3,0.1,0.3,0.4,0.4,0.6c1,0,1.6,0.1,1.8,0.6c-1.4,0.6-2.6,0-3.7,0.8c-0.2-0.3-1.4-0.5-1.8-0.2 c0.4,0,0.5,0.1,0.4,0.4c-2.9-0.5-4.5-0.4-7.1-0.5c0.7-0.4,1.1-0.2,2-0.4c-0.4-0.2-1-0.2-1.2-0.6c0.7-0.3,1.2-0.5,1.2-0.9 c1.1-0.1,1.8-0.5,3-0.3c-0.4-0.5-1.4-0.2-2-0.1c0-0.1-0.2-0.1-0.2-0.2c0.9-0.7,0.5-1.2,0.1-2.2c4.1-0.7,7.4,0.7,11.5,0 c1.5,0.1,3,0.8,5.2,0.6c-0.1,0.3,0.4,0.3,0.2,0.6c1.7-0.3,3.4,0,4.6,0.4c0.2-0.8,1.7,0.2,2.4-0.1c0.1,0.2,0.2,0.2,0,0.4 c1.5-0.8,2.5,0.7,4.4,0.3c-0.8-0.1,0.7-0.7-0.8-0.6c-0.3,0.3,0.5,0.4,0,0.5c0-0.7-1.6-0.6-2.2-1.2c-1.1,0.7-2.2,0-3.8,0 c-0.2-0.2-0.5-1-1-0.6c0.8-0.1-0.1,0.4-0.2,0.6c-1.1,0-2.2-0.4-3.2-0.4c0.3-0.6,0.3-0.4,1.2-0.3c0-0.4-0.2-0.3,0-0.7 c-0.9-0.1-1,0.2-1.4,0.4c0.3-0.8-2.3-0.3-3-0.7c0,0.3-0.2,0.4-0.6,0.4c0.1-0.2,0.2-0.2,0-0.4c-3.8,0.1-7.2,0.5-10.7,0.2 c-1.1,0.4-4.5,0.8-4.4-0.4c-4.1-0.6-8.4,0-12.9-0.4c-1.5,0.6-3.4,0.5-4.7,0.3c0.2,0-0.4,0.3-0.8,0.1c-1.4-0.6,1-0.9,2.2-0.9 c-1,0.1,0-0.8,0.2-1.1c2.2-0.3,4-0.3,5.9-0.7c0.5,0,0.6,0.4,1.2,0.3c0.8-0.5,1.8,0.2,2.8,0.1c0.6-0.1,1-0.6,1.6-0.6 c0.6,0,1.2,0.5,1.8,0.5c0.3,0,0.9-0.2,1.2-0.3c0,0-0.1,0.2-0.2,0.2c0.6,0,0.9-0.3,1.4-0.4c0.1,0,0.2,0.3,0.2,0.4 c0.7,0.2,1.6-0.4,2.4-0.5c0.6,0.3-0.7,0.6,0.2,0.6c0-0.4,0.9-0.3,1.2-0.6c0.6,0.7,2.2-0.1,2,0.6c1.3-0.2,3.7-0.5,4.9-0.5 c-0.2,0-0.2-0.2-0.2-0.4c1.5,0,2,0,2.8-0.3c0,0.1-0.2,0.1-0.2,0.2c2.2-0.1,4.1-0.2,5.5-0.1c0.2-0.2,0.3-0.4,0.6-0.5 c0.5,0.3,0.6,0.2,1-0.1c0.4,0.2,0.2,0.7,0.8,0.5c-0.7-0.3,0.8-0.4,1.2-0.5c0,0.2,0.5,0.1,0.4,0.5c0.1,0.3-0.6,0.1-0.6,0.4 c1.3,0,1.3-0.4,1.4-1c-0.5-0.2-1.3-0.2-1.8-0.3c-0.4,0.7-2.5,0.3-3,0c0.3,0,0.2-0.2,0.4-0.2c0,0.1,0,0.3,0.2,0.4 c1.1-0.8,2.4-0.3,3.9-0.3c-0.5-0.5,0.4-0.4,0.4-0.8c-1.6,0-3.1,0.1-4.6,0c0.6,0.2-0.6,0.4-0.8,0.5c-0.4-0.2-1.5-0.5-1.8-0.3 c0.2,0,0.2,0.2,0.2,0.4c-0.8-0.5-2-0.3-3.2-0.5c1.2,0.1,0.7-0.2,1.6-0.4c-0.9-0.2-1.4-0.3-2,0.1c0-0.1,0-0.2,0-0.4 c-1.8,0.4-4.8-0.3-7.1,0.1c0-0.1,0-0.3-0.2-0.4c-2.1,0.5-5.1-0.3-6.1,0.2c-0.1-0.4,0.9-0.6,1.4-0.4c-0.2-0.8-1.3-0.2-1.8-0.1 c0,0,0-0.2,0-0.2c-0.8,0.1-1.1,0.7-2,0.7c-1.1,0.1-1.4-0.5-2.8-0.3c0.4,0.6-1.5,0-2,0.4c2.1,0-2.4,0.6-2.4-0.2 c0.7,0,0.7-0.3,1.2-0.4c-1.1,0.1-0.6-0.1-0.8-0.6c-0.9,0.1-1-0.2-1.6-0.2c0.1,0.4,0.9,0.3,1.2,0.6c-0.3,0-0.4,0.1-0.6,0.1 c-0.5-0.1-0.8-0.7-1.2-0.2c0-0.2-0.1-0.4-0.2-0.5c3.2-0.3,4.3-0.5,7.3-0.1c1.8-0.4,3.7,0.4,5.5-0.3c0,0.2,0.7,0.1,0.6,0.4 c2.5-0.4,5.1,0.9,7.1-0.1c-0.6,0-1.4,0.1-1.4-0.2c0.6,0,3.4-0.4,2.8,0.5c0.5-0.1,0.9-0.2,1.6-0.1c0.3-0.5-1,0-1-0.4 c0.9-0.1,2.9-0.3,3.6,0.3c3.6-0.1,6.3-0.3,8.7,0.4c0.1-0.6,0.4,0.3,0.8,0.2c0.5-0.2-0.2-0.6,0.2-0.6c0.2,0,0.2-0.1,0.4-0.1 c0.8-0.1,0.7,0.3,1.2,0.3c0.2-0.3,1.2-0.2,2-0.3c0.2,0.9,1.6,0.3,2.4,0.3c3.2,0.1,7.5,0.5,10.1,0.4c-2-0.3-2.7,0-4.4-0.6 c-2.3,0.5-5.3-0.2-7.9,0c0-0.3-0.3-0.4-0.4-0.6c0.2-0.2,0.7-0.2,1-0.4c-0.8-0.3-2.9,0.5-4.2-0.2c-0.1,0.4-0.7,0.2-1.2,0.1 c-0.6,0.8-3.6,0.8-4.7,0.6c0-0.2,1.8,0,1.2-0.3c-0.6,0-1.2,0-1.2-0.3c0.3-0.1,1.2,0.1,1.2-0.1c-0.6-0.2-1.9,0.1-1.6-0.7 c-0.8-0.1,0.3,0.5-0.6,0.5c0-0.1-0.2-0.1-0.4-0.1c-0.3-0.5,0.3-0.6,0.6-0.8c-0.9-0.3-0.9,0.2-1,0.4c-0.6-0.3,0.5-0.5,0-0.7 c-0.9-0.2-1.8-0.2-2.2-0.2c0.2,0,0.3,0.1,0.4,0.2c-0.4-0.1-0.8,0.4-1,0c0.2,0,0.6,0,0.6-0.1c-1.1-0.3-2.9,0-3.6-0.6 c-0.5,0.2,0.4,0.4-0.2,0.5c-1.1,0.2-1-0.4-1.8-0.5c-0.1,0.2,0.2,0.6-0.2,0.6c-0.7,0-1.9,0.2-1.8-0.3c0.2-0.1,1.5-0.1,1-0.2 c-1.1,0.2-1.9,0-2.4,0.5c-0.8-0.1,0.1-0.6-0.6-0.7c-0.3,0.1,0,0.5-0.4,0.5c-0.3-0.2-2.4-0.7-1.4-0.2c-0.8-0.1-1-0.1-2.2-0.1 c0,0.2,0.1,0.4-0.2,0.5c-3.3-0.4-6.2,0.2-9.1-0.2c-0.1,0.2,0.3,0.3,0,0.4c-1.1-0.2-2-0.3-2.8,0.1c0-0.2,0.1-0.3,0.2-0.4 c-0.8,0.2-1.9,0-2.6-0.2c0.5-0.5,1.6-0.1,1.8-0.9c-1.4,0.1-1.9,1.1-3.5,0.9c-0.3,0.3,0.5,0.4,0,0.5c-0.6-0.1-0.8-0.1-1.2,0.1 c0-0.4-0.6-0.4-1-0.6c-1.6,0.5-3.1-0.3-4.5,0.4c-3.2-0.3-7.8-0.2-10.3,0.3c-0.2-0.3-1.1-0.1-1-0.6c-1.1,0.4-1.8-0.3-2.6,0.3 c0.2,0,0.5,0,0.4,0.2c-0.5,0.1-0.5,0.1-1.4,0.1c0-0.2,0-0.4-0.4-0.4c-0.6,0.8-2.2,0-3.2-0.1c-0.1,0.2,0.3,0.2,0.4,0.4 c-0.8,0.1-2.2,0.2-2.4-0.5c0.5-0.1,0.7,0.5,1,0.1c-0.3,0-0.2-0.3-0.4-0.4c-2.1,0.7-5.1,0.5-6.5,0.4c-0.5,0-0.8,0.4-1,0.4 c-0.6,0-1.1-0.5-2.2-0.3c0.2,0-0.3,0-0.8,0c-0.2,0-2.3,0.3-2.8-0.2c-0.1-0.3,1.5-0.2,1-0.4c-0.7,0-0.9,0.2-1.6,0 c0.2,0.6-1,0.5-1.4,0.3c0.6-0.2,1.5-0.2,1.8-0.6c-1.2,0.2-3.5,0.7-3.4-0.3c0,0.1-0.3,0.2-0.4,0c0.8-0.3,0.5-0.6,1.2-0.9 c-2.5,1.1-4.6-0.6-6.9,0.9c-0.1-0.2,0.2-0.3,0.2-0.5c-0.6,0-0.6,0.4-1.4,0.3c0-0.2-0.2-0.3-0.2-0.5c-0.5,0.1-1.1,0.1-1.4,0.3 c0.9-0.1,1.3,0.2,1.4,0.6c-1.3-0.2-2,0.4-3.2-0.2c0.8,0.1,0.6-0.4,1.4-0.3c-0.2-0.3-0.1-0.8-0.8-0.7c0,0.2,0.1,0.4-0.2,0.5 c0.1-0.5-2.5-0.7-3.6-0.7c-0.2,0.5,0.5,0.3,0.4,0.7c-0.2-0.1-0.7-0.1-1.2-0.1c0.4-0.3,0.3-0.3,0.2-0.7c-0.6-0.1-0.3,0.4-0.8,0.4 c0-0.5-1-0.2-1.2-0.6c-0.9,0.4-1.1,0.1-1-0.2c-0.7,0.3-1,0.2-1.6,0.6c-0.3-0.2,0-0.2,0-0.5c-0.8,0.1-0.8,0.1-1.4-0.1 c-0.3,0.1-0.5,0.3-0.8,0.5c-0.4-0.2-0.8-0.1-0.2-0.4c-2.2-0.2-2.9,1.2-3.9,0.9c-0.1,0.9-1,0.5-1.8,0.3c-0.3,0.3,0.5,0.4,0,0.5 c-0.6-0.3-1-0.2-1.8-0.1c-0.2-0.4,0.3-0.4,0.4-0.6c-0.4,0.2-1.1,0-1.2,0.1c0.3,0.1,0.5,0.2,0.6,0.4c-0.5,0-0.6,0.2-1.2,0.1 c0-0.1,0-0.2,0-0.4c-1.7,0.7-4,0.1-4.7,0.6c-0.6,0.1-0.4-0.3-0.8-0.4c0,0.2,0.1,0.3,0.2,0.4c-0.5,0.3-2.8-0.6-1.6,0 c-0.9,0-1.2-0.5-1.8-0.2c0.5,0,0.5,0.3,0,0.4c0.3-0.2,0.1-0.4-0.4-0.4c-0.2,0.2-0.6,0.3-1,0.4c0.5-0.3-0.9-0.2-1.2-0.1 c0.2,0,0.4,0,0.4,0.1c-0.4,0.1-1.5,0.3-1.8,0c0.1-0.2,0.8,0,0.8-0.2c-0.7-0.2-0.9,0.2-1.6,0.3c-0.3-0.7-2,0.6-2.2-0.3 c1.6,0.4,2.6-1.1,3.6-0.2c0-0.7,0.7-0.3,1.6-0.5c-0.2-0.4,0.3-0.3,0.4-0.5c-0.9-0.1-0.6,0.1-0.8,0.2c-0.2-0.1-0.7,0-0.6-0.4 c0.2,0,0.6,0,0.6-0.1c-0.8,0.1-1.2,0-1.4-0.3c-1,0.3-1.8,0-4,0.2c-0.4,0.2,0.3,0.4-0.4,0.5c-2.6-0.5-4.9,0.6-6.9,0.3 c-0.4,0.4,0.4,0.7-0.6,0.7c-0.5-0.2-0.4-0.4-0.2-0.7c-1.8,0.5-3-0.2-4.9-0.1c-0.8,1-3.5,0.1-4.7,0.9c0.9-0.2,2.1-0.2,2.6,0.2 c-0.7,0.4-3.1,0.6-2.8-0.2c-1.1,0.4-2-0.5-2.4,0.3c-0.2-0.8-2.5-0.7-3.8-0.4c0.2,0-0.3-0.1-0.8-0.1c-2.6,0.1-5.8,0-8.3,0.6 c0-0.2,0-0.4-0.4-0.4c0,0.3,0,0.6-0.6,0.6c-0.1-0.3,0.5-0.4-0.2-0.4c-0.2,0.2-0.6,0.4-1,0.1c-0.4,0.2,0.3,0.3-0.2,0.4 c-0.4,0-0.7-0.1-0.8-0.2c0-0.2,0.5-0.1,0.4-0.4c-0.7,0.3-0.9,0.2-1.8,0.4c0,0.4,0.7,0,0.8,0.5c-4.2,1.6-9.4,1.2-13.8,1.5 c-0.2-0.3,1.2-0.2,0.6-0.4c-1.9,0.3-2.3,0.7-3.8,0.2c-0.7,0-0.7,0.4-1.2,0.6c-0.7-0.3-2.7,0.6-3.6-0.2c-0.1,0.4-1,0-1.4,0.4 c0-0.4-0.4-0.3-0.6-0.1c-0.1-0.7-1.1-0.2-1.4-0.6c-0.3,0.4-0.9,0.3-1.6,0.1c-0.4,0.2,0.3,0.3-0.2,0.4c-1-0.3-2.4,0.4-3-0.5 c-0.5,0.6-3.2,0.4-3.8-0.1c-0.1,0.7-2.4,0.6-2.4,0.3c-0.7,0.3-1.5,0.6-2.4,0.9c0.1-0.2,0.3-0.3,0.4-0.5 c-3.6-0.1-6.5,0.6-11.1,0.1c0,0.2-0.1,0.3-0.4,0.4c-1.4-0.9-4.5,0.8-4.6-0.7c-1,0-0.1,0.4-0.8,0.6c-2.3-0.1-3.9,0.3-5.2-0.2 c-1.2,0.3-1.8,0.2-3.4,0.5c-0.1-0.3,0.6-0.1,0.6-0.4c-1.9,0.1-2.9,0.4-4.4-0.2c0.1,0.6-1,0.4-1.2,0.9c1.1,0,2.4,0,3,0.7 c-0.9,0.2-1.2-0.4-1.6-0.1c2,0.8,3-0.1,5.3,0c0,0.2-0.1,0.3-0.2,0.4c0.8,0.2,1.7-0.1,2.4-0.3c3.8,0.7,8.3-0.7,11.9,0.2 c1.2-0.6,3.3-0.5,5.1-0.6c-0.3,0.6-2.3,0.2-2.6,0.7c1,0,4.9-0.4,4.4,0.4c0-0.3-0.1-0.7,0.4-0.7c0.5-0.1,0.4,0.2,0.8,0.2 c0.3-0.7,3.6-0.3,4.7-0.3c-0.2,0-0.2-0.1-0.2-0.2c0.4,0.2,1.7-0.5,2.4,0c-0.5,0-0.7,0-0.8,0.2c0.8,0.4,0.7-0.5,1.6-0.4 c0.1,0.3-0.6,0.1-0.6,0.4c1.7-0.2,4.7,0.1,6.1-0.2c0.2-0.4-0.6-0.1-0.4-0.5c0.3,0.1,1-0.2,1,0.1c0,0.2-0.3,0.2-0.4,0.4 c3,0,6-0.2,9.7-0.1c0.5,0.6,2.9-0.1,4,0c1.4,0.1,3.7-0.2,5.7-0.3c3.2-0.2,6.4,0.2,9.1-0.4c0,0.2,0,0.4,0.4,0.4 c0-0.2-0.1-0.4,0.2-0.5c0.9,0.1,1.6,0.3,2,0.7c0.2-0.2,0.5-0.4,0.8-0.6c-0.3,0-1,0.3-1.2,0c0.4-0.1,0.3-0.3,1-0.3 c0.8,0.8,0.4,0.3,1.6,0.5c-0.3,0-0.5,0.1-0.6,0.2c0.9-0.4,2.3,0.3,3.2-0.1c-1-0.2-1.4-0.1-2.2-0.3c1-0.1,1.3,0,2.2-0.3 c0.2,0.2-0.6,0.4,0,0.5c0.9-0.5,2.5,0.8,3.8,0.2c-0.4,0.1-1.1-0.2-0.6-0.2c0.5,0,0.6,0.2,1,0.2c0.7-0.8,2.2-0.1,3.2-0.5 c0.5,0.2,0.5,0.3,0.6,0.5c0.3-0.4,2.2-0.5,2.6-0.5c0.1,0.4-0.9,0.1-1,0.4c2-0.1,2.6-0.5,3.5-0.8c0.5,0,0.2,0.3,0.6,0.4 c-0.3-0.5,1.2-0.6,2.2-0.7c-0.1,0.4,0,0.6-0.2,0.7c-0.2-0.1-0.9,0-1.2,0.1c0.6,0.2-0.6,0.4-0.6,0.7c-0.4-0.1-0.4-0.2-0.2-0.4 c-1.5,0.3-3.3,0-4.7,0.3c0-0.1,0.3-0.3,0-0.4c0.3,0.4-0.7,0.1-0.6,0.4c0.6,0.2-0.4,0.5-0.8,0.6c0.2-0.2,0.2-0.3-0.2-0.4 c-0.4,0.7-1.5-0.1-2,0.4c-0.5-0.2,0.4-0.4-0.4-0.4c0,0.2,0,0.3,0,0.5c-0.7,0.1-2.8,0.1-3.4,0.2c-0.5-0.1,0.6,0.6-0.4,0.5 c0.1-0.5-2.2,0.2-2.4-0.6c-1.8,0.4-2.6-0.2-4.1,0.4c-0.1-0.2-1.2-0.4-1.4-0.1c0.3-0.1,0.9,0.2,0.4,0.2c-2.9-0.5-6.8-0.2-9.9-0.4 c0.2,0,0.3,0.1,0.4,0.2c-0.3,0-0.5,0-0.8,0c0-0.2,0.1-0.3,0.2-0.4c-0.7,0.3-1.7-0.4-2.2-0.2c0.6,0.1-0.3,0.1-0.4,0 c-0.1,0.3,0,0.3-0.6,0.5c0.3,0,0.7-0.1,0.8,0.1c-1.7,0.5-4.2,0-5.9-0.1c-0.6,0.2,0.7,0.4,0,0.6c-0.6-0.4-1.5,0.6-1.8,0 c0.2-0.3,2-0.2,1.2-0.7c-0.9,0.3-1.6,1.1-2.8,0.6c0.2,1.2-2.5,0.7-3.3,1.2c-0.5-0.2-1.8-0.6-2.6-0.2c1.4,0.1,2.6,0.4,3.2,1 c-0.2,0-0.6,0-0.6,0.1c1.1,0.2,0.7-0.5,1.8-0.4c0-0.5-1.2-0.2-1.2-0.6c1.6-0.1,3-0.2,4.2,0.1c-0.6-0.1-0.3,0.4-0.8,0.4 c-0.2-0.1-1.1-0.3-1.2-0.1c-0.3,0.6-2.5,1.1-3.7,0.5c-0.6,0.7-1.7,0-2,0c0.5,0.1-0.2,0.4-0.4,0.5c0-0.6-2-0.4-1,0.1 c-0.8,0-1-0.3-1-0.5c-0.6,0.3-1.3,0.5-1.8,0.9c0-0.3,0.4-0.4-0.2-0.5c-0.5,0.2-0.1,0.2-0.4,0.4c-0.2,0-0.2-0.1-0.2-0.2 c-0.7,0.9-2.4-0.4-2.8,0c0.2,0,0.5,0,0.4,0.2c-0.9,0-1.9,0-2.2-0.5c-0.3,0.5-0.7-0.2-1.4-0.1c-0.3,0.8-3.6,0.9-3.4,0.3 c-0.7,0.3-1.1,0.7-2,0.3c-0.2,0.6,1.3,0.1,1.6,0.5c-0.6,0.3-2.2,0-2.8,0.3c-0.5-0.3-0.9-0.6-0.8-1c-0.5,0.1-0.6,0.4-1,0.6 c0.2,0,0.6,0,0.6,0.1c-0.7,0.4-2.2,0.3-2.2-0.5c0.5,0.1,0.6-0.5,0.4-0.5c-0.3,0.5-1.6,0.4-2,0.9c0.9,0.2,0.6-0.4,1.4-0.3 c0.3,0.4-0.2,0.5,0.4,0.7c-1.2-0.1-1.8,0-2.6,0.1c0-0.2,0.5-0.2,0.4-0.5c-0.7-0.1-0.4,0.4-0.8,0.5c-0.4-0.1-0.9-0.2-1-0.5 c-1.6,0.7-2.8,0.3-5.1,0.4c-0.3,0.5,1.2,0,1.2,0.3c-2.2,0.7-4.5,0.6-6.7,1.1c0-0.2,0.3-0.2,0.4-0.4c-1.2,0.6-2.1,0-2.4,0.5 c-2.9-0.6-9.3-0.1-11.9-0.7c-1.5,0-3.5,0.8-4.6-0.1c-0.8,0.5-2.7,0-3.4,0.4c0.3,0,0,0.2-0.2,0.2c-3.1-0.5-4.7,0.7-8.3,0.3 c0.1,0.6,2.5-0.2,2.2,0.7c2,0.1,2.6,0.5,4.4,0.4c-0.2,0-0.6,0-0.6,0.1c0.2,0,0.4,0,0.4,0.1c-0.9-0.1-1.5,0.1-1.8,0.4 c1.4-0.1,3.3-0.2,4.6,0.2c-0.4,0.5-2.9,0-3.2,0.3c1.2,0.2,2.3,0.5,3.8,0.6c-0.6,0.4,0.6,0,0.4,0.5c-0.9,0.3-1.4,0-2,0.1 c0.2,0,0.7,0.3,0.2,0.4c-0.6-0.2-0.7,0-1.4,0c0-0.2,0.8-0.4,0.2-0.5c-0.8,0.3-2.2,0.9-2.8,0.3c0,0.2,0.2,0.3,0.2,0.5 c-0.5,0-1,0-1.2,0.1c0-0.1,0-0.2,0-0.4c-1.2,0.3-1.8,0.5-2.4,0.9c-0.7-0.1-3-0.3-3.4,0.2c1,0.2,2.5-0.4,3.2,0.3 c2.7-0.1,5.8,0.1,7.5-0.1c1.1-0.1,2.6,0.2,3.6,0.1c1-0.1,2.4-0.4,3,0.2c-0.6-0.2-1.3,0.2-2-0.1c-0.4,0.2,0.3,0.3-0.2,0.4 c-9.8-0.7-20.4,1.9-31.2,1.5c0.1,1.1-3,0.7-3.9,0.4c-0.5,0.7-1.8,0-2,0.5c0.5,0.3,1.9,0,2,0.5c-0.1,0.2,0.3,0.7-0.2,0.7 c-2.4,0.2-3.8-0.7-5-0.2c1.2,0,2.3,0.9,4.2,0.8c-0.3,0-0.3,1,0,0.6c-0.2-0.8,0.9-0.1,1.4-0.6c0.7,0,0.9,0.3,1,0.7 c-0.6,0.5-2.2,0.4-2.9,0.9c0,0.5,0.7,0.7,1.4,0.5c3,0.9,8.2-0.3,11.5,0c0.4,0,0.3,0.3,0.8,0.2c1.8-0.1,4.6-0.8,6.3,0.1 c1.2-0.2,2.3-0.1,3.6,0c0.1-0.3,0.5-0.4,1.2-0.4c-0.3,0.2,0,0.2,0,0.5c-0.5,0.1-1.1,0.1-1.4,0.3c0.3,0.2,1,0,0.8,0.5 c-1.3,0-1.8,0.5-3,0.6c0.4,0,0.4,0.3,1,0.2c0.8-0.7,2.9-0.6,3.3-1.6c0.4,0.1,0.7,0.6,0.4,0.8c1.5,0.6,3.8,0,5.4,0.4 c0,0.4-0.7,0.4-1,0.7c1.4,0.1-0.2,0.3-0.2,0.6c1-0.4,2.9-0.3,4.3-0.5c9.9,1.4,21.4-0.2,30.9,0.4c2.8-0.3,5.8-0.4,7.7-0.6 c1.1-0.6,3.5-0.9,4.5-0.5c0.6-0.3,3.6-0.3,4.5-0.4c-1.2,0,0.1,0.2,0.2,0.4c-1.7,0-2.8-0.1-3.2,0.5c-0.2-0.1-0.5-0.1-0.6-0.2 c0.2,0,0.4,0,0.4-0.1c-1.3-0.2,0.3,0.8-0.8,0.8c-0.2-0.6-1.4,0.1-1.2-0.7c0.6-0.1,0.8,0.3,1-0.1c-1.8,0-3.4,0.1-4.3,0.3 c0.7,0.4,2.1-0.2,3,0c0.2,0.2,0.2,0.4,0.4,0.6c1,0.3,2-0.1,2.6,0.5c-2.7,0.4-2.2-0.4-4-0.3c0.1,0,0.2,0.1,0,0.1 c-1.3,0.1-1.8-0.1-3,0.1c-0.5-0.2-1.8-0.9-1.8,0c0.8-0.1,1.7-0.2,2,0.3c1.7,0.2,2.7-0.7,3.8-0.3c-0.9,0.1-1.5,0.2-1.8,0.6 c0.9,0.1,0.6-0.5,1.6-0.4c0,0.2-0.3,0.2-0.4,0.4c0.9-0.2,2.6-0.5,3,0.1c-1.6,0.2-3.1,0.3-4.3,0.5c0-0.2-0.1-0.5-0.2-0.2 c0,0.1,0,0.2,0,0.2c1.8,0.5,2.5-0.5,3.8,0.3c-0.9-0.1-1.7,0.3-2.4,0c-0.3,0.7-2.3,0.8-3.3,0.6c2.8,0.8,4.9-0.6,7.3-0.8 c0.2,0.4-1.4,0.4-0.6,0.8c2.7-0.7,6.4,0.3,8.9,0.3c-2.3,0.4-4.4,0.6-6.3,0.4c-0.6,0,0.5,0.3-0.2,0.4c-1.6-0.4-4.8,0-7.3,0.3 c0.1-0.2,0.2-0.2,0-0.4c-1.2,0.9-3.5,0.2-4.7,0.5c0.2,0,0.4,0,0.4,0.1c-2.9-0.2-6.9-0.2-9.7,0.4c0-0.2,0-0.3,0-0.5 c-3,0.5-7.6,1-11.1,0.5c0,0.3-0.2,0.4-0.6,0.4c-8.6-0.2-18.5,1.1-26.5,0.7c0.3,0,0.7,0,0.6,0.2c-3.7-0.6-6.9-0.3-10.3-0.3 c-0.4-0.2-0.6-0.5-1-0.7c0,0.5,0.3,0.3,0.4,0.8c-1.5-0.5-3.7-0.5-5.3-0.2c0-0.1,0-0.2,0-0.4c-1.2,0.5-2.9,0.7-4,0.3 c0.2,0,0.2,0.2,0.2,0.4c-1,0.1-1.9,0.2-2-0.2c-0.5,0.1-1.2,0.1-1.6-0.3c-0.8,0.1,0,0.6-0.4,0.7c-7.5-0.5-17.8-0.2-26.1,0.1 c6.8,0.1,13.6,0.3,20.6-0.2c0,0.3,1.3-0.2,1,0.4c3.8-0.4,8.8,0.5,12.5-0.1c0,0.1,0,0.3,0.2,0.4c-0.2-0.5,0.4-0.5,0.8-0.6 c0.4,0.5,1.8,0,2.8,0.6c0.3-0.5,2.7,0,3.2,0.1c0.2-0.2,0.2-0.4,0.6-0.5c0.1,0.4,1-0.1,1.4,0.3c0.6-0.5,1.6-0.2,2.6-0.4 c0.2,0.7,1.4,0.3,2.4,0.3c0.4-0.2-0.3-0.3,0.2-0.4c5.1,0.3,9.9-0.1,15.4,0.3c-0.2,0-0.4,0-0.4,0.1c0.6,0.1,0.4-0.3,1-0.2 c0,0.3,0.3,0.2,0,0.5c0.9-0.3,2.2,0,3.2,0.1c0.2-0.4-0.3-0.3-0.4-0.5c0.5,0,0.4-0.2,1-0.1c0,0.2-0.5,0.2-0.4,0.5 c0.9,0.2,0.7-0.4,1.6-0.3c-0.1,0.6,1,0.1,1.6,0.5c0.4-0.4,0.5-0.5,0.4-0.7c0.5,0.1,0.9,0.2,1.2-0.1c0,0.1,0,0.2,0,0.4 c0.4-0.1,1.9-0.6,2.2,0c-0.9-0.1-1.7,0.5-2.8,0c0.1,1,3.9-0.2,4.6,0.7c-4.4,0.2-7.7,0-12.3,0c-0.1,0.2,0.3,0.3,0,0.4 c-0.4-0.1-1.2,0.2-1.2-0.1c0.2-0.3,0.8,0.3,0.8-0.2c-1,0-2.9,0.1-3.4,0.2c0.4,0,1.3,0.3,0.6,0.6c-3.5-0.5-7.8-0.1-10.9-0.1 c-4.5-0.1-9.1-0.3-14.1-0.5c0-0.1,0-0.2,0-0.2c-1.8,0.6-3.5-0.2-4.9,0.4c-0.5-0.1-1.1-0.2-1.2-0.6c-0.3,0.1-1.2-0.1-1.2,0.1 c0.9-0.1,1.3,0.1,1.4,0.6c-1.1,0.1-4,0-5.4-0.2c-1.8,0.5-4.7,0.1-6.3,0.5c1.2,0.3,3.8-0.5,4,0.7c-1.3-0.3-2.2,0.6-3.6,0.2 c0.1,0.4-0.4,0.4-1.2,0.2c-0.9,1-3.9,0-5.5,0.7c-0.5-0.3-1.1-0.4-1.8-0.6c-0.1,0.4,0.7,0.2,0.2,0.5c0.3,0.1,1.2-0.2,1.2,0.1 c-4.3,0.3-7.3,0.6-11.1,0.7c0.1,1.1-2.1,0.2-2.8,0.5c0.9,0.5-1.6,0.1-2.4,0.1c-1.8,0.1-3.8,0.4-4.7,0.6c0.9,0.6,2-0.2,3.2,0.1 c-0.1,0.3-0.2,0.5-0.6,0.6c-0.2-0.2-1.3,0-1.2,0.4c1.1-0.2,1.6,0,2.6,0.2c-1.1,0.4-2.6,1.1-3.9,0.4c-0.8,0.5-2.3,0.3-3.9,0.5 c0.4,0.7-1.5,0.5-2.8,0.5c-1,0.6,0,0.8-1.6,1c0.5,0.2,0.9-0.1,1.2,0.1c-0.4,0.6-0.7,1.1-2.1,1.1c0-0.2,0.3-0.2,0.4-0.4 c-1,0.1-2.2,0.4-2.4,0.6c-0.9-0.3-0.7,0.1-1.4,0.1c-1.1,0.1-2.7-0.3-3.2,0.4c0.7,0.3,1.7-0.2,2,0.5c-0.7,0.3-1.3-0.3-1.4,0.1 c0.6,0.3,2.5-0.2,2.6,0.5c-0.4,0-0.8,0-1.2,0c0,0.4,1,0.3,0.4,0.7c0.3-0.1,1,0.1,1-0.1c-0.4,0-0.6-0.1-0.6-0.4 c0.5,0,1.6,0.1,2.4,0.1c-1.4,0.7-4.7,0.7-6.3,0.7c-0.2,0.2-0.2,0.5-0.6,0.6c0.9,0,1.8,0,0.8-0.2c0.7-0.1,0.9,0.2,1.2,0.5 c-1.4,0.6-1.1-0.1-2.4,0C96.1,338.1,96.4,338.3,95.8,338.7z M197.4,295.6c0.1-0.4,0.7-0.1,1,0 C198.3,295.9,197.5,295.6,197.4,295.6z M228.4,294.6c0.3-0.1,1.1-0.2,1.8-0.4c-0.1,0.1-0.2,0.2-0.2,0.4c-0.6,0-1,0-1.2,0.3 C228.6,294.8,228.7,294.6,228.4,294.6z M304.5,290.3c0,0.2,0.2,0.3,0.4,0.4c0,0.3-0.5,0.3-1,0.2c0.3-0.2-0.2-0.2,0.2-0.5 c-0.4,0-1.2,0.2-1-0.2C303.4,290.3,304,290.3,304.5,290.3z M422.5,306.4c0-0.3,0.3,0.2,0.8,0c0,0.1,0,0.2,0,0.4 c-0.4,0.1-0.5-0.1-0.8-0.1C422.6,306.6,422.8,306.4,422.5,306.4z M441.9,352.4c0.9,0.2,2.1-0.5,2.4,0.1 C443.8,352.7,442.1,353.1,441.9,352.4z M252.1,346.7c1-0.1,1.9-0.2,3.2,0C254.3,346.9,253.2,346.8,252.1,346.7z M97.9,337.9 c0-0.2,0.5-0.2,0.4-0.5c0.6-0.1,0.7,0.2,1.4,0.1c0,0.1-0.4,0.1-0.6,0.1c0,0.1,0,0.2,0.2,0.2C99.2,338.2,98.1,338,97.9,337.9z  M106.3,333.8c0.2-0.2,0.8-0.3,1.4-0.3c-0.1,0.3-0.7,0.4-1.2,0.5C106.6,333.9,106.5,333.8,106.3,333.8z M116.5,330.1 c0.2-0.3,1.9-0.6,1.8,0C117.5,329.9,117.5,330.1,116.5,330.1z M139.4,341.9c-0.8-0.2,1.6-0.5,1.4,0 C140.5,341.8,139.7,341.7,139.4,341.9z M144.6,342.4c-0.2-0.2,1-0.2,0.4-0.4c0.1-0.2,1.9-0.3,1.8,0.1 C145.7,342.1,145.2,342.3,144.6,342.4z M183.3,302.7c0-0.4,1.3-0.3,1.6-0.1C184.6,303,183.6,302.7,183.3,302.7z M192,324.3 c-0.1-0.5,0.9-0.1,1.2-0.1C193.2,324.5,192.2,324.5,192,324.3z M215.1,323.7c0.2,0.5-1,0.1-1.2,0.4c0.1,0.2,0.5-0.1,1,0.1 c2-1.2,5.8-0.4,8.7-0.6c2.4-0.1,4.4-0.7,6.1-0.5c0.1,0.1,0.5,0.1,0.4,0.4c0.7-0.3,1.5,0.1,2.4,0c0.3,0.4-0.2,0.3,0.8,0.2 c-0.4,0.2,0,0.3,0,0.6c-0.5,0.1-0.4-0.2-0.6-0.4c-0.3,0.2-0.7,0.3-0.8,0.6c-0.4-0.1-0.5-0.4-0.8-0.5c-0.4,0-0.4,0.3-0.8,0.4 c0.4,0.4,1.9,0,2.4,0.6c-1,0.1-1.2-0.3-2.2-0.2c0.5,0.2,1.2,0.2,1.8,0.3c1.7-0.4,1.4-1.6,3.3-1.7c-0.1-0.3-0.8-0.3-1.2-0.3 c1.5-0.6,2.9,0.1,3.9-0.5c0.3,0.1,0.7,0.1,0.8,0.4c0.6-0.1,1.8-0.6,2-0.1c0.4,0,0.1-0.4,0.6-0.4c1.3,0.8,4-0.4,5.3,0.2 c1-0.5,3.3-0.5,4.1-0.3c1-0.9,4.7-0.6,6.1-0.1c1.5-0.1,1.4-0.4,2.8-0.4c-0.4,0-1.2-0.4-1.4-0.2c0-0.4,1-0.4,2.4-0.4 c0,0-0.2,0.1-0.4,0.1c2,0.2,6-1.2,8.3,0.3c-0.8,0-1.5,0-2,0.3c0.5-0.2,2.7,0.4,3-0.4c0.6-0.1,0.8,0.1,1,0.3 c-0.1,0.3-0.1,0.6-0.8,0.5c-0.1,0.3,0.9-0.1,0.6,0.4c-1.3,0-2-0.3-3.4-0.2c0.5,0.2,1.3,0.3,2.6,0.3c-2.9,0.7-4.7,0.8-7.9,0.6 c0,0.5,1.2,0.4,1.4,0.8c-2.1-0.2-3.5,0.5-4.9,0.3c0-0.1,0-0.2,0-0.2c-0.1-0.3,0.3-0.2,0.6-0.2c-0.4-0.4-1.1,0.1-0.8,0.5 c-0.7,0-1,0.2-1.8,0.1c0-0.3,0.5-0.3,1-0.2c-0.6-0.5-2,0.1-3,0.4c-0.7,0.2-0.1-0.4-0.6-0.4c-0.8,0.2-5,0.4-5.9-0.1 c-0.5,0.2-0.6,0.3-0.4,0.6c-0.7,0.1-1.1,0-1.2-0.3c-0.8,0.6-2,0.1-3-0.1c-0.7,0,0.4,0.4-0.2,0.4c-0.5,0-0.2-0.1-0.2-0.2 c-0.7,0-0.6,0.5-1.6,0.4c0.2-0.3,0.2-0.6,0.2-1.1c-0.4,0-0.1,0.5-0.2,0.7c-0.8,0.1-0.8-0.3-1.4-0.3c0.3,0.5-1,1.4-1.6,0.5 c0.7-0.1,0.8,0.1,1.2,0.2c0-0.3-0.4-0.4,0-0.6c-0.9,0.3-1,0.1-2-0.1c-0.1,0.3-0.5,0.6,0,1.1c-0.6-0.2-1.4-0.3-2-0.5 c0-0.3,0.7-0.2,1.2-0.3c0.3,0-0.3-0.4-0.4-0.6c-0.4,0.1,0.2,0.2-0.2,0.4c-0.5,0-0.7-0.2-1.4-0.1c-0.3-0.2,0-0.2,0-0.5 c-1.2,0.4-0.6,1.2-2,1.1c0.1,0.1,0.3,0.2,0.6,0.2c-2.2,1-5.4-0.4-7.1,0.4c-0.6-0.3-0.3-0.4-1-0.1c-0.4-0.6,0.4-0.8,1.2-1.1 c0.1,0.3-0.1,0.3-0.2,0.5c1,0.1,2.5,0.6,3.8,0c-1.8,0-2.9-0.4-4.4-0.4c0.2-0.4,0.1-0.3-0.2-0.6c-0.7,0.1,0.5,0.7-0.2,0.8 c-0.3-0.3-1.7,0.2-2.6-0.2c-0.3,0,0,0.2,0.2,0.2c-0.3,0.3-0.7-0.4-1.4-0.2c0.1,0.1,0.4,0.2,0.6,0.2c-0.1,0.4-0.4-0.1-0.8,0 c0,0.1,0.2,0.1,0.4,0.1c-0.1,0.3-1,0.1-1.2,0.4c-0.3-0.2-1-0.6-1.4-0.1c-2.6-0.5-5.4-0.5-8.1-0.5c0-0.1,0-0.2,0-0.4 c-1.9,0.5-3.6,0.2-5.5,0.3c1.4-0.9,3.8-0.3,5.9-0.4C213,324,213.9,323.6,215.1,323.7z M199.9,324.6c1.3-0.9,4-0.1,5.9-0.4 C204.6,324.9,201.5,324.5,199.9,324.6z M211.1,344.2c0.6-0.5,1.4-0.2,2.6-0.4C213.2,344.1,211.9,344.5,211.1,344.2z M232.1,323.2 c-0.1-0.3,0.3-0.4,0.8-0.4c0,0.1,0,0.2,0,0.4C232.7,323.2,232.4,323.2,232.1,323.2z M234.2,347.9c0.4-0.3,1.4,0,2,0 C235.8,348.2,234.6,348,234.2,347.9z M234.4,324.8c0.6,0,0.5,0.7,0.2,0.8C233.8,325.5,234.4,325.1,234.4,324.8z M235,324.9 c0-0.1,0.4-0.1,0.6-0.1c-0.2,0.3,0.3,0.3,0.2,0.6C235.2,325.3,235.2,325,235,324.9z M235.7,345.7c0.2-0.3,1.3-0.4,1.2,0.1 C236.3,345.9,236.2,345.7,235.7,345.7z M241.9,347c0.5,0.1,1,0.2,1.4,0C243.7,347.1,241.7,347.7,241.9,347z M241.6,320.8 c0.1-0.4,0.9-0.2,1.4-0.1C242.8,321.2,242.2,320.8,241.6,320.8z M242.7,348.1c0-0.5,1.5,0,1.8-0.4c0.7,0-0.3,0.5,0.2,0.5 C244.2,348.3,243.4,348.1,242.7,348.1z M245,298.3c0.1-0.2,0.5-0.2,0.6-0.5c0.3,0,0.2,0.4,0.8,0.2 C246.3,298.3,245.5,298.2,245,298.3z M246.9,298.5c0.9-0.1,1.6-0.3,2.6-0.1C249.2,298.8,247.6,298.5,246.9,298.5z M247.5,295.5 c0.5,0.3,1.1-0.1,1.4,0.1C249,296,247.2,295.9,247.5,295.5z M247.7,298.1c0.1-0.3,0.8-0.5,1.2-0.3 C248.6,298,248.1,298.3,247.7,298.1z M250.9,298.2c0.4-0.3,0.9-0.4,1.6-0.3c0,0.3-0.7,0.1-1,0.1c0,0.3,0.7,0,1,0.1 C252,298.6,251.6,298.3,250.9,298.2z M257.4,297.4c0.2-0.6,1.6,0,2-0.3C258.9,297.6,258.3,297.2,257.4,297.4z M258.2,297.9 c0.2-0.2,1.5-0.2,1.8,0c0.1,0.3-0.9-0.1-0.6,0.4C259.1,298.1,258.6,298,258.2,297.9z M259.4,321c1.6-0.5,2.4-0.5,4.1-0.8 c-0.1,0.2-0.9,0-0.6,0.5C261.5,320.7,260.7,321,259.4,321z M259.6,297.4c0.4-0.2,2.1-0.7,2.6,0 C261.5,297.1,260.4,297.4,259.6,297.4z M260.6,298.3c0.1-0.3,0.7-0.6,1-0.4C261.4,298.2,261.2,298.4,260.6,298.3z M261.6,297.9 c0.7-0.2,1.9-0.1,3-0.1c-0.4,0.6-2-0.1-2,0.6c-0.4,0.1-0.5-0.1-0.8-0.1C262.1,298.1,262.5,297.8,261.6,297.9z M267.2,347 c-0.2-0.4,0.6-0.2,1-0.2C268.3,347.2,267.5,347.2,267.2,347z M266.5,297.9c1.5-0.2,3.6-0.1,5.9-0.4c-0.2-0.5-1,0.1-1.4-0.2 c0.1-0.4,1.1-0.2,1.8-0.3c0.4,0.4-0.3,0.6,0,1.1C270.4,298.1,268.8,298.4,266.5,297.9z M271.1,322.6c0-0.6,1.2-0.5,2.2-0.5 C273.2,322.7,271.9,322.6,271.1,322.6z M273.7,321.6c0-0.6,3.1,0,0.8-0.1C274.3,321.6,274,321.6,273.7,321.6z M275.4,297.2 c-0.2-0.5,0.9-0.2,1.4-0.3C276.5,297.3,276.3,297.1,275.4,297.2z M277,297.6c0.1-0.3,0.5-0.4,1-0.5c-0.2,0.1-0.2,0.3-0.2,0.5 C277.5,297.6,277.3,297.6,277,297.6z M281.7,296.2c0.1-0.1,0.7-0.4,0.8-0.1c0.2,0,0.1-0.1,0.2-0.2c0.6,0.1,0.2,0.2,0.2,0.5 C282.3,296.4,282.3,296.1,281.7,296.2z M283.7,296.3c0.1-0.1,0.2-0.2,0-0.2c0-0.3,0.7-0.1,1-0.1 C284.5,296.2,284.3,296.4,283.7,296.3z M288.4,295.2c0.2-0.4,0.8,0,1.4-0.3C290,295.4,288.9,295.1,288.4,295.2z M288.9,291.1 c0.8,0.1,1.5,0.3,1.4,0.9C289.9,291.7,289.1,291.6,288.9,291.1z M289.4,294.6c0.3-0.2,1.3-0.4,0.2-0.5c0.3-0.5,1.3-0.1,2-0.1 C290.9,294.4,290.5,294.4,289.4,294.6z M291.7,347.4c0.3-0.2-0.2-0.2,0.2-0.5c1.3,0.2,1.6,0.2,2.8,0.2 C294.3,347.5,292.8,347.3,291.7,347.4z M290.7,291.9c-0.2-0.5,1.6-0.5,1.4,0C291.4,291.8,291.2,292.2,290.7,291.9z M291.2,294.8 c0-0.4,1.3-0.3,1.6-0.1C292.3,294.9,292,294.7,291.2,294.8z M295.1,347.2c-0.2-0.4,1-0.2,1.2-0.1 C296.1,347.3,295.4,347.4,295.1,347.2z M294.3,293.6c-0.1-0.4,0.7-0.4,1-0.2C295.1,293.5,294.8,293.6,294.3,293.6z M298.3,292.6 c1.3,0.1,2.4-0.4,3.4-0.3c0.2,0.4-0.3,0.4-0.2,0.7c-0.3-0.2-1.4,0-1.2-0.5C300,293,299,292.6,298.3,292.6z M298.7,292.7 c0.3,0.2,0.2,0.7-0.6,0.6c0.6-0.7-0.9,0.1-1-0.6C297.9,292.8,297.8,292.7,298.7,292.7z M300.8,290.4c0.5-0.4,0.8-0.1,1.4,0 C301.6,290.8,301.4,290.5,300.8,290.4z M314.5,348.6c-0.1-0.2,0.2-0.2,0.2-0.4c0.6,0,0.8,0.2,1.6,0.1 C316.2,348.7,315,348.8,314.5,348.6z M315.1,292.7c0.5-0.4,1.2,0,1.6-0.5c1,0.1,1.4,0.3,2.2,0c0,0.2,0,0.4,0,0.6 C317.8,292.6,316.4,292.9,315.1,292.7z M317.9,348.5c0.7,0.2,1,0,1.6,0.1C319.4,349,317.8,348.9,317.9,348.5z M319,292.4 c0.6-0.6,2.2-0.6,3-0.1c0.7-0.6,1.5-1,3-0.5c-0.5,0.3-1.9-0.1-2.2,0.9C321.1,292.4,319.8,292.6,319,292.4z M319.5,294 c0-0.3,1.1-0.3,1.4-0.1c-0.1,0.3-0.5,0.5-1.2,0.5C319.7,294.1,319.7,294,319.5,294z M321.3,294.2c0.1-0.4,0.8,0,1.6-0.1 c0,0.2,0.2,0.3,0.2,0.5C322.4,294.4,321.7,294.4,321.3,294.2z M324.5,351.2c0.4-0.2,0.9-0.2,1.4-0.1 C325.7,351.5,325.2,351,324.5,351.2z M323.2,290.8c0-0.3,0.8-0.1,1.2-0.1c-0.4,0.3,0.1,0.3,0.6,0.2 C324.7,291.4,323.7,290.8,323.2,290.8z M324.2,292.6c0-0.1,0-0.2,0-0.4c0.3,0,0.7,0,1,0C325.2,292.6,324.5,292.5,324.2,292.6z  M326.3,351.4c0.2-0.2,0.6-0.3,1.2-0.3C327.4,351.4,326.7,351.6,326.3,351.4z M326.8,349.6c0-0.2,0.7,0.1,1,0.1 C327.6,350.2,327,349.8,326.8,349.6z M328.4,349.1c0-0.3,0.7-0.2,1.2-0.3C329.7,349.2,328.7,349.3,328.4,349.1z M330.4,349.4 c-0.2,0-0.1-0.1,0-0.1c0-0.3-0.8-0.1-0.6-0.5c0.5,0,0.4-0.2,1-0.1c0.1,0.1,0.2,0.2,0.4,0.2C331.2,349.2,330.4,349.1,330.4,349.4z  M330.1,290.5c0,0.1,0.4,0.1,0.6,0.1c0.2,0.2-0.6,0.4,0,0.5c-0.2,0.2-0.8-0.4-1-0.6c0.7,0,0.5-0.3,1.2-0.1 C330.8,290.5,330.4,290.5,330.1,290.5z M332,352c-0.1-0.4,1.1-0.5,1,0C332.8,352.2,332.3,352.2,332,352z M332.2,349.5 c-0.1-0.4,0.5-0.3,0.6-0.6c0.3,0.1,0.4,0.3,0.4,0.5C332.9,349.5,332.6,349.6,332.2,349.5z M333.5,291.4c0.1-0.1,0.2-0.2,0.2-0.4 c0.2,0,0.5,0.2,0.2,0.2c0.1,0.1,0.5,0.1,0.4,0.4c-0.2-0.1-0.4-0.1-0.4,0C333.6,291.6,333.7,291.4,333.5,291.4z M334.8,290.9 c0.1,0.5,0.2,0.5-0.2,0.8C334.4,291.5,334,290.9,334.8,290.9z M337.4,350.8c0-0.1-0.1-0.2-0.2-0.2c0.4-0.3,0.4,0.3,1.2,0 c-0.1,0.2,0.2,0.2,0.4,0.2C338.4,351.1,338,350.4,337.4,350.8z M338.3,295c1.5-0.6,5.1-0.4,6.5-0.7 C344.3,295.1,340.3,294.8,338.3,295z M340.5,294.1c0-0.1,0-0.2,0-0.4c0.5,0,1,0,1.2,0.1C341.6,294.2,341,294.1,340.5,294.1z  M341.8,293.7c0-0.1,0-0.2,0-0.4c0.4,0,0.9,0,0.8,0.4C342.4,293.7,342.1,293.7,341.8,293.7z M342.8,291.8c0-0.1,0.2-0.1,0.2,0 c0.7-0.6,0.2,0.3,0.8,0.2c-0.1,0.2-0.5,0.1-0.8,0.1C343,292,343,291.8,342.8,291.8z M346.6,294.3c0-0.4,1.1-0.2,1.6-0.4 C347.9,294.5,347.2,294.1,346.6,294.3z M355.7,354.9c0.3-0.2,1-0.4,1.4-0.1C357,355.1,356.1,354.9,355.7,354.9z M373.8,296.1 c1.6,0.8,0.5,1.3-1.8,1.2c0.2,0.2,0.6,0.2,1,0.2c0.1,0.4-0.9,0.1-1,0.4c-0.3,0-0.2-0.3-0.2-0.5c-1.9,0.1-2.1,0.2-4.2,0.3 c-0.3-0.5-1,0-1.4-0.5c-0.5,0.1,0.6,0.3,0,0.5c-1.4-0.1-1.3-0.4-2.8-0.2c0,0.3,1.3-0.2,1,0.3c-0.9-0.2-1.6-0.1-2.4,0.1 c-0.1-0.3,0-0.5,0.2-0.6c-0.5,0-0.6,0.2-0.6,0.5c-1,0.1-1.2-0.2-1.6-0.5c1-0.9,4.6,0,5.9-0.7c2.4,0.3,4.5,0.2,6.9,0.3 c0-0.2-0.7-0.1-0.8-0.2c0-0.4,1.2-0.2,1.2,0.1C373.9,296.7,374,296.6,373.8,296.1z M362.9,357.8c0.1-0.3,0.9-0.4,1.2-0.3 C363.9,357.7,363.4,357.8,362.9,357.8z M363.5,358.6c-0.2-0.5,0.9-0.5,0.8,0C364,358.6,363.7,358.6,363.5,358.6z M363.3,349.7 c0.4-0.2,2.2-0.3,1.8,0.3C364.4,349.7,363.9,349.8,363.3,349.7z M364.2,357.5c1.1-0.6,2.9,0,4-0.2c-0.3,0.2-0.5,0.4-0.6,0.7 c-1,0-1.7-0.5-2.6-0.2C364.9,357.7,364.9,357.4,364.2,357.5z M363.9,298.9c0.1-0.3,1.1-0.1,1.6-0.1 C365.2,299.4,364.8,299,363.9,298.9z M365.7,352.8c0.1-0.1,0.2-0.3,0.2-0.5c0.6-0.1,0.4,0.3,1,0.2 C366.9,352.9,366.2,352.8,365.7,352.8z M366.3,351.7c0-0.1,0-0.2,0-0.4c1-0.3,1.5,0.1,2.6,0.2C368,351.9,367.2,351.5,366.3,351.7 z M368.8,351.5c1.7-0.4,3,0.3,4.9,0c-0.2,0.3-0.1,0.3-0.2,0.7c-0.9-0.4-2.8-0.6-3.2-0.1c-0.4,0-0.5-0.2-0.4-0.5 c-0.6,0.1-0.2,0.2-0.2,0.5C369.3,352,369.4,351.5,368.8,351.5z M368.1,300c0-0.5,0.6,0,1.2-0.1C369,300.1,368.6,300.1,368.1,300z  M370.2,303.3c2.2-0.5,5.7-0.2,7.9-0.2c0.5-0.1-0.2-0.5-0.6-0.5c0.2-0.3,0.8,0,1.2,0c0,0.2-0.2,0.3-0.2,0.5c0.1,0.3,1,0,1.4,0.1 c-2.7,1.2-5.4,0.3-9.5,0.4C370.4,303.5,370.4,303.3,370.2,303.3z M370.4,296.4c0.2-0.2,0.8-0.1,1.2-0.3c0,0.2,0.2,0.3,0.2,0.5 C371,296.7,371.2,296.2,370.4,296.4z M374.2,352c0-0.5,0.8-0.4,1.6-0.5c0,0.2-0.2,0.3-0.2,0.5C375.1,351.7,374.8,352,374.2,352z  M374.8,297.6c0.1-0.3,0.3-0.5,0.2-0.8c1.1,0.1,1.6,0.3,2.8,0.6C377.1,297.9,376,297.4,374.8,297.6z M380.9,295.4 c-0.3,0-0.7,0-1,0c3.2-0.4,7.6-0.6,11.5-0.1c0.2,0,0.1-0.2,0.4-0.2c0.5,0,0.8,0.1,1.2,0.2c0,0.4-1,0.2-1.6,0.3 c0,0.2,0,0.3,0.2,0.4c-1.9,0.3-5.4,0-8.3,0.7c-0.6-0.1-1.3-0.3-1.6-0.6c-0.6,0.1,0.1,0.4,0,0.6c-0.5,0.1-0.9-0.5-1.2-0.1 c-0.6-0.1-0.2-0.2-0.2-0.5c-1,0.2-1.7,0.3-2.4,0.3c-0.2,0.4,0.6,0.2,1,0.2c-0.6,0.4-2,0.3-2.6,0c-0.2-0.5,0.9-0.8-0.2-0.8 c0.9-0.4,3.1,0.4,3.6-0.2c-1.5-0.3-4.2,0.2-5-0.6c2.1-0.5,3.9,0.1,6.1-0.1C380.9,295.1,380.9,295.3,380.9,295.4z M375.4,300 c0-0.3,0.4-0.6,0.8-0.4C376.3,300,375.8,300,375.4,300z M377.4,299.3c0,0.1-0.2,0.1-0.2,0.2c2.5,0,2.8-0.2,4.9-0.4 c0.8,1.2-3.8,1-4.9,1.1C376.4,299.9,376.2,299.5,377.4,299.3z M378.5,297.5c0.1-0.3,0.6-0.3,0.8-0.6c0.3,0.4,1.7,0,1.8,0.5 C380.2,297,379.6,297.7,378.5,297.5z M386.2,302.6c0,0.1,0.2,0.1,0.4,0.1c0,0.2-0.6,0-0.6,0.2c0.2,0.3,1.2,0,1.8,0.1 c-0.8,0.6-2.8,0.4-3.5,0.8c-0.3-0.3-0.2-0.7,0-0.7c-0.2-0.4-0.4,0-0.8-0.2c-0.5,0.2,0.6,0.2,0.4,0.6c-1.5,0-1.9-0.1-2.6,0.3 c-0.6-0.2,0-0.2-1.2-0.1c-0.1-0.8,1.3-0.2,1.8-0.5c-0.7-0.5-2.6,0.5-2.6-0.3c2.5,0.1,5.6-0.8,8.3,0 C387.2,303,386.9,302.5,386.2,302.6z M381.1,298.2c-0.7,0,0.5-0.5-0.2-0.5c0.2-0.4,0.7,0,0.8,0.1 C381.8,298.1,381.2,297.9,381.1,298.2z M381.9,297.7c1.5-0.3,4.8-0.1,4,0.4C384.9,297.6,383.5,298.2,381.9,297.7z M385.5,307.3 c-0.3,0,0.2-0.2-0.2-0.2c0.4-0.5,1.7,0,2.4,0C387.5,307.6,385.9,306.9,385.5,307.3z M387.5,307.2c0.3,0,0.7,0,1,0 c-0.1,0.1-0.2,0.2,0,0.2c0,0.2-0.6,0-0.6,0.2C387.6,307.7,387.5,307.5,387.5,307.2z M386.5,297.6c1.3-0.3,4.2,0,6.5-0.3 c-1.4,0.9-3.6,0.3-5.7,0.5C387.5,297.5,386.8,297.7,386.5,297.6z M393.5,308c0.5,0.2,1.7-0.2,2,0.3c0.4-0.1,0.7-0.3,1.4-0.3 c0.1,0.2,0.6,0.4,0.2,0.6c-0.5,0-0.2-0.3-0.6-0.4c-0.5,0-0.5,0.3,0,0.4c-2,0.2-3,0.3-4.7,0c0.4-0.1,0.9-0.5,1.4-0.3 c0-0.7-0.9-0.3-1.4-0.1c-0.1-0.1-0.8-0.5-0.4-0.5c0-0.4,1,0,1.6-0.3c-0.5-0.3-2.3,0.1-2.6-0.1c0.1,0.3,0.4,0.6-0.4,0.6 c0.1-0.8-0.9-1-2-1.1c0.2-0.1,0.2-0.3,0.2-0.5c2.2,0.4,6.6-0.5,9.5-0.2c0,0.2-0.2,0.3-0.2,0.5c0.6-0.1,0.7-0.5,1.4-0.5 c0,0.2,0,0.3,0,0.5c0.4,0,0.4-0.2,0.8-0.1c0.4-0.1-0.2-0.2,0.2-0.4c0.3,0,0.7,0,1,0c0,0.1,0,0.2,0.2,0.2 c-0.4,0.3-0.5,0.6-1.4,0.6c0.2,0.1,0.2,0.3,0.2,0.5c-0.5-0.2-1.1,0.2-1.6-0.1c-0.3,0.1-0.4,0.3-0.4,0.5 C396.2,308,395.2,307.9,393.5,308z M394,296.4c0.2,0.4-0.3,0.4-0.4,0.6c-1.1-0.1-1.4,0-2.6-0.1c1.1,0.6-2.5,0.4-2.8,0 C390.1,296.4,392.7,297,394,296.4z M393.2,295.9c0-0.3,0.9-0.1,1,0C394,296.3,393.5,296,393.2,295.9z M394.4,297 c-0.1-0.4,0.3-0.5,1-0.5c0.2,0.3-0.4,0.2-0.4,0.5c1.6,0.3,3.2,0,3.8,0.8c-1.4-0.2-1.9,0.1-3,0.4c-0.3-0.1-0.4-0.3-0.8-0.4 c0.3-0.3,0.5-0.2,1-0.1C395.8,297.2,395.2,297,394.4,297z M400.7,296.8c0.1-0.3,1.2-0.1,1,0.2c-0.2,0.1-0.4,0.1-0.8,0.1 C400.9,297,400.9,296.8,400.7,296.8z M406.7,359.5c0.5-0.5,1,0.1,1.8,0.1c0.1,0.3-1.1-0.1-1,0.2 C406.9,359.9,407.3,359.4,406.7,359.5z M413,358c1.1-0.2,2.2,0.3,3.4-0.3c0.7,0,0.4,0.6,1.2,0.5c0.2,0.2-0.6,0.4,0,0.5 c-1,0.3-1.7,0.3-2.8,0.4c-0.3-0.2-0.3-0.4,0-0.6C414.1,358.3,413.4,358.3,413,358z M415,299.5c0-0.3,0.8-0.1,1.2-0.1 C416.2,299.7,415.3,299.7,415,299.5z M415.8,297.2c0.1-0.3,1-0.1,1.4-0.1C417.1,297.8,416.5,297.2,415.8,297.2z M423.3,298.6 c-0.6-0.2,0.4-0.4,1-0.4C424.5,298.8,423.3,298.4,423.3,298.6z M430.8,351.4c0.6-0.2,1.5-0.2,1.2-0.6c1.5-0.2,2.1,1.3,0.8,1.8 C432,352.2,430.8,352.2,430.8,351.4z M437.1,311.1c-0.1-0.4,0.4-0.4,1-0.4c0,0.2,0.2,0.3,0.2,0.5 C437.8,311.2,437.3,311.2,437.1,311.1z M451.1,350.1c-0.2-0.6,0.7-0.5,1.2-0.7c0.1-1-0.7-1.2,0.2-1.8c0.7-0.1,0.9,0.2,1.4,0.3 c0.2,1,0.1,1-0.3,1.9c-0.5,0.1-1.6,0-1.4,0.5C451.9,350.2,451.4,350.2,451.1,350.1z M451.9,326.3c0.1-0.3,1-0.1,1.2,0 c-0.1,0.2-0.4,0.2-0.8,0.2C452.4,326.3,452.2,326.3,451.9,326.3z M454.9,348.6c0.4,0,0.4,0.1,0.8,0.1c0.2,0.3-0.3,0.3-0.2,0.6 C455.2,349.1,454.8,349,454.9,348.6z M454.7,309.4c-0.1-0.4,1.5-0.3,1.2,0.1C455.4,309.7,455.1,309.4,454.7,309.4z M462.8,311.2 c0.1,0,0.3,0,0.4,0c0,0.4,0.5,0.6-0.4,0.6C462.9,311.4,462.5,311.4,462.8,311.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M256.3,348.2c-0.9-0.3-2.1,0-3.2,0.1c0.2-0.6-0.5,0.2-0.6-0.2c0.4-0.5,3,0.1,3.7-0.5 c-0.1-0.2-0.5-0.1-0.8-0.1c-0.2-0.3,1.7-0.1,1.6,0.3C256.3,347.8,256,347.8,256.3,348.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M259.8,291.5c0.4,0,0.2-0.3,0.8-0.2c0.9,0.2,1.9,0.2,2.6-0.3c0.4,0.1,0.4,0.2,0.2,0.4 c2.3-0.4,4-0.1,6.1-0.8c-0.5,0.5,2,0.3,1.4-0.1c2.7,0.3,6.9,0.1,9.3-0.7c-1,0.2-2.7-0.2-3.6,0.3c0.4-0.5-0.9-0.1-1,0.1 c0-0.1,0-0.2,0-0.4c-8.5,0.2-17.9,0.5-25.3,0.4c-0.8,0.4-3.5-0.1-4.3,0.8c-1.1-0.3-1.5-0.4-2.6-0.1c0.4-0.7-1.2-0.1-1-0.6 c-0.9,0.3-2-0.3-2.4,0.1c1.2,0.1,2-0.2,2.4,0.3c-1.2-0.1-2.4,0.2-3.2-0.3c-0.9,0.2-2.6,0.6-3.4,0.2c-0.1,0.6-1.1-0.1-1.6,0.3 c-0.1,0.2,0.3,0.3,0,0.4c-0.8,0.3-1.7-0.3-2.4,0c0.2,0,0.5,0,0.4,0.2c-0.6,0.1-0.6-0.2-1.2-0.1c-0.1,0.4,0.9,0.2,1.2,0.3 c0.4-0.4,2.7-0.4,3-0.1c-0.7,0.2-0.9,0.5-1.6,0.1c-0.1,0.3,0.4,0.2,0.4,0.5c0.7,0,0.7-0.4,1.4-0.4c-0.1,0.3-0.6,0.5-0.8,0.7 c0.7,0,0.5-0.5,1.2-0.5c0.2,0.2-0.6,0.4,0,0.5c0.4-0.4,1,0.2,1.4,0.2c-0.2-0.7,1,0.1,1.4-0.4c-0.6,0.2-1.1-0.3-0.6-0.5 c0.5,0.4,0.8,0.1,1.6,0.3c0,0.1,0.2,0.1,0.2,0.2c-0.9,0-0.8,0.7-0.2,0.1c1.2,0.1,2.6,0.2,3.4,0.3c-0.2-0.1-0.5-0.1-0.6-0.2 c1.2,0,1,0.4,1.2-0.1c0.8,0,0.7,0.5,1.2,0.7c-0.2-0.4,0.9-0.1,0.8-0.5c-0.4,0-1.2,0.2-1-0.2c1.3,0.1,1.4,0.1,2.6-0.1 c0,0.2,0.2,0.3,0.2,0.5c-0.6-0.2-1.4-0.2-1.6,0.3c1.1,0.1,1.7-0.1,2.4-0.5c0.5,0.4,1.2,0.1,1.2-0.1c0.6,0.2,0.2,0.4,0,0.7 c1.1-0.1,1.5-0.1,2.4,0.2c-0.3,0-0.2,0.3-0.4,0.4c0.8-0.3,0.9-0.2,1.6,0.1c0.7-0.4,3.2-0.8,4.5-0.3c0.8-0.5,1.5-0.3,3.4-0.5 c0.3-0.5-1.2,0-1.2-0.3c0.2-0.4,1.6-0.8,2.2-0.3c0.1,0.3-0.9-0.1-0.6,0.4C263.5,292.4,260.8,291.7,259.8,291.5z M239.1,291.9 c0-0.1,0-0.2,0-0.4c0.6-0.1,0.5,0.2,0.8,0.2C239.8,292,239.4,291.9,239.1,291.9z M240.7,292.4c0.6-0.4,1.5-1,2.6-0.5 c0,0.2,0,0.3,0,0.5c-0.4,0.1-0.8-0.3-1,0c-0.7-0.1,0.2-0.2,0.2-0.4C241.9,291.7,241.7,292.6,240.7,292.4z M250.2,292.2 c0.4-0.3,2.1-0.4,2.4,0.1C251.7,292.3,250.6,292.4,250.2,292.2z M251.4,293c0.2-0.3,1.1-0.2,1.8-0.3 C252.8,293.2,252.1,293.1,251.4,293z M252.9,292.3c0.2-0.2,0.7-0.2,1.2-0.3C254.3,292.5,253.2,292.5,252.9,292.3z M253.7,293.3 c-0.1-0.3,0.3-0.4,0.8-0.4C254.6,293.2,254.3,293.3,253.7,293.3z M254.3,292.3c0.4-0.8,2.6,0.1,2.2,0.5 C255.8,292.4,255.2,292.3,254.3,292.3z M256.1,291.8c-0.3-0.1,0.8-0.1,1.6-0.1C257.4,292.2,256.5,292,256.1,291.8z M256.9,293.1 c-0.2-0.3,0.6-0.6,0-0.7c0.9,0,1.1,0.1,2.6,0.2C259.1,293,258.1,293.2,256.9,293.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M96.2,334.1c0.3-0.1,1.7-0.5,1.8,0C97.2,334,97.2,334.1,96.2,334.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M98.5,298.3c0.2-0.2,2.3,0.2,2.8-0.1C101.8,298.6,98.9,298.5,98.5,298.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M112.5,328.1c0.3-0.2,0.5-0.4,1.2-0.4c0,0.3,0.6,0.3,0.6,0.6C113.7,328,113.4,327.9,112.5,328.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M122,321c-0.7,0.1-0.5-0.4-1.2-0.3c0.1-0.3,1.2-0.1,1,0.2c0.2-0.1,0.4-0.2,0.4-0.4 C123,320.7,122.4,320.9,122,321z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M143.2,313.6c0-0.4,0.4-0.5,0.8-0.6C146.9,313.3,143.8,312.9,143.2,313.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M144.1,310.1c-0.3-0.1,0.1-0.2,0-0.4c0.7,0.1,1.4,0.2,2,0.3C145.7,310.5,144.6,309.7,144.1,310.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M147.5,289.1c-0.2,0-0.2,0.2-0.2,0.4c-1.3,0.1-2.2-0.8-3.4-0.3c0.1,0.3,1,0,1.2,0.2 c-0.5,0.2-0.8-0.1-1.6,0.1c-0.2-0.4,0-0.3-0.2-0.7c1.7-0.2,1.5,0.1,3.6,0c-0.6,0.4,1.1,0.2,1,0.4c-0.1-0.5,0.7-0.4,1.2,0 c0.6-0.1-0.3-0.3,0.2-0.5c0.7,0.3,2.3-0.2,2,0.3c0.2,0,0.4,0,0.4,0.1c0.5-0.1-0.4-0.5,0.6-0.5c-0.7,0.4,0.5,0.3,0.8,0.5 c-1,0.7-3.6,0.2-4.9,0.5C147.9,289.4,147.7,289.2,147.5,289.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M144.1,302.7c-0.2-0.3,1.5,0.2,2.2,0.1C145.7,303.1,144.8,302.7,144.1,302.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M147.1,311.1c0.2-0.2,1.1,0.2,1.8,0.1c0.1,0.3-1.1-0.1-1,0.2C147.6,311.3,147.5,311.1,147.1,311.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M163.9,316.1c0.5-0.1,1.3-0.1,2.2,0C165.5,316.1,164.6,316.2,163.9,316.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M172.6,299.5c0.2-0.3,1.3-0.3,1.8-0.3C173.9,299.5,173.1,299.4,172.6,299.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M178.4,296.2c0.3-0.2,1.4-0.1,1.4-0.5C180.3,296,178.8,296.5,178.4,296.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M182.6,289.5c0.3-0.5-0.9-0.8-1.6-0.5c0.3-0.5,2.3-0.3,3.1-0.7c-0.7,0.2-0.8,0.7-1.2,0.5 c-0.5,0-0.1,0.5,0.2,0.5C183.1,289.4,182.6,289.3,182.6,289.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M190,346.8c1.6-0.5,4.5,0.2,5.9-0.7c0.2,0.3,1,0.2,1,0.6c-2-0.3-2.7,0.4-4.2-0.1 C192.2,347.1,190.7,346.8,190,346.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M189.6,298.8c0.2,0.3,0.3,0.1,0.8,0.1c0.7,0.2-0.8,0-0.4,0.4c-0.6,0-1.1,0-1-0.4c0.2,0,0.2,0,0.2,0.1 c0.2-0.1,0.3-0.2,0.4-0.4C189.8,298.7,189.7,298.8,189.6,298.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M195.7,298.6c0.4,0,0.9,0,0.8,0.4c-0.9-0.1-1,0.2-1.6,0.3c0,0.1,0.2,0.1,0.4,0.1c-1,0.7-3,0.2-4.4-0.2 c0.1-0.2,0.4-0.3,0.6-0.5C191.8,299.4,194.9,298.9,195.7,298.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M197.7,291c0.5,0,0.6-0.2,1.2-0.1c-0.1,0.2-0.3,0.3-0.4,0.5c3-0.6,7.6,0.5,10.7-0.5c1.1,0.8,2.3-0.6,3,0.2 c-0.1-0.4-0.1-0.2,0-0.6c-1.3,0.4-3.5,0.1-3.6-0.6c0.1,0.6,0.3-0.7,1-0.1c0.3-0.3-0.5-0.4,0-0.5c0.4,0.2,0.7,0.4,1,0.6 c0.5,0,0.8-0.2,1.2-0.3c0,0.1,0,0.3,0.2,0.4c-0.2-0.7,1-0.2,1.4-0.1c-0.4-0.4-1.5-0.4-1.8-0.8c-0.2,0.4-0.4,0.1-1,0.1 c0-0.1,0-0.3-0.2-0.4c-0.2,0.1-0.9-0.3-1.4,0.1c0.4,0.1,0.4,0.2,0.2,0.4c-1-0.2-2.1,0.2-3.2-0.3c-0.1,0.7-0.8,0.4-1.6,0.3 c0,0.2,0.1,0.4-0.2,0.5c-0.4,0-0.4-0.3-0.6-0.5c0.3,0,1.2-0.2,0.6-0.4c0,0.3-1.4-0.1-1.4,0.3c0.4,0,0.6,0.1,0.6,0.4 c-0.5-0.3-0.4,0.3-1.2,0.1c-0.1,0.3-0.1,0.7-0.4,0.8c-0.5-0.6-1.1,0.2-1.8,0.3c-0.5-0.3-1-0.6-1.2-1.1c-0.6,0.1-0.8,0-1,0.1 c0.4,0,0.4,0.3,0.6,0.5c-1.2,0.3-1.7,0.2-3,0c-0.2,0.3-0.6,0.5-1.2,0.4C194.9,291,197.2,290.4,197.7,291z M205.4,290.7 c-0.2,0-0.2-0.2-0.2-0.4c0.2-0.1,0.5-0.2,1-0.1C206.5,290.7,205.1,290.2,205.4,290.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M197.7,346.2c-0.3-0.3,0.9,0.2,1.6,0.1c-0.2,0.3-1.1,0.3-1.8,0.4C197.8,346.5,198.5,346.4,197.7,346.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M201.4,299.1c-0.4,0-0.2,0.3-0.8,0.2c-0.2-0.2-0.4-0.5-0.8-0.6c0-0.1,0.4-0.1,0.4-0.2 c0.3,0.6,1.4,0.2,1.6,0.9C201.6,299.4,201.4,299.3,201.4,299.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M202,299.1c-0.2-0.4,0.4-0.2,0.4,0c0.3,0,0.6,0,0.6-0.1c0.5,0.1-0.2,0.5-0.6,0.5 C202.5,299.3,202.4,299.1,202,299.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M203.9,348.1c0.2,0,0.1-0.1,0-0.1c0.4-0.3,1.9,0,2.4-0.3c0,0.1-2.7,1-2.8,0.3 C203.7,347.9,203.8,348,203.9,348.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M206.7,348.3c-0.3,0.3,1.1,0.5,1.6,0.7c-0.1-0.4,2.1-0.2,3.6-0.3c-0.7,0.4-4.5,0.7-4.9-0.1 c-1.1-0.1-1.2,0-2.2-0.1c1.4-0.5,4.4-0.4,5.7-0.4C210.1,348.5,207.6,348.2,206.7,348.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M210,299.1c-0.8-0.2,0-0.1,0-0.5c0.3,0,0.7,0,1,0c-0.4,0.2,0.1,0.2,0.2,0.5c0.6,0,0.1-0.7,1-0.5 c0.1,0.3-0.4,0.2-0.4,0.4c0.7-0.3,1.5-0.3,2.2,0c-0.3,0.3-0.7,0.2-1.2,0c-0.2,0.2-0.5,0.3-0.6,0.6c-0.2-0.1-0.5-0.1-0.8-0.1 c0-0.1,0.4-0.1,0.6-0.1C211.6,299.3,210.2,298.7,210,299.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M212.6,348.1c0.2,0.2,0.5,0.2,0.8,0.4c-0.1,0.2-0.5,0.1-0.8,0.1c0.3-0.2,0.1-0.4-0.4-0.4 c0.5-0.2,0.4-0.6,1.2-0.6C213.6,348.1,212.8,348,212.6,348.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M214.9,347.1c0.5-0.3,1.1,0.1,1.6-0.1C216.4,347.4,215.4,347.1,214.9,347.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M214.7,298.8c0.5,0,0.7,0,0.8,0.2c0.6-0.1,0.2-0.2,0.2-0.5c0.3,0,0.5,0,0.8,0c-1,0.4,0.4,0.2,0.4,0.6 C216,298.9,215.1,299.3,214.7,298.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M219.6,298.7c-0.8-0.1-1.3,0.2-1.6,0c0.1-0.2,0.3-0.2,0.4-0.4c0.5,0.2,1.8,0.2,1.2,0.7 C219.4,299,219.7,298.9,219.6,298.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M221.9,318.3c0.1,0.4-2.4,0.4-1.4,0.3C221.2,318.5,221.1,318.1,221.9,318.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M221.9,318.8c0.4-0.3,1.4,0,2,0C223.6,319,222.7,318.6,221.9,318.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M225.4,300c-0.2-0.2-0.6-0.2-0.6-0.5c1.4-0.1,1.9,0,3-0.1c-0.4,0.3-0.2,0.3-0.4,0.6c-0.2,0-0.4,0-0.6,0 c0-0.1,0.4-0.1,0.6-0.1C227.2,299.4,225.5,299.6,225.4,300z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M228.5,296.5c0.7-0.2,1.3,0.2,2.4,0C230.2,296.8,229.3,296.7,228.5,296.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M230.5,291.5c-0.6,0.1-0.3-0.4-1-0.2c0.2-0.3,0.9-0.3,1-0.7C231.1,291,229.6,291.1,230.5,291.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M230.7,297.4c0.4,0.2,1.2,0.2,1.8,0.3c0-0.1,0-0.2,0-0.2C233.4,298,230.6,298,230.7,297.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M233.7,293.2c-0.1-0.3,0.1-0.3,0.2-0.5c0.5,0.1,0.4,0.8,1.2,0.5c0.6,0.1-0.4,0.2-0.4,0.4 C234.4,293.4,234.3,293.2,233.7,293.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M234.3,297.8c0.3-0.5,1.3,0,1.8,0.1c-0.1,0.1-0.2,0.2-0.2,0.4c0.8-0.3,0.5,0.3,1.2,0.3 c0.2,0,0.1-0.2,0.4-0.2c0.6-0.1,0.9,0.1,0.8,0.5c-1-0.2-0.9-0.1-2,0c0-0.1,0-0.2,0-0.4c-0.5,0-0.8,0-1-0.1 c0.1,0.3,0.3,0.4-0.2,0.6c-0.1,0.3,0.9-0.1,0.6,0.4c-0.4-0.1-0.8-0.2-1.2-0.3c0.9-0.2,0.4-0.4,0.2-0.8c0.4,0.2,0.5,0,1,0 C235.8,297.6,234.9,297.8,234.3,297.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M234.9,292.7c0.5,0.1,0.6,0.3,1.2,0.1c0,0.2,0.2,0.3,0.4,0.4C236.5,293.2,234.9,293.1,234.9,292.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M238,298.2c0.6-0.4,1.1,0.2,1.2,0.5c0.2-0.1,0.2-0.3,0.6-0.2C239.4,299.2,238.7,298.3,238,298.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M251.1,352.3c0.4-0.1,1.8,0.1,2.6,0.1C253.1,352.7,251.8,352.4,251.1,352.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M253.3,323.6c-0.4,0-0.7,0.1-0.4,0.1c-1,0.1-1.2-0.2-0.2-0.6c0.2,0,0.4,0.5,0.6,0.1 C253.6,323.3,253.2,323.4,253.3,323.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M260.1,323.6c0-0.1,0.2-0.1,0.2,0c0.2-0.1,0.4-0.3,1-0.2C261.1,323.6,260.5,323.8,260.1,323.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M261.8,352.1c0.5-0.4,1.2-0.1,2,0C263.5,352.3,262.5,352,261.8,352.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M283.8,352.9c-0.1,0-0.3,0-0.4,0c0-0.1-0.1-0.1-0.2-0.1c0.5-0.2,0.9-0.4,1.6-0.5 C284.8,352.6,283.9,352.3,283.8,352.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M291.3,352.3c-0.4,0.3-1.9-0.2-1,0.2c-1.7-0.4-3.1-0.5-4.8-0.2c1.3,0,1.4,0.3,2.2,0.5c-1.3,0.4-2.1-0.5-3,0 c0.3,0,0.1,0.3,0,0.4c0.5,0,1.2-0.1,1.2,0.2c-0.2,0.2-1.6-0.3-1.8,0.3c5-0.2,8.9-0.1,13.9-0.1c-0.3-0.2-0.9-0.2-1.2-0.3 c0.2,0,0.4,0,0.4-0.1c-0.2,0-0.4,0-0.4-0.1c0.7,0.1,1.8-0.2,1.4-0.4c-0.3,0.4-1.2,0.1-1.8,0c-0.5,0.2,0.4,0.6-0.4,0.7 c-1.3-0.4-3.3,0.4-4-0.3c0.7-0.3,2.8,0.4,3.4-0.5c-1.1,0-2.5,0.3-3.4-0.2c-0.2,0.1-0.4,0.2-0.6,0.4 C290.8,352.5,291.6,352.4,291.3,352.3z M287.9,352.8c-0.1-0.4,0.9-0.4,1.2-0.3C288.9,352.8,288.5,352.8,287.9,352.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M284.8,347.8c0-0.3,0.8-0.1,1.2-0.1c-0.1,0.1-0.2,0.2,0,0.2C285.9,348.2,285.3,347.7,284.8,347.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M297.7,350c0.6-0.2,1.7-0.6,2.6-0.3C299.7,349.9,298.5,349.8,297.7,350z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M299.2,350.7c-0.3,0-0.2-0.3-0.2-0.5c0.5,0,1.7-0.5,1.6,0.2C299.9,350.3,299.1,350,299.2,350.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M306.7,353.4c0-0.1,0-0.2-0.2-0.2c0.7-0.4,1.5-0.1,2.2,0.1C308.3,353.5,307.5,353.1,306.7,353.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M307.5,290.9c-0.5,0.1-1.1-0.4-0.6-0.6C306.9,290.2,307.1,290.7,307.5,290.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M309.8,350.1c-0.4,0-0.4-0.1-0.8-0.1c0.4-0.4,0.7-0.3,1.6-0.4C311.1,349.8,309.6,349.7,309.8,350.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M315.2,350.6c0.8-0.4,2.4,0,3.4-0.5C318,350.8,316.3,350.5,315.2,350.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M317.4,351.3c-0.1,0.2,0.2,0.2,0.4,0.2c0,0.3-0.5,0.3-0.8,0.1c-0.1-0.3,0.8-0.9,0.8-0.4 C317.6,351.3,317.5,351.3,317.4,351.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M318,290.1c-0.3-0.3,1.3,0.3,1.8,0c-0.5,0.3,0.4,0.5,0.8,0.6c-0.4,0.4-1,0.1-1.8,0.1 C319.7,290.5,318.5,290.3,318,290.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M320.3,278.5c0,0.3-0.7,0.1-1,0.1c0.1-0.6,0.9-0.7,1.8-0.9C320.4,278.3,320.4,278.3,320.3,278.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M326.3,353.4c0.2-0.5,1,0,1.6,0C327.7,353.7,327,353.3,326.3,353.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M344.5,289.3c-0.1,0.2-0.3,0-0.6,0c0.3-0.2,0.6-0.3-0.2-0.2c-0.2-0.2,1.1-0.3,1.6-0.1 C345.2,289.1,343.8,289,344.5,289.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M366.7,289.9c-0.6,0,1.3-0.3,1.6-0.6c0.2,0.2,1.1,0.6,1.4,0.3c0.4,0.6-1,0-2,0c0.1,0.2,0.5,0.2,0.8,0.4 C368.1,290.3,367.6,289.7,366.7,289.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M373,291c-0.4-0.1-1.2,0.2-1-0.2c1.2,0.1,1.4-0.6,0.8-0.8c0.1-0.1,0.5-0.1,0.4-0.4 C373.9,290,373.1,290.5,373,291z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M376.4,289.7c-0.2,0.4,0.6,0.7,0.2,0.8c-0.7-0.1-0.1-0.5-0.6-0.8c0.3,0,0.4-0.1,0.4-0.2 c1.2,0.3,1.7-0.2,3.2,0c-0.2,0.2-0.7,0.3-1,0.1c0.4,0.5-0.7,0.4-1.4,0.7c0-0.2,0-0.4,0-0.6C376.9,289.7,376.6,289.7,376.4,289.7z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M384.3,284.2c-0.3,0.6,0.6,0.4,1,0.6C384.9,285.2,382.9,284.3,384.3,284.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M393.4,291.2c-0.4,0-2.8,0-0.6-0.2C393,291.1,393.2,291.2,393.4,291.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M395.8,290.7c-0.7,0.2-1.3,0.3-2.4,0.3c0.5-0.3-0.3-0.5-0.4-0.7c0.5-0.1,1.4,0,1.6,0.3 c0.3-0.1-0.1-0.2,0.2-0.5c0.3,0.2,0.9,0.2,1.2,0C396.3,290.3,395.2,290.3,395.8,290.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M395.6,291.7c0.8-0.6,4.1-1.2,6.1-1.3c0.2,0,0.2-0.2,0.2-0.4c0.5,0.1,0.6,0.2,0.4,0.6 c0.9,0,0.9-0.2,1.4,0.1c0.2-0.1,0.4-0.2,0.4-0.4c4.3,0.2,7.6-0.2,10.5-0.5c-0.6,0.4,0.7,0.2,0.4,0.7c0.2-0.1,0.3-0.1,0.6-0.1 c-0.1-0.2-0.8-0.1-0.6-0.5c1,0.2,1.4,0.1,1.8,0.7c-0.3,0.4-1.1-0.5-1,0.2c-6,0-9.4-0.1-16.2-0.1c-0.5-0.1-0.4,0.3-0.6,0.4 c-0.1-0.2-0.9,0-1-0.2c-0.3,0.1-0.6,0.2-0.6,0.5C396.9,291.6,395.8,291.4,395.6,291.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M411.7,301.6c0-0.4,0.9-0.2,1.2-0.4c-0.1-0.1-0.4-0.2-0.6-0.2c1.2-0.8,3.3-0.2,5.1-0.4 c-0.6,0.7,4,0.9,4.4,0.2c0.6-0.1,0.4,0.3,0.8,0.4c0.5-0.2,0.7-0.5,1.4-0.6c-0.1,0.1-0.2,0.3-0.2,0.5c0.9-0.2,1.3,0.6,2,0.8 c0.2-0.3,0.9-0.2,1.4-0.1c-0.8,0.3,0.2,0.4,1,0.4c-1.1,0.3-1.5,0.7-2.8,0.7c0.1-0.2,0.3-0.2,0.4-0.4c-0.6-0.3-1.8-0.4-2.6-0.3 c-0.3-0.2-0.3-0.4,0-0.6c-0.6,0.4-2.4-0.1-2.8,0.6c-0.4-0.1-0.8-0.2-1.4-0.2c0.2-0.5,0.6,0,1.2,0c0.2-0.1,0.3-0.2,0.4-0.4 C418.2,301.6,414.5,301.4,411.7,301.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M413.8,306c-0.4-0.3-1.5-0.2-1.8-0.6c0.8,0,1.9,0.4,2.4,0.2C414.9,305.7,413.9,305.9,413.8,306z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M416.9,365.2c0.1-0.1,0.2-0.3,0.2-0.5c0.2,0.4,0.9,0.6,1.6,0.3c0.2,0.1,0.1,0.3,0.4,0.4 c-0.2,0.4-0.5,0-1.2,0.1C418,365.1,417.5,365.1,416.9,365.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M419.7,296.1c-1.2,0.2-1.8,0.1-3,0.3c0.1-0.1,0.2-0.2,0.6-0.2c-0.1-0.1-0.2-0.2-0.2-0.4 c1.1,0.4,2,0.1,3-0.1C419.8,295.8,418.4,296.2,419.7,296.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M422.4,295.9c-0.4-0.3,0.8,0.1,0.6,0.5c-0.2-0.1-0.5-0.1-0.8-0.1C422.1,296.1,423,295.9,422.4,295.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M423.4,293.1c0-0.1,0.1-0.1,0.2-0.1c0-0.1,0-0.2,0-0.2c0.3,0.5,2.4,0,2.2,0.8c-0.4,0.1-0.4-0.2-0.4-0.4 C424.5,293.1,423.8,293.2,423.4,293.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M430.7,284.4c0.6,0,0.6,0.3,1.2,0.2c-0.4,0.1-0.9,0.5-1.6,0.4c0,0.2,0.3,0.3,0.2,0.5c-0.7,0-0.8-0.2-1.4,0 c0.1,0.1,0.3,0.2,0.6,0.2c-0.3,0.4-0.6,0.1-1,0.5c-0.4,0,0-0.5,0.2-0.6c-0.3-0.1-0.5-0.3-1-0.4c0.1-0.1,0.5-0.1,0.4-0.4 C429.6,284.7,430.1,284.9,430.7,284.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M429.3,309.8c-0.2,0-0.1-0.1,0-0.1c-0.1-0.1-0.5-0.1-0.4-0.4c0.6,0.1,0.9,0.4,1.4,0.5 C430.9,310.2,429.2,309.6,429.3,309.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M431,306.9c0.3-0.2,0.4-0.5,1.2-0.5c-0.7,0.6,1.1-0.2,1.8,0.1c0.2,0,0.5-0.5,0.2-0.5 c0.9,0.2,3.9,0.1,5.2,0.7c0.4-0.8,1.4,0.3,1.8-0.5c0.4,0,0.1,0.4,0.4,0.5c0.9-0.4,2,0.2,2.8,0.1c0.3,0-0.2,1,0.6,0.5 c0.3,0.5-1.1,0.3-1.2-0.2c-0.9,0.1-1.4,0-2.2-0.2c-0.3,0-0.4,0.2-0.4,0.5c-1.1-0.1-1.2-0.3-2.2,0c0.4-1.3-2.7,0-3.8-0.9 C434.2,306.9,432.7,306.7,431,306.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M435,298.3c0.2-0.2,0.6-0.3,1.2-0.3c0.2-0.3-0.3-0.3-0.2-0.6c1.1,0,1.6-0.3,2.4-0.5 c-0.5,0.7,4.1,0.4,4.4,1.4c0.2-0.1,0.4-0.1,0.8-0.1c0.4,0.3,0.9,0.5,1.8,0.6c1,0.8,3.2,1,3.8,1.8c-0.6-0.2-1.7,0.1-1.4,0.1 c-3.4,0.4-9.4-1.2-12.1,0.4c0.7,0.2,1.2-0.6,2.6-0.4c-1,0.4-1.2,0.9-2.5,1.2c0,0.3,1.3-0.2,1,0.4c-0.3,0.2-0.7-0.1-1.4,0 c0.9-0.8-1.9-0.7-2.6-0.6c0-0.2,0.5-0.2,0.4-0.5c0.7-0.1,1.3,0.3,1.8,0c-0.9-0.8-2.3-0.3-3.8-0.4c1.5-0.1,2.8-1.3,4.5-1.7 c0.8,0.1,1.9,0.1,2-0.5c0.5,0,0.4,0.4,1,0.3c0.6-0.2-0.1-0.6,1.4-0.5c0.3-0.1,0.4-0.3,0.4-0.5c-0.5-0.5-2.6,0.2-2.2-0.5 c-0.4-0.1-0.3,0.2-0.6,0.2c-0.1,0.3,0.9-0.1,0.6,0.4c-0.4,0.2-1,0.1-0.8-0.4C436.3,297.7,436.2,298.3,435,298.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M433.4,307.9c0-0.3,0.5,0.2,1,0c0.2,0.4,0.1,0.3-0.2,0.6C434,308.2,434.3,307.9,433.4,307.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M441.7,307.6c0.8,0,1.7,0,2.6,0.2C444.1,307.8,441.9,308,441.7,307.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M445,302.5c-0.1,1-2.3,0-3.4-0.2C442.9,302.3,444.2,302.2,445,302.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M449.1,330.7c0.8-0.1,0.6,0.5,1.2,0.6C450.7,331.4,448.8,331.1,449.1,330.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M466.6,359.9c0.8,0,0.7,0.6,1.2,0.7C467.7,360.7,466.7,360.3,466.6,359.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M469.4,344.3c0.1-0.3,0.5,0.2,1,0.1c-0.1,0.2-0.5,0.3-1,0.4C469.6,344.5,470.1,344.4,469.4,344.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M472.8,361c0.3,0,1.4,0,1.8,0.5C473.7,361.3,473.5,361.4,472.8,361z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M473.4,362.2c0.4-0.4,0.8,0.2,1.2,0.2C476,362.7,473.6,362.5,473.4,362.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M488,350.7c0.4,0,0.4-0.1,0.8-0.1c0,0.5-1.5,0.5-1.8,0.4c0.9-0.3-0.1-0.6-0.2-1c0.5-0.3,1.2-0.6,0.6-1 c0.7,0.2,1.6,0.3,2,0.7C488.5,349.6,487.4,349.6,488,350.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M509.5,348.8c-0.8-0.3-0.5,0.1-0.2,0.4c-0.1-0.5,1.3-0.2,2.4-0.4c0.1,0.2,0.5,0.3,0.4,0.7 c-0.6,0-2.2-0.4-2,0.5c-1.5,0.4-4,0.3-5.1,0.9c0.7,1.2,2,0.7,3.6,0.2c-0.1,0.5,0.5,0.4,0.8,0.6c-1,1.3-3.5,0.3-5.1,0 c0.5-0.1-0.4-0.4,0.2-0.6c-1.1-0.7-2.9-1-3.6-2c-0.5,0-0.4,0.2-1,0.1c0.1-0.3,0-0.5-0.2-0.6c-0.7,0.2-1.6,0.4-1.2-0.3 c-0.3,0-1-0.1-0.8,0.2c-0.3-0.2-0.4-0.5-0.8-0.6c-0.6-0.1-0.1,0.4-0.8,0.2c-0.2-0.6-1.5-0.4-1.6-1.1c-0.9,0.4-2.1-0.5-2.6-1.1 c2.6-1.1,4.2,0.7,7.7,0.6c0,0.8,1.1,0.9,2.2,0.7c0.3,0.1,0.4,0.4,0.4,0.7c0.7,0,1.3,0,1.8,0.1c1.9-0.7,3.3-1.8,6.5-2 c0.3,0.4,0.4,0.2,1,0.3c-0.9,0.3-1.4,0.9-2.1,1.3C509.6,348.1,509.5,348.5,509.5,348.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M43.6,327.1c0.2-0.1,0.2-0.3,0.2-0.5c0.9,0.1,1.1-0.2,2-0.1c-0.1,0.3,0.2,0.8,0.4,0.5 c0.5,0.2-0.8,0.6,0.6,0.5c0,0.5-1.3,0.2-1.2,0.7C45,327.5,44.7,327.4,43.6,327.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M187.9,288.9c0.4-0.3,1.3-0.4,1.8-0.7c0.4,0,0.4,0.3,0.4,0.6c0.2-0.1,0.4-0.1,0.4,0.1 c0.6-0.3,1.1-0.1,1.8-0.4c0.4,0.3,0.6,0.7,1.6,0.6c-1.4,0.3-2.8-0.2-3.6,0.2c-0.4-0.2-0.6-0.5-1.2-0.6c-0.5,0.2-0.7,0.5-1.6,0.5 c0.1-0.2,0-0.4-0.4-0.4c0.1-0.1,0.2-0.2,0.2-0.4C187.6,288.6,187.7,288.8,187.9,288.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M231.3,296.7c0.3-0.1,0.3-0.4,0.8-0.4c-0.1,0.5,0.9,0.4,1.6,0.5c0.1,0.5-1.2,0.1-1.8,0.3 C231.7,296.9,231.8,296.6,231.3,296.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M422.2,287.8c0.1,0.3-0.7,0.1-0.6,0.6c-0.3-0.4-1.5-0.2-1.4-0.8c-1,0.2-1.8,0.6-1.5,1.6 c-2,0.8-4.8,0.1-6-0.7c-0.7-1.5,0.1-2.6,1.7-2.8c2.4-0.3,5,1.3,6.7,0.7c0.7,0.2,2.6,0.2,3.6,0.6c-0.2,0.4,0,0.3,0,0.7 c-0.7,0.1-2-0.1-2,0.5C422.6,288.1,422.4,288,422.2,287.8z"
  }))))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M50.6,333.6h-5v-24.2h5V333.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8,315.6l0.1,2c1.3-1.6,3-2.3,5.2-2.3c2.3,0,3.9,0.9,4.8,2.7c1.3-1.8,3.1-2.7,5.4-2.7c1.9,0,3.4,0.6,4.3,1.7 c1,1.1,1.4,2.8,1.4,5.1v11.5h-4.8v-11.5c0-1-0.2-1.8-0.6-2.2c-0.4-0.5-1.1-0.7-2.1-0.7c-1.4,0-2.4,0.7-3,2.1l0,12.3h-4.8v-11.4 c0-1-0.2-1.8-0.6-2.3c-0.4-0.5-1.1-0.7-2.1-0.7c-1.4,0-2.3,0.6-3,1.7v12.7h-4.8v-18H60.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6,315.6l0.1,2c1.3-1.6,3-2.3,5.2-2.3c2.3,0,3.9,0.9,4.8,2.7c1.3-1.8,3.1-2.7,5.4-2.7c1.9,0,3.4,0.6,4.3,1.7 c1,1.1,1.4,2.8,1.4,5.1v11.5h-4.8v-11.5c0-1-0.2-1.8-0.6-2.2c-0.4-0.5-1.1-0.7-2.1-0.7c-1.4,0-2.4,0.7-3,2.1l0,12.3h-4.8v-11.4 c0-1-0.2-1.8-0.6-2.3c-0.4-0.5-1.1-0.7-2.1-0.7c-1.4,0-2.3,0.6-3,1.7v12.7h-4.8v-18H91.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.8,331.7c-1.2,1.4-2.8,2.2-4.9,2.2c-1.9,0-3.4-0.6-4.4-1.7c-1-1.1-1.5-2.7-1.6-4.9v-11.8h4.8v11.6 c0,1.9,0.9,2.8,2.6,2.8c1.6,0,2.7-0.6,3.4-1.7v-12.7h4.8v18h-4.5L128.8,331.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.9,315.6l0.1,2.1c1.3-1.6,3-2.4,5.2-2.4c1.9,0,3.3,0.6,4.3,1.7s1.4,2.8,1.4,5v11.6h-4.8v-11.5c0-1-0.2-1.8-0.7-2.2 c-0.4-0.5-1.2-0.7-2.2-0.7c-1.4,0-2.4,0.6-3,1.7v12.7h-4.8v-18H142.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.2,333.9c-2.6,0-4.8-0.8-6.4-2.4c-1.7-1.6-2.5-3.8-2.5-6.5v-0.5c0-1.8,0.3-3.4,1-4.8c0.7-1.4,1.7-2.5,3-3.3 c1.3-0.8,2.7-1.2,4.4-1.2c2.5,0,4.4,0.8,5.8,2.3c1.4,1.5,2.1,3.7,2.1,6.6v2h-11.4c0.2,1.2,0.6,2.1,1.4,2.8c0.8,0.7,1.8,1.1,3,1.1 c1.8,0,3.3-0.7,4.3-2l2.4,2.6c-0.7,1-1.7,1.8-2.9,2.4C170.1,333.6,168.7,333.9,167.2,333.9z M166.7,319.1c-1,0-1.7,0.3-2.3,1 c-0.6,0.6-1,1.6-1.1,2.8h6.7v-0.4c0-1.1-0.3-1.9-0.9-2.5C168.5,319.4,167.7,319.1,166.7,319.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.7,320.1c-0.7-0.1-1.2-0.1-1.7-0.1c-1.8,0-3,0.6-3.6,1.8v11.8h-4.8v-18h4.5l0.1,2.1c1-1.6,2.3-2.5,4-2.5 c0.5,0,1,0.1,1.5,0.2L198.7,320.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.4,333.9c-2.6,0-4.8-0.8-6.4-2.4c-1.7-1.6-2.5-3.8-2.5-6.5v-0.5c0-1.8,0.3-3.4,1-4.8c0.7-1.4,1.7-2.5,3-3.3 c1.3-0.8,2.7-1.2,4.4-1.2c2.5,0,4.4,0.8,5.8,2.3c1.4,1.5,2.1,3.7,2.1,6.6v2h-11.4c0.2,1.2,0.6,2.1,1.4,2.8c0.8,0.7,1.8,1.1,3,1.1 c1.8,0,3.3-0.7,4.3-2l2.4,2.6c-0.7,1-1.7,1.8-2.9,2.4C213.3,333.6,211.9,333.9,210.4,333.9z M209.9,319.1c-1,0-1.7,0.3-2.3,1 c-0.6,0.6-1,1.6-1.1,2.8h6.7v-0.4c0-1.1-0.3-1.9-0.9-2.5C211.7,319.4,210.9,319.1,209.9,319.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.7,328.6c0-0.6-0.3-1-0.9-1.4c-0.6-0.3-1.5-0.6-2.8-0.9c-4.3-0.9-6.4-2.7-6.4-5.4c0-1.6,0.7-2.9,2-4 c1.3-1.1,3.1-1.6,5.2-1.6c2.3,0,4.1,0.5,5.5,1.6c1.4,1.1,2,2.5,2,4.2h-4.8c0-0.7-0.2-1.3-0.7-1.7c-0.4-0.4-1.1-0.7-2.1-0.7 c-0.8,0-1.4,0.2-1.9,0.5s-0.7,0.8-0.7,1.4c0,0.5,0.3,1,0.8,1.3c0.5,0.3,1.4,0.6,2.5,0.8c1.2,0.2,2.2,0.5,3,0.8 c2.5,0.9,3.8,2.5,3.8,4.8c0,1.6-0.7,3-2.1,4c-1.4,1-3.2,1.5-5.4,1.5c-1.5,0-2.8-0.3-4-0.8c-1.2-0.5-2.1-1.3-2.7-2.2 c-0.7-0.9-1-1.9-1-3h4.5c0,0.9,0.4,1.5,0.9,2s1.4,0.7,2.4,0.7c0.9,0,1.6-0.2,2.1-0.5C231.4,329.6,231.7,329.2,231.7,328.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257,324.7c0,2.8-0.6,5-1.9,6.6c-1.3,1.7-3,2.5-5.1,2.5c-1.8,0-3.3-0.6-4.4-1.9v8.5h-4.8v-24.9h4.4l0.2,1.8 c1.2-1.4,2.7-2.1,4.5-2.1c2.2,0,3.9,0.8,5.2,2.5s1.8,3.9,1.8,6.8V324.7z M252.2,324.4c0-1.7-0.3-3-0.9-3.9 c-0.6-0.9-1.5-1.4-2.6-1.4c-1.5,0-2.5,0.6-3.1,1.7v7.4c0.6,1.2,1.6,1.8,3.1,1.8C251.1,330,252.2,328.1,252.2,324.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.7,324.4c0-1.8,0.3-3.4,1-4.8s1.7-2.5,3-3.2c1.3-0.8,2.8-1.1,4.5-1.1c2.4,0,4.4,0.7,5.9,2.2c1.5,1.5,2.4,3.5,2.6,6 l0,1.2c0,2.8-0.8,5-2.3,6.6c-1.5,1.7-3.6,2.5-6.2,2.5s-4.7-0.8-6.2-2.5c-1.5-1.7-2.3-3.9-2.3-6.8V324.4z M265.5,324.7 c0,1.7,0.3,3,1,3.9c0.6,0.9,1.6,1.4,2.8,1.4c1.2,0,2.1-0.4,2.7-1.3c0.7-0.9,1-2.3,1-4.3c0-1.7-0.3-3-1-3.9s-1.6-1.4-2.8-1.4 c-1.2,0-2.1,0.5-2.7,1.4C265.8,321.4,265.5,322.8,265.5,324.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.5,315.6l0.1,2.1c1.3-1.6,3-2.4,5.2-2.4c1.9,0,3.3,0.6,4.3,1.7s1.4,2.8,1.4,5v11.6h-4.8v-11.5c0-1-0.2-1.8-0.7-2.2 c-0.4-0.5-1.2-0.7-2.2-0.7c-1.4,0-2.4,0.6-3,1.7v12.7H282v-18H286.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.3,328.6c0-0.6-0.3-1-0.9-1.4c-0.6-0.3-1.5-0.6-2.8-0.9c-4.3-0.9-6.4-2.7-6.4-5.4c0-1.6,0.7-2.9,2-4 c1.3-1.1,3.1-1.6,5.2-1.6c2.3,0,4.1,0.5,5.5,1.6c1.4,1.1,2,2.5,2,4.2h-4.8c0-0.7-0.2-1.3-0.7-1.7c-0.4-0.4-1.1-0.7-2.1-0.7 c-0.8,0-1.4,0.2-1.9,0.5s-0.7,0.8-0.7,1.4c0,0.5,0.3,1,0.8,1.3c0.5,0.3,1.4,0.6,2.5,0.8c1.2,0.2,2.2,0.5,3,0.8 c2.5,0.9,3.8,2.5,3.8,4.8c0,1.6-0.7,3-2.1,4c-1.4,1-3.2,1.5-5.4,1.5c-1.5,0-2.8-0.3-4-0.8c-1.2-0.5-2.1-1.3-2.7-2.2 c-0.7-0.9-1-1.9-1-3h4.5c0,0.9,0.4,1.5,0.9,2s1.4,0.7,2.4,0.7c0.9,0,1.6-0.2,2.1-0.5C312,329.6,312.3,329.2,312.3,328.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.7,333.9c-2.6,0-4.8-0.8-6.4-2.4c-1.7-1.6-2.5-3.8-2.5-6.5v-0.5c0-1.8,0.3-3.4,1-4.8c0.7-1.4,1.7-2.5,3-3.3 c1.3-0.8,2.7-1.2,4.4-1.2c2.5,0,4.4,0.8,5.8,2.3c1.4,1.5,2.1,3.7,2.1,6.6v2h-11.4c0.2,1.2,0.6,2.1,1.4,2.8c0.8,0.7,1.8,1.1,3,1.1 c1.8,0,3.3-0.7,4.3-2l2.4,2.6c-0.7,1-1.7,1.8-2.9,2.4C332.6,333.6,331.2,333.9,329.7,333.9z M329.2,319.1c-1,0-1.7,0.3-2.3,1 c-0.6,0.6-1,1.6-1.1,2.8h6.7v-0.4c0-1.1-0.3-1.9-0.9-2.5C331,319.4,330.2,319.1,329.2,319.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351,328.6c0-0.6-0.3-1-0.9-1.4c-0.6-0.3-1.5-0.6-2.8-0.9c-4.3-0.9-6.4-2.7-6.4-5.4c0-1.6,0.7-2.9,2-4 c1.3-1.1,3.1-1.6,5.2-1.6c2.3,0,4.1,0.5,5.5,1.6c1.4,1.1,2,2.5,2,4.2h-4.8c0-0.7-0.2-1.3-0.7-1.7c-0.4-0.4-1.1-0.7-2.1-0.7 c-0.8,0-1.4,0.2-1.9,0.5s-0.7,0.8-0.7,1.4c0,0.5,0.3,1,0.8,1.3c0.5,0.3,1.4,0.6,2.5,0.8c1.2,0.2,2.2,0.5,3,0.8 c2.5,0.9,3.8,2.5,3.8,4.8c0,1.6-0.7,3-2.1,4c-1.4,1-3.2,1.5-5.4,1.5c-1.5,0-2.8-0.3-4-0.8c-1.2-0.5-2.1-1.3-2.7-2.2 c-0.7-0.9-1-1.9-1-3h4.5c0,0.9,0.4,1.5,0.9,2s1.4,0.7,2.4,0.7c0.9,0,1.6-0.2,2.1-0.5C350.8,329.6,351,329.2,351,328.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.5,333.6c-0.2-0.4-0.4-1-0.5-1.6c-1.2,1.3-2.7,1.9-4.5,1.9c-1.8,0-3.2-0.5-4.4-1.5c-1.2-1-1.7-2.3-1.7-3.9 c0-1.9,0.7-3.4,2.1-4.4c1.4-1,3.5-1.5,6.1-1.5h2.2v-1c0-0.8-0.2-1.5-0.6-2c-0.4-0.5-1.1-0.7-2-0.7c-0.8,0-1.4,0.2-1.9,0.6 c-0.5,0.4-0.7,0.9-0.7,1.6h-4.8c0-1,0.3-2,1-2.9s1.5-1.6,2.7-2.1c1.2-0.5,2.5-0.8,4-0.8c2.2,0,4,0.6,5.3,1.7c1.3,1.1,2,2.7,2,4.7 v7.8c0,1.7,0.2,3,0.7,3.9v0.3H380.5z M376.5,330.2c0.7,0,1.4-0.2,2-0.5c0.6-0.3,1-0.7,1.3-1.3v-3.1H378c-2.4,0-3.7,0.8-3.8,2.5 l0,0.3c0,0.6,0.2,1.1,0.6,1.5S375.8,330.2,376.5,330.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389,324.4c0-2.8,0.6-5,1.9-6.7c1.3-1.7,3-2.5,5.2-2.5c1.7,0,3.2,0.7,4.3,2v-9.2h4.8v25.5h-4.3l-0.2-1.9 c-1.2,1.5-2.7,2.2-4.6,2.2c-2.1,0-3.8-0.8-5.1-2.5C389.6,329.7,389,327.4,389,324.4z M393.8,324.8c0,1.7,0.3,3,0.9,3.9 s1.4,1.3,2.6,1.3c1.5,0,2.5-0.6,3.1-1.9V321c-0.6-1.3-1.6-1.9-3.1-1.9C394.9,319.2,393.8,321,393.8,324.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.6,333.9c-2.6,0-4.8-0.8-6.4-2.4c-1.7-1.6-2.5-3.8-2.5-6.5v-0.5c0-1.8,0.3-3.4,1-4.8c0.7-1.4,1.7-2.5,3-3.3 c1.3-0.8,2.7-1.2,4.4-1.2c2.5,0,4.4,0.8,5.8,2.3c1.4,1.5,2.1,3.7,2.1,6.6v2h-11.4c0.2,1.2,0.6,2.1,1.4,2.8c0.8,0.7,1.8,1.1,3,1.1 c1.8,0,3.3-0.7,4.3-2l2.4,2.6c-0.7,1-1.7,1.8-2.9,2.4C421.4,333.6,420.1,333.9,418.6,333.9z M418,319.1c-1,0-1.7,0.3-2.3,1 c-0.6,0.6-1,1.6-1.1,2.8h6.7v-0.4c0-1.1-0.3-1.9-0.9-2.5C419.8,319.4,419.1,319.1,418,319.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.4,324.4c0-2.8,0.6-5.1,1.9-6.7c1.3-1.6,3-2.5,5.2-2.5c1.9,0,3.5,0.7,4.6,2.2l0.3-1.9h4.2v24.9h-4.8V332 c-1.1,1.3-2.6,1.9-4.3,1.9c-2.1,0-3.8-0.8-5.1-2.5S429.4,327.4,429.4,324.4z M434.2,324.7c0,1.7,0.3,3,0.9,3.9 c0.6,0.9,1.5,1.3,2.5,1.3c1.5,0,2.5-0.6,3.1-1.8v-7.4c-0.6-1.1-1.6-1.7-3.1-1.7c-1.1,0-2,0.4-2.6,1.3 C434.5,321.4,434.2,322.8,434.2,324.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.5,331.7c-1.2,1.4-2.8,2.2-4.9,2.2c-1.9,0-3.4-0.6-4.4-1.7c-1-1.1-1.5-2.7-1.6-4.9v-11.8h4.8v11.6 c0,1.9,0.9,2.8,2.6,2.8c1.6,0,2.7-0.6,3.4-1.7v-12.7h4.8v18h-4.5L461.5,331.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.6,333.6c-0.2-0.4-0.4-1-0.5-1.6c-1.2,1.3-2.7,1.9-4.5,1.9c-1.8,0-3.2-0.5-4.4-1.5c-1.2-1-1.7-2.3-1.7-3.9 c0-1.9,0.7-3.4,2.1-4.4c1.4-1,3.5-1.5,6.1-1.5h2.2v-1c0-0.8-0.2-1.5-0.6-2c-0.4-0.5-1.1-0.7-2-0.7c-0.8,0-1.4,0.2-1.9,0.6 c-0.5,0.4-0.7,0.9-0.7,1.6h-4.8c0-1,0.3-2,1-2.9s1.5-1.6,2.7-2.1c1.2-0.5,2.5-0.8,4-0.8c2.2,0,4,0.6,5.3,1.7c1.3,1.1,2,2.7,2,4.7 v7.8c0,1.7,0.2,3,0.7,3.9v0.3H481.6z M477.7,330.2c0.7,0,1.4-0.2,2-0.5c0.6-0.3,1-0.7,1.3-1.3v-3.1h-1.8c-2.4,0-3.7,0.8-3.8,2.5 l0,0.3c0,0.6,0.2,1.1,0.6,1.5S476.9,330.2,477.7,330.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.6,311.2v4.4h3.1v3.5h-3.1v9c0,0.7,0.1,1.1,0.4,1.4s0.7,0.4,1.5,0.4c0.5,0,1,0,1.4-0.1v3.6c-0.9,0.3-1.9,0.4-2.9,0.4 c-3.4,0-5.1-1.7-5.1-5.1v-9.7h-2.6v-3.5h2.6v-4.4H496.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.1,333.9c-2.6,0-4.8-0.8-6.4-2.4c-1.7-1.6-2.5-3.8-2.5-6.5v-0.5c0-1.8,0.3-3.4,1-4.8c0.7-1.4,1.7-2.5,3-3.3 c1.3-0.8,2.7-1.2,4.4-1.2c2.5,0,4.4,0.8,5.8,2.3c1.4,1.5,2.1,3.7,2.1,6.6v2H508c0.2,1.2,0.6,2.1,1.4,2.8c0.8,0.7,1.8,1.1,3,1.1 c1.8,0,3.3-0.7,4.3-2l2.4,2.6c-0.7,1-1.7,1.8-2.9,2.4C514.9,333.6,513.5,333.9,512.1,333.9z M511.5,319.1c-1,0-1.7,0.3-2.3,1 c-0.6,0.6-1,1.6-1.1,2.8h6.7v-0.4c0-1.1-0.3-1.9-0.9-2.5C513.3,319.4,512.5,319.1,511.5,319.1z"
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    className: "st98"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st99",
    d: "M40.2,359.7c-1.1-3.2-2.2-6.4-2.8-7.7c-1.4-3.4-4.3-2.3-5.2-4.6c-1-2.5,1.6-4.2,3.1-4.8 c1.4-0.6,4.5-1.2,5.5,1.1s-1.8,3.6-0.4,7.1c0.3,0.8,1.9,4.1,3.5,7.4c2.5-0.8,5.2-1.3,8-1.4c-0.5-1.8-2.2-2.1-2.2-3.7 c0-2,2.3-2.5,3.5-2.5c1.2,0,3.5,0.5,3.5,2.4c0,1.7-1.7,1.9-2.2,3.7c2.6,0.1,5.2,0.7,7.6,1.5c1.5-3.1,3-6.2,3.5-7.5 c1.4-3.4-1.4-4.7-0.5-6.9c1-2.5,4.1-1.8,5.6-1.2c1.4,0.6,4.1,2.3,3.1,4.7c-1,2.4-3.8,1.2-5.3,4.7c-0.4,0.8-1.6,4.3-2.8,7.8 c2.3,1.2,4.5,2.6,6.4,4.4c1-1.7-0.1-3.1,1-4.2c1.4-1.4,3.4-0.1,4.2,0.7c0.8,0.8,2.2,2.8,0.8,4.2c-1.2,1.2-2.6,0.2-4.2,1.1 c1.8,2,3.4,4.2,4.6,6.7c3.3-1.1,6.5-2.3,7.8-2.8c3.4-1.4,2.3-4.3,4.6-5.2c2.5-1,4.2,1.6,4.8,3.1c0.6,1.4,1.2,4.5-1.1,5.5 c-2.4,1-3.6-1.8-7.1-0.4c-0.8,0.3-4.1,1.9-7.5,3.5c0.9,2.6,1.4,5.4,1.5,8.3c1.8-0.5,2.1-2.2,3.6-2.2c2,0,2.4,2.3,2.4,3.6 c0,1.2-0.5,3.5-2.4,3.5c-1.6,0-1.9-1.7-3.7-2.2c-0.1,2.6-0.6,5-1.4,7.4c3.1,1.5,6.1,2.9,7.3,3.5c3.4,1.4,4.7-1.4,6.9-0.5 c2.5,1,1.8,4.1,1.2,5.6c-0.6,1.4-2.3,4.1-4.7,3.1c-2.4-1-1.2-3.8-4.7-5.3c-0.8-0.4-4.1-1.5-7.6-2.7c-1.2,2.5-2.7,4.7-4.5,6.7 c1.6,0.8,2.9-0.1,4,0.9c1.4,1.4,0.1,3.4-0.7,4.3c-0.8,0.8-2.8,2.2-4.1,0.8c-1.2-1.1-0.2-2.5-1-4.1c-1.9,1.8-4.1,3.3-6.5,4.5 c1.1,3.2,2.2,6.2,2.7,7.5c1.4,3.4,4.3,2.3,5.2,4.6c1,2.5-1.6,4.2-3.1,4.8c-1.4,0.6-4.5,1.2-5.5-1.1c-1-2.4,1.8-3.6,0.4-7.1 c-0.3-0.8-1.8-3.9-3.4-7.1c-2.6,0.9-5.3,1.4-8.1,1.5c0.5,1.7,2.1,2,2.1,3.5c0,2-2.3,2.5-3.5,2.5c-1.2,0-3.5-0.5-3.5-2.4 c0-1.6,1.6-1.9,2.2-3.6c-2.7-0.1-5.3-0.6-7.8-1.5c-1.4,3-2.8,5.8-3.3,7c-1.4,3.4,1.4,4.7,0.5,6.9c-1,2.5-4.1,1.8-5.6,1.2 c-1.4-0.6-4.1-2.3-3.1-4.7c1-2.4,3.8-1.2,5.3-4.7c0.3-0.8,1.4-4,2.6-7.3c-2.4-1.2-4.5-2.6-6.5-4.4c-0.7,1.5,0.2,2.8-0.9,3.9 c-1.4,1.4-3.4,0.1-4.2-0.7c-0.8-0.8-2.2-2.8-0.8-4.2c1.1-1.1,2.4-0.3,3.9-1c-1.9-2-3.4-4.3-4.7-6.8c-3.1,1.1-6.1,2.1-7.4,2.7 c-3.4,1.4-2.3,4.3-4.6,5.2c-2.5,1-4.2-1.6-4.8-3.1c-0.6-1.4-1.2-4.5,1.1-5.5c2.4-1,3.6,1.8,7.1,0.4c0.8-0.3,3.9-1.8,7.1-3.4 c-0.8-2.5-1.3-5.1-1.4-7.8c-1.6,0.6-1.9,2.1-3.3,2.1c-2,0-2.4-2.3-2.4-3.6c0-1.2,0.5-3.5,2.4-3.5c1.6,0,1.9,1.5,3.4,2.1 c0.1-2.8,0.7-5.4,1.6-7.9c-2.9-1.4-5.7-2.7-6.9-3.2c-3.4-1.4-4.7,1.4-6.9,0.5c-2.5-1-1.8-4.1-1.2-5.6c0.6-1.4,2.3-4.1,4.7-3.1 c2.4,1,1.2,3.8,4.7,5.3c0.8,0.3,3.9,1.4,7.2,2.6c1.2-2.3,2.6-4.4,4.4-6.3c-1.6-0.8-3,0.1-4-0.9c-1.4-1.4-0.1-3.4,0.7-4.3 c0.8-0.8,2.8-2.2,4.1-0.8c1.2,1.2,0.2,2.5,1.1,4.1C35.4,362.5,37.7,360.9,40.2,359.7z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.52522,0,0,3.52522,-3269.79,-3330.1)",
    className: "st100"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st83"
  }, /*#__PURE__*/React.createElement("g", {
    id: "circle833",
    transform: "matrix(0.431746,0,0,0.431746,636.17,595.185)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st101",
    cx: 703.2,
    cy: 1053.4,
    r: 2.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "circle835",
    transform: "matrix(0.431746,0,0,0.431746,817.472,581.312)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st101",
    cx: 289.8,
    cy: 1094.8,
    r: 3.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "circle837",
    transform: "matrix(0.370944,0,0,0.370944,701.54,791.604)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st101",
    cx: 645,
    cy: 720.3,
    r: 2.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "circle839",
    transform: "matrix(0.187408,0,0,0.187408,1235.46,1065.38)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st101",
    cx: -1538.2,
    cy: -70.4,
    r: 3.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "circle8391",
    transform: "matrix(0.183259,0,0,0.183259,830.801,1185.47)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st101",
    cx: 584.5,
    cy: -713.7,
    r: 3.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "circle841",
    transform: "matrix(0.431746,0,0,0.431746,618.83,618.83)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st101",
    cx: 752.4,
    cy: 995.5,
    r: 0.9
  })), /*#__PURE__*/React.createElement("g", {
    id: "circle8411",
    transform: "matrix(0.320652,0,0,0.320652,1000,822.788)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st101",
    cx: -165.7,
    cy: 706.8,
    r: 0.9
  })), /*#__PURE__*/React.createElement("g", {
    id: "circle8412",
    transform: "matrix(0.431746,0,0,0.431746,353.652,1040.56)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st101",
    cx: 1352.9,
    cy: 40.5,
    r: 0.9
  })), /*#__PURE__*/React.createElement("g", {
    id: "circle8413",
    transform: "matrix(0.431746,0,0,0.431746,300.196,771.909)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st101",
    cx: 1474,
    cy: 648.8,
    r: 0.9
  })), /*#__PURE__*/React.createElement("g", {
    id: "circle843",
    transform: "matrix(0.226964,0,0,0.226964,1222.74,1217.1)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st101",
    cx: -1215.5,
    cy: -705.6,
    r: 2.9
  })), /*#__PURE__*/React.createElement("g", {
    id: "circle845",
    transform: "matrix(0.33076,0,0,0.33076,834.516,979.057)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st101",
    cx: 332.3,
    cy: 244.4,
    r: 1.6
  })))))), /*#__PURE__*/React.createElement("g", null, _g43 || (_g43 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M47,513.1h-2.8v-15.9H47V513.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.6,501.2l0.1,1.4c0.9-1.1,2-1.6,3.4-1.6c2.5,0,3.7,1.4,3.8,4.2v7.8h-2.7v-7.7c0-0.8-0.2-1.3-0.5-1.7 c-0.3-0.4-0.9-0.5-1.6-0.5c-1.1,0-1.9,0.5-2.4,1.5v8.4h-2.7v-11.8H52.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5,513.1v-9.9h-1.8v-2h1.8v-1.1c0-1.3,0.4-2.3,1.1-3c0.7-0.7,1.8-1.1,3.1-1.1c0.5,0,1,0.1,1.5,0.2l-0.1,2.1 c-0.3-0.1-0.6-0.1-1-0.1c-1.3,0-1.9,0.7-1.9,2v1.1h2.4v2h-2.4v9.9H63.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5,513.3c-1.7,0-3.1-0.5-4.1-1.6c-1-1.1-1.6-2.5-1.6-4.2v-0.3c0-1.2,0.2-2.2,0.7-3.2c0.5-0.9,1.1-1.7,1.9-2.2 c0.8-0.5,1.7-0.8,2.8-0.8c1.6,0,2.9,0.5,3.7,1.5s1.3,2.5,1.3,4.4v1.1h-7.7c0.1,1,0.4,1.8,1,2.3c0.6,0.6,1.3,0.9,2.2,0.9 c1.2,0,2.2-0.5,3-1.5l1.4,1.4c-0.5,0.7-1.1,1.3-1.9,1.6S76.5,513.3,75.5,513.3z M75.2,503.1c-0.7,0-1.3,0.3-1.8,0.8 s-0.7,1.2-0.9,2.1h5.1v-0.2c-0.1-0.9-0.3-1.6-0.7-2S75.9,503.1,75.2,503.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.2,511.2c0.7,0,1.2-0.2,1.7-0.6c0.4-0.4,0.7-0.9,0.7-1.4h2.5c0,0.7-0.3,1.4-0.7,2.1s-1,1.1-1.8,1.5 c-0.7,0.4-1.5,0.6-2.4,0.6c-1.7,0-3-0.5-3.9-1.6c-1-1.1-1.5-2.6-1.5-4.4V507c0-1.8,0.5-3.2,1.4-4.3c1-1.1,2.3-1.6,3.9-1.6 c1.4,0,2.6,0.4,3.4,1.2c0.9,0.8,1.4,1.9,1.4,3.2h-2.5c0-0.7-0.3-1.2-0.7-1.7c-0.4-0.4-1-0.7-1.7-0.7c-0.9,0-1.5,0.3-2,0.9 c-0.5,0.6-0.7,1.6-0.7,2.8v0.4c0,1.3,0.2,2.2,0.7,2.9C85.6,510.9,86.3,511.2,87.2,511.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.4,498.3v2.9h2.1v2h-2.1v6.6c0,0.5,0.1,0.8,0.3,1s0.5,0.3,1,0.3c0.3,0,0.6,0,0.9-0.1v2.1c-0.6,0.2-1.2,0.3-1.8,0.3 c-2,0-3.1-1.1-3.1-3.4v-6.7h-1.9v-2h1.9v-2.9H97.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.5,498.2c0-0.4,0.1-0.7,0.4-1c0.3-0.3,0.6-0.4,1.1-0.4c0.5,0,0.9,0.1,1.1,0.4c0.3,0.3,0.4,0.6,0.4,1 c0,0.4-0.1,0.7-0.4,1c-0.3,0.3-0.6,0.4-1.1,0.4c-0.5,0-0.9-0.1-1.1-0.4C101.7,498.9,101.5,498.6,101.5,498.2z M104.3,513.1h-2.7 v-11.8h2.7V513.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.7,507c0-1.2,0.2-2.2,0.7-3.1s1.1-1.6,1.9-2.1c0.8-0.5,1.8-0.8,2.9-0.8c1.6,0,2.9,0.5,3.9,1.5c1,1,1.5,2.4,1.6,4.1 l0,0.6c0,1.2-0.2,2.2-0.7,3.1c-0.4,0.9-1.1,1.6-1.9,2.1c-0.8,0.5-1.8,0.8-2.9,0.8c-1.7,0-3-0.6-4-1.7c-1-1.1-1.5-2.6-1.5-4.5V507 z M109.4,507.3c0,1.2,0.3,2.2,0.8,2.9c0.5,0.7,1.2,1,2.1,1c0.9,0,1.6-0.4,2.1-1.1c0.5-0.7,0.8-1.7,0.8-3.1c0-1.2-0.3-2.1-0.8-2.8 c-0.5-0.7-1.2-1.1-2.1-1.1c-0.9,0-1.6,0.3-2.1,1C109.7,504.9,109.4,505.9,109.4,507.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.5,501.2l0.1,1.4c0.9-1.1,2-1.6,3.5-1.6c2.5,0,3.7,1.4,3.8,4.2v7.8h-2.7v-7.7c0-0.8-0.2-1.3-0.5-1.7 c-0.3-0.4-0.9-0.5-1.6-0.5c-1.1,0-1.9,0.5-2.4,1.5v8.4H120v-11.8H122.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.1,509.9c0-0.5-0.2-0.8-0.6-1.1c-0.4-0.2-1-0.5-1.9-0.7c-0.9-0.2-1.7-0.4-2.3-0.7c-1.3-0.6-2-1.6-2-2.8 c0-1,0.4-1.9,1.3-2.6c0.9-0.7,2-1,3.3-1c1.4,0,2.6,0.4,3.4,1.1c0.9,0.7,1.3,1.6,1.3,2.7H139c0-0.5-0.2-0.9-0.6-1.3 c-0.4-0.3-0.9-0.5-1.5-0.5c-0.6,0-1.1,0.1-1.4,0.4c-0.4,0.3-0.6,0.6-0.6,1.1c0,0.4,0.2,0.7,0.5,1c0.3,0.2,1,0.5,2.1,0.7 c1,0.2,1.9,0.5,2.5,0.8c0.6,0.3,1,0.7,1.3,1.1c0.3,0.4,0.4,1,0.4,1.6c0,1.1-0.4,1.9-1.3,2.6c-0.9,0.7-2,1-3.5,1 c-1,0-1.8-0.2-2.6-0.5c-0.8-0.4-1.4-0.8-1.8-1.4c-0.4-0.6-0.6-1.3-0.6-2h2.6c0,0.6,0.3,1.1,0.7,1.5c0.4,0.3,1,0.5,1.7,0.5 c0.7,0,1.2-0.1,1.6-0.4S139.1,510.3,139.1,509.9z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_13_",
    cx: 69.0144,
    cy: 442.4083,
    r: 36.4139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5DB06E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1273,
    style: {
      stopColor: "#75BC83"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.548,
    style: {
      stopColor: "#BFE0C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8495,
    style: {
      stopColor: "#EDF6EF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st102",
    cx: 69,
    cy: 442.4,
    r: 36.4
  })), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st103",
    points: "70.5,412.4 84.6,396.6 80.5,409.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st103",
    points: "81.5,415.4 103.6,406.6 81.5,421.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st103",
    points: "86.6,423.4 105.3,424.4 87,430.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st103",
    points: "81.7,441.1 96.5,448.2 85.8,435.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st103",
    points: "78.8,445 83.9,464.7 71.7,447  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st103",
    points: "65.9,449.4 58.1,461.6 60.3,447.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M55.7,443.8l-17.3,8.5L51.3,439C51.3,439,53.7,441.1,55.7,443.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st103",
    points: "46.7,435.3 31.6,429 46.7,430.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st103",
    points: "47.6,420.9 33.9,412.9 49.8,415.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st103",
    points: "54.2,413.7 43.7,399.5 57.1,409.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st103",
    points: "61.5,406.1 61,389.6 66.8,404.6  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M92.8,427.9c0,2.8-0.5,5.5-1.4,8c-3.3,9.4-12.2,16.1-22.7,16.1c-13.3,0-24.1-10.8-24.1-24.1 c0-9.9,5.9-18.3,14.4-22.1c3-1.3,6.2-2,9.7-2C82,403.8,92.8,414.6,92.8,427.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M92.8,427.9c0,2.8-0.5,5.5-1.4,8c-3,1.3-6.2,2-9.7,2c-13.3,0-24.1-10.8-24.1-24.1c0-2.8,0.5-5.5,1.4-8 c3-1.3,6.2-2,9.7-2C82,403.8,92.8,414.6,92.8,427.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "M55.4,424.2c0,1.4-1.1,2.6-2.6,2.6s-2.6-1.1-2.6-2.6c0-1.4,1.1-2.6,2.6-2.6S55.4,422.8,55.4,424.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st105",
    cx: 81.9,
    cy: 429,
    r: 2.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1593 -0.9872 0.9872 0.1593 -343.0605 431.169)",
    className: "st105",
    cx: 81.6,
    cy: 417,
    rx: 1.9,
    ry: 1.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "M66.3,411.1c0,1.1-0.9,2-2,2c-1.1,0-2-0.9-2-2c0-1.1,0.9-2,2-2C65.4,409.1,66.3,410,66.3,411.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "M62.6,444.1c0,1.1-0.9,2-2,2s-2-0.9-2-2c0-1.1,0.9-2,2-2S62.6,443,62.6,444.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "M82.3,444.5c0,1.6-1.3,2.9-2.9,2.9c-1.6,0-2.9-1.3-2.9-2.9c0-1.6,1.3-2.9,2.9-2.9 C80.9,441.5,82.3,442.8,82.3,444.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st105",
    cx: 69.7,
    cy: 421.6,
    r: 1.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "M65.4,432.6c0,0.8-0.6,1.4-1.4,1.4c-0.8,0-1.4-0.6-1.4-1.4c0-0.8,0.6-1.4,1.4-1.4 C64.8,431.2,65.4,431.8,65.4,432.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st105",
    cx: 52,
    cy: 435.9,
    r: 1.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st106",
    d: "M77.7,409.9c-0.3,0.4-0.9,0.5-1.4,0.2c-2-1.3-4.4-1.9-6.8-1.7c-0.5,0-1.1-0.3-1.2-0.8l0,0 c-0.1-0.5,0.3-1,1-1.1c2.8-0.3,5.6,0.4,8,2C77.9,408.8,78,409.5,77.7,409.9L77.7,409.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st106",
    d: "M64.7,448.2c0.2-0.5,0.8-0.7,1.3-0.5c2.2,0.8,4.7,0.8,7,0.1c0.5-0.2,1.1,0,1.3,0.5l0,0 c0.2,0.5-0.1,1.1-0.7,1.3c-2.7,0.9-5.6,0.9-8.2-0.1C64.8,449.3,64.5,448.7,64.7,448.2L64.7,448.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st106",
    d: "M86.7,439c-0.4-0.4-0.4-1,0-1.4c1.5-1.9,2.3-4.2,2.4-6.6c0-0.5,0.4-1,0.9-1.1l0,0c0.5-0.1,1,0.4,1,1.1 c0,2.8-1,5.5-2.8,7.7C87.7,439.3,87,439.4,86.7,439L86.7,439z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_14_",
    cx: 117.2977,
    cy: 447.108,
    r: 28.3811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DB4672"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.221,
    style: {
      stopColor: "#E47596"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5964,
    style: {
      stopColor: "#F2BFCE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8656,
    style: {
      stopColor: "#FCEDF1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st107",
    cx: 117.3,
    cy: 447.1,
    r: 28.4
  })), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st108",
    d: "M115.9,454.3c-13.7-7.5-20.4-18-16.4-25.4c4.1-7.4,17.4-9,31.1-1.5C149,437.6,134.3,464.4,115.9,454.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st109",
    d: "M116.6,453.2c-9.2-5-15.2-11.6-16.6-17.3c-0.5-2.3-0.3-4.4,0.7-6.3c3.4-6.3,15.6-8.4,29.3-1 c8.7,4.8,9.2,13.3,5.9,19.2c-1,1.8-2.3,3.4-4,4.7C128.1,455.4,122.6,456.5,116.6,453.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st110",
    d: "M116.6,453.2c-9.2-5-15.2-11.6-16.6-17.3c5.6-2.4,14.5-1.9,24.2,3.4c6.1,3.3,8.1,8.5,7.7,13.3 C128.1,455.4,122.6,456.5,116.6,453.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st111",
    d: "M126.4,439.2c-2.2-1.2-3.1-4-1.8-6.3s4-3.1,6.3-1.8c2.2,1.2,3.1,4,1.8,6.3 C131.4,439.6,128.6,440.4,126.4,439.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st111",
    d: "M104.2,429.3c-0.4-0.2-0.5-0.6-0.3-1c0.2-0.4,0.6-0.5,1-0.3c0.4,0.2,0.5,0.6,0.3,1 C105,429.3,104.5,429.5,104.2,429.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st111",
    d: "M121.5,440c-0.4-0.2-0.5-0.6-0.3-1c0.2-0.4,0.6-0.5,1-0.3c0.4,0.2,0.5,0.6,0.3,1 C122.3,440.1,121.8,440.2,121.5,440z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st111",
    d: "M134,436.3c-0.5-0.3-0.7-0.9-0.4-1.4c0.3-0.5,0.9-0.7,1.4-0.4c0.5,0.3,0.7,0.9,0.4,1.4 C135.1,436.4,134.5,436.6,134,436.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st111",
    d: "M122.2,428c-0.4-0.2-0.5-0.6-0.3-1c0.2-0.4,0.6-0.5,1-0.3c0.4,0.2,0.5,0.6,0.3,1 C123,428.1,122.6,428.2,122.2,428z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st111",
    d: "M135.5,440.4c-0.2-0.1-0.3-0.4-0.2-0.6c0.1-0.2,0.4-0.3,0.6-0.2c0.2,0.1,0.3,0.4,0.2,0.6 C136,440.4,135.7,440.5,135.5,440.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st111",
    d: "M135.6,445.5c-0.2-0.1-0.3-0.4-0.2-0.6c0.1-0.2,0.4-0.3,0.6-0.2c0.2,0.1,0.3,0.4,0.2,0.6 C136.1,445.6,135.8,445.6,135.6,445.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st111",
    d: "M101.1,433.5c-0.2-0.1-0.3-0.4-0.2-0.6c0.1-0.2,0.4-0.3,0.6-0.2c0.2,0.1,0.3,0.4,0.2,0.6 C101.5,433.5,101.3,433.6,101.1,433.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st111",
    d: "M124,453.4c-0.5-0.3-0.7-0.9-0.4-1.4c0.3-0.5,0.9-0.7,1.4-0.4c0.5,0.3,0.7,0.9,0.4,1.4 C125.1,453.5,124.5,453.7,124,453.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st111",
    d: "M124.7,447.1c-0.8-0.4-1-1.4-0.6-2.1c0.4-0.8,1.4-1,2.1-0.6c0.8,0.4,1,1.4,0.6,2.1 C126.4,447.3,125.5,447.5,124.7,447.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st111",
    d: "M119.3,433.9c-0.8-0.4-1-1.4-0.6-2.1c0.4-0.8,1.4-1,2.1-0.6c0.8,0.4,1,1.4,0.6,2.1 C121,434,120.1,434.3,119.3,433.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st111",
    d: "M131.6,444.1c-0.8-0.4-1-1.4-0.6-2.1c0.4-0.8,1.4-1,2.1-0.6c0.8,0.4,1,1.4,0.6,2.1 C133.3,444.2,132.4,444.5,131.6,444.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st111",
    d: "M107.6,442.9c-0.8-0.4-1-1.4-0.6-2.1c0.4-0.8,1.4-1,2.1-0.6c0.8,0.4,1,1.4,0.6,2.1 C109.3,443,108.3,443.3,107.6,442.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st111",
    d: "M102.5,435.8c-1.1-1.9,1.6-5.4,5.9-7.9c4.3-2.5,8.7-3,9.7-1.1c1.1,1.9-1.6,5.4-5.9,7.9 C108,437.1,103.6,437.6,102.5,435.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st111",
    d: "M114.3,447.7c-1.7-0.9-2.3-3.1-1.4-4.8c0.9-1.7,3.1-2.3,4.8-1.4c1.7,0.9,2.3,3.1,1.4,4.8 C118.1,448,116,448.7,114.3,447.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st108",
    d: "M136.1,448.3c0,0,0.1,0,0.4,0.1c0.1,0,0.3,0.1,0.5,0.1c0.2,0.1,0.4,0.1,0.6,0.2c0.2,0.1,0.4,0.2,0.6,0.3 c0.2,0.1,0.4,0.3,0.7,0.5c0.2,0.2,0.4,0.4,0.6,0.6c0.2,0.2,0.4,0.4,0.6,0.6c0.4,0.4,0.7,0.9,1.1,1.3c0.2,0.2,0.3,0.4,0.5,0.6 c0.1,0.1,0.2,0.2,0.2,0.2c0.1,0.1,0.2,0.1,0.3,0.2c0.2,0.1,0.3,0.2,0.5,0.3c0.1,0.1,0.3,0.2,0.4,0.2c0.2,0.1,0.3,0.2,0.3,0.2 c0,0,0,0,0,0.1c0,0,0,0-0.1,0c0,0-0.1-0.1-0.3-0.2c-0.1-0.1-0.2-0.1-0.4-0.2c-0.2-0.1-0.3-0.2-0.5-0.3 c-0.1-0.1-0.2-0.1-0.3-0.2c-0.1-0.1-0.2-0.2-0.3-0.2c-0.2-0.2-0.4-0.3-0.6-0.5c-0.4-0.4-0.8-0.8-1.2-1.2l-0.3-0.3 c-0.1-0.1-0.2-0.2-0.3-0.3c-0.2-0.2-0.4-0.3-0.6-0.5c-0.2-0.1-0.4-0.3-0.6-0.4c-0.2-0.1-0.4-0.2-0.6-0.3 c-0.2-0.1-0.4-0.1-0.5-0.2c-0.2,0-0.3-0.1-0.4-0.1c-0.2,0-0.4-0.1-0.4-0.1c-0.2,0-0.3-0.2-0.3-0.4 C135.7,448.4,135.9,448.3,136.1,448.3C136.1,448.3,136.1,448.3,136.1,448.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st108",
    d: "M131.6,453.3c0,0,0.1,0.2,0.3,0.4c0.2,0.3,0.4,0.7,0.7,1.2c0.1,0.2,0.3,0.5,0.4,0.8 c0.1,0.3,0.3,0.6,0.4,0.9c0.1,0.3,0.3,0.7,0.4,1c0.1,0.4,0.2,0.7,0.3,1.1c0.1,0.4,0.2,0.7,0.3,1.1c0.1,0.2,0.1,0.3,0.2,0.5 l0.1,0.2l0,0.1c0,0,0,0,0,0l0.1,0.1c0.1,0.1,0.2,0.3,0.3,0.4c0.1,0.1,0.2,0.2,0.3,0.3c0.2,0.2,0.5,0.4,0.7,0.5 c0.5,0.3,0.9,0.5,1.2,0.7c0.3,0.2,0.4,0.3,0.4,0.3c0,0,0,0,0,0.1c0,0,0,0-0.1,0l0,0c0,0-0.2-0.1-0.4-0.3 c-0.3-0.2-0.7-0.4-1.2-0.6c-0.2-0.1-0.5-0.3-0.8-0.5c-0.1-0.1-0.3-0.2-0.4-0.3c-0.1-0.1-0.2-0.3-0.3-0.4l-0.1-0.1 c0,0,0,0,0-0.1l0-0.1l-0.1-0.2c-0.1-0.2-0.2-0.3-0.2-0.5c-0.1-0.3-0.3-0.7-0.4-1.1c-0.1-0.4-0.2-0.7-0.4-1 c-0.1-0.3-0.3-0.7-0.4-1c-0.1-0.3-0.3-0.6-0.5-0.9c-0.1-0.3-0.3-0.5-0.4-0.8c-0.3-0.5-0.5-0.9-0.7-1.1 c-0.2-0.3-0.3-0.4-0.3-0.4c-0.1-0.2-0.1-0.4,0.1-0.5C131.2,453.1,131.5,453.2,131.6,453.3C131.6,453.3,131.6,453.3,131.6,453.3 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st108",
    d: "M125.9,455.9c0,0-0.1,0.1-0.4,0.3c-0.1,0.1-0.2,0.2-0.4,0.4c-0.1,0.1-0.2,0.3-0.3,0.5c0,0.1,0,0.1,0,0.2 c0,0,0,0.1,0,0.1l0,0.1c0,0.1,0,0.3,0,0.5c0,0.3,0,0.6,0.1,0.9c0.1,0.7,0.2,1.4,0.3,2.1c0.1,0.7,0.2,1.4,0.2,2.1 c0,0.7,0,1.3-0.1,1.9c-0.1,0.3-0.1,0.5-0.2,0.7c-0.1,0.2-0.2,0.4-0.2,0.5c-0.1,0.1-0.1,0.2-0.2,0.3c0,0.1-0.1,0.1-0.1,0.1 c0,0,0,0-0.1,0c0,0,0,0,0-0.1l0,0c0,0,0,0,0.1-0.1c0-0.1,0.1-0.2,0.2-0.3c0.1-0.1,0.1-0.3,0.2-0.5c0.1-0.2,0.1-0.4,0.2-0.7 c0.1-0.5,0.1-1.2,0-1.8c-0.1-0.7-0.2-1.4-0.3-2.1c-0.1-0.7-0.3-1.4-0.4-2.1c-0.1-0.3-0.1-0.7-0.1-1c0-0.2,0-0.3,0-0.5l0-0.1 c0-0.1,0-0.1,0-0.1c0-0.1,0-0.2,0-0.2c0.1-0.3,0.2-0.6,0.4-0.8c0.2-0.2,0.3-0.3,0.4-0.5c0.2-0.2,0.4-0.3,0.4-0.3 c0.1-0.1,0.4-0.1,0.5,0C126.1,455.6,126.1,455.8,125.9,455.9C126,455.9,125.9,455.9,125.9,455.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st108",
    d: "M119.7,455.7C119.7,455.7,119.7,455.7,119.7,455.7c-0.2,0.1-0.3,0.1-0.4,0.2c-0.1,0.1-0.2,0.1-0.3,0.2 c-0.1,0.1-0.3,0.2-0.4,0.4c-0.3,0.3-0.6,0.7-0.8,1.2c-0.3,0.5-0.5,1-0.7,1.6c-0.1,0.3-0.2,0.6-0.3,0.8 c-0.1,0.3-0.2,0.5-0.3,0.8c-0.1,0.3-0.2,0.5-0.3,0.8c-0.1,0.2-0.2,0.5-0.3,0.7c-0.4,0.8-0.7,1.3-0.7,1.3c0,0,0,0-0.1,0 c0,0,0,0,0-0.1l0,0c0,0,0.2-0.5,0.6-1.4c0.1-0.2,0.2-0.4,0.3-0.7c0.1-0.2,0.2-0.5,0.3-0.8c0.1-0.3,0.2-0.5,0.3-0.8 c0.1-0.3,0.2-0.6,0.3-0.9c0.3-1.2,0.8-2.3,1.4-3.1c0.2-0.2,0.3-0.4,0.5-0.5c0.1-0.1,0.3-0.2,0.4-0.3c0.1-0.1,0.2-0.1,0.3-0.2 c0.1,0,0.1-0.1,0.1-0.1c0.2-0.1,0.4,0,0.5,0.1C120,455.3,119.9,455.6,119.7,455.7C119.8,455.7,119.7,455.7,119.7,455.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st108",
    d: "M128.2,455.2c0,0,0,0,0,0.1c0,0.1,0,0.2,0,0.3c0,0.2,0,0.6,0.1,1.1c0.1,0.4,0.3,1,0.6,1.5 c0.1,0.3,0.3,0.6,0.4,0.8c0.1,0.3,0.3,0.6,0.4,0.9c0.1,0.3,0.2,0.6,0.3,0.9c0.1,0.3,0.2,0.6,0.2,0.9c0.1,0.3,0.1,0.6,0.2,0.9 c0,0.3,0.1,0.5,0.1,0.8c0.1,0.5,0.1,0.9,0.1,1.2c0,0.3,0,0.4,0,0.4c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0-0.2-0.1-0.4 c-0.1-0.3-0.1-0.7-0.2-1.2c0-0.2-0.1-0.5-0.2-0.8c0-0.3-0.1-0.5-0.2-0.8c-0.1-0.3-0.1-0.6-0.3-0.9c-0.1-0.3-0.2-0.6-0.4-0.9 c-0.1-0.3-0.3-0.6-0.4-0.8c-0.2-0.3-0.3-0.6-0.5-0.8c-0.3-0.5-0.6-1.1-0.7-1.6c-0.2-0.5-0.2-0.9-0.2-1.3c0-0.2,0-0.3,0-0.4 c0-0.1,0-0.1,0-0.1c0-0.2,0.2-0.3,0.4-0.3C128.1,454.8,128.3,455,128.2,455.2C128.2,455.2,128.2,455.2,128.2,455.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st108",
    d: "M134.3,451.3C134.3,451.3,134.4,451.3,134.3,451.3c0.1,0.1,0.2,0.1,0.3,0.2c0.1,0.1,0.3,0.2,0.4,0.3 c0.1,0.1,0.2,0.3,0.3,0.5c0,0.1,0.1,0.2,0.1,0.2c0,0.1,0.1,0.2,0.1,0.2c0.1,0.2,0.2,0.4,0.3,0.5c0.1,0.2,0.3,0.4,0.4,0.5 c0.1,0.2,0.3,0.4,0.4,0.5c0.2,0.2,0.3,0.3,0.5,0.5c0.2,0.2,0.4,0.3,0.5,0.4c0.2,0.1,0.4,0.2,0.5,0.3c0.2,0.1,0.3,0.2,0.5,0.2 c0.2,0.1,0.3,0.1,0.4,0.2c0.1,0,0.3,0.1,0.4,0.1c0.2,0,0.3,0.1,0.3,0.1l0,0c0,0,0,0,0,0.1c0,0,0,0,0,0c0,0-0.1,0-0.3,0 c-0.1,0-0.2,0-0.4-0.1c-0.1,0-0.3-0.1-0.5-0.1c-0.2-0.1-0.4-0.1-0.5-0.2c-0.2-0.1-0.4-0.2-0.6-0.3c-0.2-0.1-0.4-0.2-0.6-0.4 c-0.2-0.1-0.4-0.3-0.6-0.5c-0.2-0.2-0.3-0.4-0.5-0.5c-0.2-0.2-0.3-0.4-0.5-0.5c-0.1-0.2-0.3-0.4-0.4-0.5 c-0.1-0.1-0.1-0.1-0.2-0.3c0-0.1-0.1-0.2-0.1-0.2c-0.1-0.2-0.2-0.3-0.2-0.3c-0.1-0.1-0.1-0.1-0.2-0.1c0,0-0.1-0.1-0.2-0.1 c-0.1,0-0.1,0-0.1,0c-0.2-0.1-0.3-0.3-0.2-0.5C133.9,451.4,134.1,451.3,134.3,451.3C134.3,451.3,134.3,451.3,134.3,451.3 L134.3,451.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st108",
    d: "M137.9,445.2c0,0,0.2,0,0.4,0.1c0.3,0,0.7,0.1,1.1,0.2c0.5,0.1,1,0.2,1.6,0.3c0.3,0,0.6,0.1,0.9,0.1 c0.3,0,0.6,0,0.9,0.1c0.3,0,0.6,0,0.9,0c0.3,0,0.6-0.1,0.9-0.1c0.6-0.1,1.1-0.2,1.6-0.3c0.9-0.2,1.5-0.3,1.5-0.3c0,0,0,0,0.1,0 c0,0,0,0,0,0.1c0,0-0.6,0.2-1.5,0.4c-0.5,0.1-1,0.3-1.6,0.4c-0.3,0.1-0.6,0.1-0.9,0.2c-0.3,0-0.6,0.1-1,0.1c-0.3,0-0.6,0-1,0 c-0.3,0-0.6,0-0.9-0.1c-0.6-0.1-1.1-0.1-1.6-0.2c-0.5,0-0.8-0.1-1.1-0.1c-0.3,0-0.4,0-0.4,0c-0.2,0-0.4-0.2-0.3-0.4 C137.5,445.3,137.6,445.2,137.9,445.2C137.8,445.2,137.8,445.2,137.9,445.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st108",
    d: "M138.3,441.3c0,0,0.1,0,0.3,0.1c0.1,0,0.2,0.1,0.4,0.1c0.1,0,0.3,0.1,0.5,0.1c0.4,0.1,0.8,0.1,1.3,0.2 c0.2,0,0.5,0,0.7,0c0.3,0,0.5,0,0.8,0c0.5,0,1-0.1,1.5-0.2c0.5-0.1,0.9-0.2,1.3-0.4c0.2-0.1,0.3-0.1,0.5-0.2 c0.1-0.1,0.3-0.1,0.4-0.2c0.2-0.1,0.3-0.2,0.3-0.2l0,0c0,0,0,0,0.1,0c0,0,0,0,0,0.1c0,0-0.1,0.1-0.3,0.2 c-0.1,0.1-0.2,0.1-0.3,0.2c-0.1,0.1-0.3,0.2-0.5,0.3c-0.4,0.2-0.8,0.3-1.3,0.5c-0.5,0.1-1,0.2-1.5,0.3c-0.3,0-0.5,0.1-0.8,0.1 c-0.3,0-0.5,0-0.8,0c-0.5,0-1,0-1.4-0.1c-0.2,0-0.4,0-0.6-0.1c-0.2,0-0.3-0.1-0.4-0.1c-0.2-0.1-0.4-0.1-0.4-0.1 c-0.2,0-0.3-0.2-0.3-0.4C137.9,441.4,138.1,441.3,138.3,441.3C138.3,441.3,138.3,441.3,138.3,441.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st108",
    d: "M138.5,438c0,0,0.6-0.1,1.5-0.2c0.2,0,0.5-0.1,0.7-0.1c0.3-0.1,0.5-0.1,0.8-0.2c0.3-0.1,0.6-0.1,0.9-0.2 c0.3-0.1,0.6-0.2,0.9-0.2c0.3-0.1,0.6-0.2,0.9-0.3c0.1-0.1,0.3-0.1,0.4-0.2c0.1-0.1,0.3-0.1,0.4-0.2c0.1-0.1,0.2-0.1,0.4-0.2 c0.1-0.1,0.2-0.2,0.3-0.3c0.2-0.2,0.4-0.3,0.5-0.5c0.2-0.2,0.3-0.3,0.4-0.5c0.1-0.2,0.2-0.3,0.3-0.4c0.2-0.2,0.3-0.3,0.3-0.3 c0,0,0,0,0.1,0c0,0,0,0,0,0.1c0,0-0.1,0.1-0.2,0.4c-0.1,0.1-0.2,0.3-0.3,0.4c-0.1,0.2-0.3,0.3-0.4,0.5 c-0.1,0.2-0.3,0.4-0.5,0.6c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0.1-0.2,0.2-0.4,0.2c-0.1,0.1-0.3,0.2-0.4,0.3 c-0.1,0.1-0.3,0.1-0.4,0.2c-0.3,0.1-0.6,0.3-0.9,0.4c-0.3,0.1-0.6,0.2-0.9,0.3c-0.3,0.1-0.6,0.2-0.9,0.3 c-0.3,0.1-0.6,0.2-0.8,0.2c-0.3,0.1-0.5,0.1-0.7,0.2c-0.9,0.2-1.5,0.3-1.5,0.3c-0.2,0-0.4-0.1-0.4-0.3 C138.2,438.3,138.3,438.1,138.5,438C138.5,438,138.5,438,138.5,438z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st108",
    d: "M115.6,453.5c0,0-0.1,0.1-0.4,0.2c-0.3,0.1-0.7,0.3-1.1,0.6c-0.2,0.1-0.4,0.3-0.7,0.4 c-0.2,0.2-0.5,0.3-0.7,0.5c-0.1,0.1-0.3,0.2-0.4,0.3c-0.1,0.1-0.2,0.2-0.4,0.3c-0.3,0.2-0.5,0.4-0.8,0.6 c-0.3,0.2-0.5,0.4-0.8,0.6c-0.1,0.1-0.3,0.2-0.4,0.3c-0.1,0.1-0.3,0.2-0.4,0.3c-0.3,0.2-0.6,0.3-0.8,0.4 c-0.3,0.1-0.5,0.2-0.8,0.2c-0.5,0.1-0.9,0-1.2,0c-0.3,0-0.5,0-0.5,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0.2,0,0.5,0 c0.3,0,0.7,0.1,1.2,0c0.2,0,0.5-0.1,0.7-0.3c0.2-0.1,0.5-0.3,0.8-0.5c0.1-0.1,0.3-0.2,0.4-0.3c0.1-0.1,0.2-0.2,0.4-0.3 c0.2-0.2,0.5-0.5,0.7-0.7c0.2-0.2,0.5-0.5,0.7-0.7c0.1-0.1,0.2-0.2,0.4-0.3c0.1-0.1,0.3-0.2,0.4-0.3c0.3-0.2,0.5-0.4,0.7-0.6 c0.2-0.2,0.5-0.3,0.7-0.5c0.4-0.3,0.8-0.5,1-0.7c0.3-0.2,0.4-0.2,0.4-0.2c0.2-0.1,0.4,0,0.5,0.1 C115.9,453.2,115.8,453.4,115.6,453.5C115.7,453.5,115.7,453.5,115.6,453.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st108",
    d: "M111.2,451.1c0,0-0.2,0-0.4,0.1c-0.3,0.1-0.7,0.2-1.1,0.3c-0.2,0.1-0.5,0.2-0.7,0.3 c-0.2,0.1-0.5,0.2-0.8,0.4c-0.2,0.2-0.5,0.3-0.8,0.5c-0.3,0.2-0.5,0.4-0.8,0.6c-0.2,0.2-0.5,0.4-0.7,0.6 c-0.3,0.2-0.5,0.4-0.8,0.6c-0.3,0.2-0.5,0.3-0.8,0.5c-0.2,0.1-0.5,0.2-0.7,0.3c-0.2,0.1-0.4,0.2-0.6,0.2 c-0.2,0.1-0.4,0.1-0.5,0.1c-0.1,0-0.3,0-0.3,0c-0.1,0-0.1,0-0.1,0c0,0,0,0,0,0c0,0,0,0,0,0l0,0c0,0,0,0,0.1,0 c0.1,0,0.2,0,0.3,0c0.1,0,0.3,0,0.5-0.1c0.2-0.1,0.4-0.1,0.6-0.2c0.2-0.1,0.4-0.2,0.7-0.4c0.2-0.1,0.5-0.3,0.7-0.5 c0.2-0.2,0.5-0.4,0.7-0.6c0.2-0.2,0.5-0.5,0.7-0.7c0.2-0.2,0.5-0.4,0.7-0.7c0.3-0.2,0.5-0.4,0.8-0.6c0.3-0.2,0.5-0.3,0.8-0.4 c0.3-0.1,0.5-0.2,0.7-0.3c0.5-0.2,0.9-0.3,1.1-0.4c0.3-0.1,0.4-0.1,0.4-0.1c0.2-0.1,0.4,0,0.5,0.2 C111.6,450.8,111.5,451.1,111.2,451.1C111.3,451.1,111.2,451.1,111.2,451.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st108",
    d: "M136.4,433.5c0,0,0.6-0.3,1.6-0.8c0.5-0.2,1-0.5,1.6-0.8c0.3-0.2,0.6-0.3,0.9-0.5c0.3-0.2,0.6-0.3,1-0.5 c0.6-0.3,1.3-0.6,1.9-0.9c0.3-0.1,0.6-0.3,0.8-0.4c0.3-0.2,0.5-0.3,0.7-0.5c0.1-0.1,0.2-0.2,0.3-0.3c0.1-0.1,0.1-0.2,0.2-0.3 c0.1-0.2,0.2-0.3,0.3-0.5c0.1-0.3,0.1-0.5,0.1-0.5l0,0c0,0,0,0,0.1,0c0,0,0,0,0,0c0,0,0,0.2-0.1,0.5c-0.1,0.1-0.1,0.3-0.2,0.5 c-0.1,0.1-0.1,0.2-0.2,0.3c-0.1,0.1-0.2,0.2-0.3,0.3c-0.2,0.2-0.4,0.4-0.7,0.5c-0.3,0.2-0.5,0.3-0.8,0.5 c-0.6,0.3-1.2,0.7-1.8,1c-0.3,0.2-0.6,0.3-0.9,0.5c-0.3,0.2-0.6,0.3-0.9,0.5c-0.6,0.3-1.1,0.7-1.6,0.9 c-0.9,0.5-1.5,0.9-1.5,0.9l0,0c-0.2,0.1-0.4,0-0.5-0.1C136.2,433.8,136.2,433.6,136.4,433.5 C136.4,433.5,136.4,433.5,136.4,433.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st108",
    d: "M130.3,427.5c0,0,0,0,0.1,0c0.1,0,0.2,0.1,0.3,0.1c0.2,0,0.5,0,0.9-0.3c0.2-0.1,0.4-0.3,0.6-0.5 c0.2-0.2,0.4-0.4,0.6-0.6c0.4-0.5,0.8-1,1.2-1.5c0.2-0.2,0.4-0.5,0.7-0.7c0.2-0.2,0.5-0.5,0.7-0.7c0.1-0.1,0.2-0.2,0.3-0.3 c0.1-0.1,0.2-0.2,0.4-0.2c0.1-0.1,0.2-0.2,0.4-0.2c0.1-0.1,0.2-0.1,0.4-0.2c0.2-0.1,0.5-0.1,0.7-0.2c0.2,0,0.4,0,0.5,0 c0.3,0,0.5,0,0.5,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0-0.2,0-0.5,0c-0.1,0-0.3,0-0.5,0.1c-0.1,0-0.2,0-0.3,0.1c-0.1,0-0.2,0-0.3,0.1 c-0.1,0.1-0.2,0.1-0.3,0.2c-0.1,0.1-0.2,0.2-0.3,0.2c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0.1-0.2,0.2-0.3,0.3 c-0.2,0.2-0.4,0.4-0.6,0.7c-0.2,0.2-0.4,0.5-0.6,0.8c-0.4,0.5-0.7,1.1-1.1,1.6c-0.2,0.3-0.4,0.5-0.6,0.7 c-0.2,0.2-0.4,0.4-0.6,0.6c-0.2,0.2-0.5,0.3-0.7,0.4c-0.2,0.1-0.4,0.1-0.7,0.1c-0.2,0-0.3-0.1-0.4-0.1c-0.1,0-0.1,0-0.1,0 c-0.2-0.1-0.3-0.3-0.3-0.5C129.8,427.5,130,427.4,130.3,427.5C130.2,427.5,130.2,427.5,130.3,427.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st108",
    d: "M127.5,427.3c0,0-0.1-0.2-0.3-0.6c-0.1-0.2-0.2-0.4-0.3-0.7c-0.1-0.3-0.2-0.7-0.2-1l0-0.2 c0-0.1,0-0.1,0-0.2c0-0.1,0-0.2,0-0.3c0-0.2,0-0.4,0.1-0.6c0.1-0.4,0.2-0.9,0.4-1.3c0.1-0.4,0.3-0.8,0.5-1.3 c0.2-0.4,0.4-0.8,0.6-1.3c0.4-0.8,0.8-1.7,1-2.5c0.1-0.4,0.2-0.8,0.3-1.2c0-0.1,0-0.2,0-0.3c0-0.1,0-0.2,0-0.3 c0-0.2,0-0.4,0-0.5c-0.1-0.3-0.1-0.7-0.2-0.9c-0.1-0.3-0.1-0.5-0.2-0.7c-0.1-0.4-0.2-0.6-0.2-0.6c0,0,0,0,0-0.1c0,0,0,0,0.1,0 c0,0,0.1,0.2,0.3,0.6c0.1,0.2,0.2,0.4,0.2,0.7c0.1,0.3,0.1,0.6,0.2,1c0,0.2,0,0.4,0,0.5c0,0.1,0,0.2,0,0.3c0,0.1,0,0.2,0,0.3 c0,0.4-0.1,0.8-0.2,1.3c-0.2,0.9-0.6,1.7-0.9,2.6c-0.2,0.4-0.4,0.9-0.5,1.3c-0.2,0.4-0.3,0.8-0.4,1.3c-0.1,0.4-0.2,0.8-0.3,1.2 c0,0.2,0,0.4-0.1,0.6c0,0.1,0,0.2,0,0.3c0,0,0,0.1,0,0.1l0,0.1c0,0.6,0.3,1.1,0.5,1.4c0.2,0.3,0.3,0.5,0.3,0.5 c0.1,0.2,0,0.4-0.1,0.5C127.9,427.6,127.7,427.5,127.5,427.3C127.5,427.3,127.5,427.3,127.5,427.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st108",
    d: "M134,429.7c0,0,0,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0.1,0,0.3,0,0.4-0.1c0.2,0,0.4-0.1,0.6-0.3 c0.4-0.3,0.8-0.7,1.3-1.1c0.3-0.2,0.5-0.4,0.8-0.6c0.3-0.2,0.6-0.4,0.9-0.6c0.3-0.2,0.6-0.4,0.9-0.5c0.3-0.2,0.6-0.3,0.9-0.4 c0.3-0.1,0.6-0.3,0.9-0.4c0.3-0.1,0.6-0.2,0.8-0.3c0.3-0.1,0.5-0.2,0.7-0.2c0.2,0,0.4-0.1,0.5-0.1c0.3-0.1,0.5-0.1,0.5-0.1 c0,0,0,0,0.1,0c0,0,0,0,0,0l0,0c0,0-0.2,0-0.5,0.1c-0.1,0-0.3,0.1-0.5,0.1c-0.2,0-0.4,0.1-0.7,0.2c-0.2,0.1-0.5,0.2-0.8,0.3 c-0.3,0.1-0.6,0.3-0.8,0.4c-0.3,0.2-0.6,0.3-0.9,0.5c-0.3,0.2-0.6,0.4-0.8,0.6c-0.3,0.2-0.6,0.4-0.8,0.6 c-0.3,0.2-0.5,0.4-0.8,0.7c-0.5,0.4-0.9,0.9-1.3,1.3c-0.2,0.2-0.5,0.3-0.7,0.4c-0.2,0.1-0.5,0.1-0.7,0.1c-0.1,0-0.2,0-0.3,0 c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.1,0c-0.2-0.1-0.3-0.3-0.2-0.5C133.6,429.8,133.8,429.7,134,429.7 C134,429.7,134,429.7,134,429.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st108",
    d: "M123.7,425.2c0,0-0.1-0.1-0.4-0.3c-0.1,0-0.1-0.1-0.2-0.2c-0.1-0.1-0.1-0.2-0.2-0.2 c-0.1-0.1-0.2-0.2-0.3-0.3c-0.1-0.1-0.1-0.2-0.2-0.3c-0.1-0.1-0.2-0.2-0.2-0.4c-0.1-0.1-0.1-0.3-0.2-0.4 c-0.1-0.1-0.1-0.3-0.1-0.5c0-0.2-0.1-0.3-0.1-0.5c0-0.2,0-0.3-0.1-0.5c0-0.2,0-0.4,0-0.5c0-0.2,0-0.4,0-0.5 c0-0.2,0-0.4,0.1-0.5c0.1-0.7,0.2-1.4,0.2-2c0-0.3,0-0.6,0-0.9c0-0.3-0.1-0.6-0.2-0.8c-0.1-0.2-0.2-0.5-0.3-0.6 c-0.1-0.2-0.2-0.3-0.3-0.4c-0.1-0.1-0.2-0.2-0.2-0.3c-0.1-0.1-0.1-0.1-0.1-0.1l0,0c0,0,0,0,0-0.1c0,0,0,0,0.1,0 c0,0,0,0,0.1,0.1c0.1,0.1,0.2,0.1,0.3,0.3c0.1,0.1,0.2,0.3,0.3,0.4c0.1,0.2,0.2,0.4,0.3,0.7c0.1,0.3,0.2,0.5,0.2,0.8 c0.1,0.3,0.1,0.6,0.1,1c0,0.7,0,1.4-0.1,2.1c0,0.2,0,0.3,0,0.5c0,0.2,0,0.3,0,0.5c0,0.2,0,0.3,0,0.5c0,0.2,0.1,0.3,0.1,0.5 c0,0.2,0.1,0.3,0.1,0.4c0,0.1,0.1,0.3,0.2,0.4c0.1,0.1,0.1,0.2,0.2,0.4c0.1,0.1,0.1,0.2,0.2,0.3c0.1,0.1,0.1,0.2,0.2,0.3 c0.1,0.1,0.1,0.1,0.2,0.2c0.1,0.1,0.1,0.1,0.2,0.2c0.1,0.1,0.1,0.1,0.2,0.1c0.3,0.2,0.4,0.3,0.4,0.3c0.2,0.1,0.2,0.3,0.1,0.5 C124.1,425.3,123.9,425.3,123.7,425.2C123.7,425.2,123.7,425.2,123.7,425.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st108",
    d: "M119,424.2c0,0,0,0-0.1-0.1c-0.1,0-0.2-0.1-0.4-0.2c-0.2-0.1-0.4-0.2-0.6-0.3c-0.2-0.1-0.5-0.3-0.7-0.6 c-0.1-0.1-0.2-0.3-0.3-0.5c0,0,0,0,0-0.1l0-0.1l0-0.1c0-0.1-0.1-0.2-0.1-0.2c-0.2-0.3-0.2-0.7-0.3-1.1 c-0.2-0.8-0.3-1.6-0.5-2.4c-0.1-0.4-0.2-0.8-0.3-1.2c-0.1-0.2-0.1-0.4-0.2-0.6c-0.1-0.2-0.1-0.4-0.2-0.5l-0.1-0.3 c0-0.1-0.1-0.2-0.1-0.2c-0.1-0.2-0.2-0.3-0.3-0.5c-0.2-0.3-0.4-0.6-0.5-0.8c-0.2-0.3-0.4-0.5-0.5-0.7c-0.2-0.2-0.3-0.4-0.4-0.5 c-0.2-0.3-0.4-0.4-0.4-0.4c0,0,0,0,0-0.1c0,0,0,0,0.1,0c0,0,0.1,0.1,0.4,0.4c0.1,0.1,0.3,0.3,0.5,0.5c0.2,0.2,0.4,0.4,0.6,0.6 c0.2,0.3,0.4,0.5,0.6,0.8c0.1,0.2,0.2,0.3,0.3,0.5c0,0.1,0.1,0.2,0.1,0.3l0.1,0.3c0.1,0.2,0.2,0.4,0.2,0.6 c0.1,0.2,0.1,0.4,0.2,0.6c0.2,0.4,0.3,0.8,0.4,1.2c0.3,0.8,0.5,1.6,0.7,2.4c0.1,0.4,0.2,0.7,0.4,1c0,0.1,0.1,0.2,0.1,0.2 l0.1,0.1l0,0.1c0,0,0,0,0,0c0.1,0.1,0.2,0.2,0.3,0.3c0.2,0.2,0.4,0.3,0.6,0.5c0.2,0.1,0.4,0.2,0.6,0.3c0.2,0.1,0.3,0.1,0.4,0.1 c0.1,0,0.1,0.1,0.1,0.1c0.2,0.1,0.3,0.3,0.2,0.5C119.4,424.1,119.2,424.2,119,424.2C119,424.2,119,424.2,119,424.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st108",
    d: "M112,423.4c0,0-0.2-0.1-0.4-0.2c-0.3-0.2-0.7-0.3-1.1-0.6c-0.1-0.1-0.2-0.2-0.4-0.2 c-0.1-0.1-0.2-0.2-0.4-0.3c-0.1-0.1-0.1-0.1-0.2-0.2c0,0-0.1,0-0.1-0.1l-0.1-0.1c-0.1-0.1-0.2-0.2-0.3-0.4 c-0.2-0.3-0.4-0.6-0.6-0.9c-0.2-0.3-0.3-0.6-0.5-1c-0.1-0.3-0.3-0.6-0.4-1c-0.1-0.3-0.2-0.7-0.4-1c-0.1-0.3-0.2-0.6-0.3-0.9 c-0.1-0.3-0.2-0.5-0.4-0.8c-0.1-0.1-0.1-0.2-0.2-0.3c-0.1-0.1-0.1-0.2-0.2-0.3c-0.1-0.2-0.2-0.3-0.3-0.4 c-0.2-0.2-0.3-0.4-0.3-0.4l0,0c0,0,0,0,0-0.1c0,0,0,0,0.1,0c0,0,0.1,0.1,0.3,0.4c0.1,0.1,0.2,0.3,0.4,0.4 c0.1,0.1,0.1,0.2,0.2,0.3c0.1,0.1,0.1,0.2,0.2,0.3c0.1,0.2,0.3,0.5,0.4,0.8c0.1,0.3,0.3,0.6,0.4,0.9c0.1,0.3,0.3,0.6,0.4,0.9 c0.1,0.3,0.3,0.6,0.5,0.9c0.2,0.3,0.3,0.6,0.5,0.9c0.2,0.3,0.4,0.5,0.6,0.8c0.1,0.1,0.2,0.2,0.3,0.4l0.1,0.1c0,0,0.1,0,0.1,0.1 c0.1,0,0.1,0.1,0.2,0.1c0.1,0.1,0.2,0.2,0.3,0.2c0.1,0.1,0.2,0.1,0.3,0.2c0.4,0.3,0.9,0.4,1.1,0.6c0.3,0.1,0.4,0.2,0.4,0.2 c0.2,0.1,0.3,0.3,0.2,0.5C112.4,423.5,112.2,423.5,112,423.4C112,423.5,112,423.4,112,423.4L112,423.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st108",
    d: "M106.1,424.4l-0.8-0.9l-0.4-0.4c-0.1-0.1-0.3-0.3-0.4-0.4l-0.4-0.4c-0.1-0.1-0.3-0.3-0.4-0.4l-0.5-0.3 c-0.2-0.1-0.3-0.2-0.5-0.3l-1.1-0.5c-0.3-0.2-0.7-0.3-1.1-0.5l-1.1-0.5c-0.2-0.1-0.4-0.2-0.5-0.3c-0.2-0.1-0.3-0.2-0.5-0.4l0,0 l0,0l0-0.3c0-0.1,0-0.2-0.1-0.2l0,0c0,0,0,0,0-0.1c0,0,0,0,0,0c0,0.1,0.1,0.2,0.1,0.3l0,0.3l0,0c0.2,0.1,0.3,0.2,0.5,0.3 c0.2,0.1,0.3,0.2,0.5,0.2l1.1,0.4c0.4,0.1,0.8,0.3,1.1,0.4l1.1,0.5c0.2,0.1,0.4,0.2,0.5,0.3l0.5,0.3c0.2,0.1,0.3,0.2,0.5,0.4 l0.5,0.4c0.2,0.1,0.3,0.3,0.5,0.4l0.4,0.4l0.8,0.8c0.1,0.1,0.1,0.4,0,0.5C106.5,424.5,106.3,424.6,106.1,424.4 C106.1,424.4,106.1,424.4,106.1,424.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st108",
    d: "M101.1,427.5c0,0-0.1-0.1-0.3-0.4c-0.1-0.1-0.2-0.3-0.4-0.4c-0.1-0.2-0.3-0.4-0.5-0.5 c-0.2-0.2-0.4-0.4-0.6-0.6c-0.2-0.2-0.4-0.4-0.7-0.6c-0.3-0.2-0.5-0.4-0.8-0.6c-0.3-0.2-0.6-0.4-0.8-0.6 c-0.3-0.2-0.6-0.4-0.9-0.6c-0.3-0.2-0.6-0.3-0.9-0.5c-0.6-0.3-1.1-0.7-1.5-1c-0.2-0.2-0.4-0.4-0.5-0.6 c-0.1-0.2-0.2-0.4-0.2-0.5c0-0.1,0-0.1,0-0.2c0-0.1,0-0.1,0-0.2c0-0.1,0-0.1,0-0.1c0,0,0,0,0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0.1 c0,0,0,0.1,0,0.1c0,0.1,0,0.1,0,0.2c0,0.1,0.1,0.3,0.2,0.5c0.1,0.2,0.3,0.3,0.5,0.5c0.4,0.3,0.9,0.6,1.5,0.9 c0.3,0.1,0.6,0.3,0.9,0.4c0.3,0.2,0.6,0.3,0.9,0.5c0.3,0.2,0.6,0.3,0.9,0.5c0.3,0.2,0.6,0.4,0.8,0.6c0.3,0.2,0.5,0.4,0.8,0.6 c0.2,0.2,0.5,0.4,0.7,0.6c0.2,0.2,0.3,0.4,0.5,0.5c0.1,0.2,0.3,0.3,0.4,0.4c0.2,0.2,0.3,0.4,0.3,0.4c0.1,0.1,0.1,0.4,0,0.5 C101.5,427.6,101.3,427.6,101.1,427.5C101.1,427.5,101.1,427.5,101.1,427.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st108",
    d: "M99.6,437.8c0,0-0.1,0.1-0.4,0.2c-0.3,0.1-0.6,0.3-1.1,0.5c-0.2,0.1-0.5,0.2-0.8,0.3 c-0.3,0.1-0.6,0.2-0.9,0.2c-0.3,0-0.6,0.1-1,0.1c-0.2,0-0.3,0-0.5,0l-0.5-0.1c-0.2,0-0.3-0.1-0.5-0.1c-0.2,0-0.3-0.1-0.5-0.1 c-0.3-0.1-0.6-0.3-0.9-0.4c-0.6-0.2-1.1-0.5-1.5-0.6c-0.2-0.1-0.4-0.1-0.6-0.1c-0.2,0-0.4,0-0.5,0.1c-0.1,0.1-0.2,0.1-0.3,0.2 c-0.1,0-0.1,0.1-0.1,0.1l0,0c0,0,0,0-0.1,0c0,0,0,0,0-0.1c0,0,0,0,0.1-0.1c0.1-0.1,0.2-0.1,0.3-0.2c0.1-0.1,0.3-0.1,0.5-0.1 c0.2,0,0.4,0,0.7,0c0.5,0.1,1,0.3,1.6,0.5c0.3,0.1,0.6,0.2,0.9,0.3c0.1,0,0.3,0.1,0.5,0.1c0.2,0,0.3,0.1,0.5,0.1l0.5,0 c0.2,0,0.3,0,0.5,0c0.3,0,0.6-0.1,0.9-0.1c0.3-0.1,0.6-0.2,0.8-0.2c0.3-0.1,0.5-0.2,0.7-0.3c0.4-0.2,0.8-0.4,1-0.5 c0.3-0.1,0.4-0.2,0.4-0.2c0.2-0.1,0.4,0,0.5,0.2C99.9,437.4,99.8,437.7,99.6,437.8C99.6,437.8,99.6,437.8,99.6,437.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st108",
    d: "M99.1,434c0,0-0.7,0.1-1.7,0.2c-0.5,0.1-1.1,0.1-1.8,0.1c-0.7,0-1.4-0.2-2-0.4c-0.3-0.1-0.6-0.3-0.9-0.5 c-0.3-0.2-0.5-0.4-0.8-0.6c-0.5-0.4-0.9-0.9-1.3-1.1c-0.2-0.1-0.4-0.2-0.6-0.3c-0.2-0.1-0.4-0.1-0.5-0.1c-0.3,0-0.5,0-0.5,0 l0-0.1c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0.2,0,0.5,0c0.2,0,0.3,0,0.5,0.1c0.2,0,0.4,0.1,0.7,0.3 c0.5,0.3,0.9,0.7,1.4,1.1c0.2,0.2,0.5,0.4,0.8,0.6c0.3,0.2,0.6,0.3,0.9,0.4c1.2,0.5,2.6,0.3,3.6,0.1c1-0.2,1.7-0.3,1.7-0.3 c0.2,0,0.4,0.1,0.4,0.3C99.4,433.8,99.3,434,99.1,434C99.1,434,99.1,434,99.1,434L99.1,434z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st108",
    d: "M99.2,431c0,0-1.7-1.1-3.3-2.1l-0.3-0.2c-0.1-0.1-0.2-0.1-0.3-0.2c-0.2-0.1-0.4-0.2-0.6-0.3 c-0.4-0.1-0.9-0.3-1.2-0.4c-0.2-0.1-0.3-0.1-0.5-0.2c-0.1-0.1-0.3-0.1-0.4-0.2c-0.2-0.1-0.3-0.2-0.3-0.2c0,0,0,0,0-0.1 c0,0,0,0,0.1,0l0,0c0,0,0.1,0.1,0.3,0.1c0.1,0.1,0.2,0.1,0.4,0.1c0.1,0.1,0.3,0.1,0.5,0.1c0.4,0.1,0.8,0.2,1.2,0.3 c0.2,0.1,0.5,0.1,0.7,0.2c0.1,0.1,0.2,0.1,0.3,0.2l0.3,0.2c1.7,0.9,3.5,1.8,3.5,1.8l0,0c0.2,0.1,0.2,0.3,0.2,0.5 C99.7,431.1,99.4,431.1,99.2,431C99.3,431,99.2,431,99.2,431z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st108",
    d: "M100.7,439.6c0,0,0,0.2,0,0.4c0,0.3-0.1,0.7-0.2,1.1c-0.1,0.2-0.1,0.5-0.2,0.7c-0.1,0.3-0.2,0.5-0.4,0.8 c-0.2,0.2-0.4,0.5-0.6,0.7c-0.3,0.2-0.6,0.3-0.9,0.4c-0.3,0.1-0.6,0.1-0.9,0.2c-0.3,0-0.6,0.1-0.9,0.1c-0.5,0.1-1,0.2-1.4,0.4 c-0.2,0.1-0.4,0.2-0.5,0.3c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0.1-0.1,0.2-0.2,0.2c0,0.1-0.1,0.1-0.1,0.1l0,0c0,0,0,0-0.1,0 c0,0,0,0,0-0.1c0,0,0,0,0.1-0.1c0-0.1,0.1-0.2,0.2-0.3c0.1-0.1,0.2-0.2,0.3-0.4c0.1-0.1,0.3-0.3,0.5-0.4 c0.4-0.2,0.9-0.4,1.5-0.5c0.3-0.1,0.6-0.1,0.9-0.2c0.3-0.1,0.6-0.1,0.8-0.2c0.5-0.2,0.9-0.5,1.2-1c0.1-0.2,0.2-0.5,0.3-0.7 c0.1-0.2,0.1-0.5,0.2-0.7c0.1-0.4,0.1-0.8,0.1-1c0-0.3,0-0.4,0-0.4l0,0c0-0.2,0.2-0.4,0.4-0.4 C100.5,439.2,100.7,439.4,100.7,439.6C100.7,439.6,100.7,439.6,100.7,439.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st108",
    d: "M103.6,443.5c0,0-0.1,0.1-0.2,0.4c-0.1,0.1-0.1,0.3-0.2,0.4c-0.1,0.2-0.2,0.4-0.4,0.5 c-0.1,0.2-0.3,0.4-0.5,0.6c-0.2,0.2-0.4,0.4-0.6,0.6c-0.2,0.2-0.4,0.4-0.7,0.6c-0.2,0.2-0.5,0.4-0.8,0.5 c-0.3,0.2-0.5,0.3-0.8,0.5c-0.1,0.1-0.3,0.2-0.4,0.2c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0.1-0.2,0.2-0.3,0.3 c-0.1,0.1-0.2,0.2-0.3,0.3c-0.2,0.2-0.3,0.4-0.5,0.6c-0.3,0.4-0.5,0.7-0.6,0.9c-0.1,0.2-0.2,0.3-0.2,0.3c0,0,0,0-0.1,0 c0,0,0,0,0-0.1c0,0,0.1-0.1,0.2-0.4c0.1-0.2,0.3-0.6,0.6-0.9c0.1-0.2,0.3-0.4,0.4-0.6c0.1-0.1,0.2-0.2,0.3-0.3 c0.1-0.1,0.2-0.2,0.3-0.3c0.1-0.1,0.2-0.2,0.3-0.3c0.1-0.1,0.2-0.2,0.4-0.3c0.2-0.2,0.5-0.3,0.7-0.5c0.2-0.2,0.5-0.4,0.7-0.5 c0.2-0.2,0.4-0.4,0.6-0.6c0.2-0.2,0.4-0.4,0.5-0.6c0.2-0.2,0.3-0.4,0.4-0.6c0.1-0.2,0.2-0.4,0.3-0.5c0.1-0.1,0.2-0.3,0.2-0.4 c0.1-0.2,0.2-0.4,0.2-0.4c0.1-0.2,0.3-0.3,0.5-0.2C103.6,443,103.7,443.3,103.6,443.5C103.6,443.5,103.6,443.5,103.6,443.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st108",
    d: "M106.8,447.5c0,0,0,0-0.1,0c-0.1,0-0.2,0-0.3,0c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.2,0.1 c-0.2,0.1-0.3,0.2-0.5,0.3c-0.2,0.1-0.4,0.3-0.5,0.5c-0.2,0.2-0.4,0.4-0.5,0.7c-0.3,0.5-0.7,1-1,1.6c-0.2,0.3-0.3,0.6-0.5,0.8 c-0.2,0.3-0.4,0.5-0.6,0.7c-0.2,0.2-0.5,0.4-0.7,0.6c-0.2,0.2-0.5,0.3-0.7,0.4c-0.4,0.3-0.8,0.5-1,0.6 c-0.2,0.2-0.4,0.3-0.4,0.3l0,0c0,0,0,0-0.1,0c0,0,0,0,0-0.1c0,0,0.1-0.1,0.3-0.3c0.2-0.2,0.6-0.4,1-0.7 c0.2-0.1,0.4-0.3,0.6-0.5c0.2-0.2,0.4-0.4,0.6-0.6c0.2-0.2,0.4-0.5,0.5-0.7c0.2-0.3,0.3-0.6,0.5-0.8c0.3-0.6,0.6-1.2,0.9-1.7 c0.2-0.3,0.3-0.5,0.5-0.7c0.2-0.2,0.4-0.4,0.6-0.6c0.1-0.1,0.2-0.2,0.3-0.2c0.1-0.1,0.2-0.1,0.3-0.2c0.1,0,0.2-0.1,0.3-0.1 c0.1,0,0.2,0,0.3-0.1c0.2,0,0.3,0,0.4,0c0.1,0,0.1,0,0.1,0c0.2,0,0.4,0.1,0.4,0.4C107.1,447.3,107,447.5,106.8,447.5 C106.8,447.5,106.8,447.5,106.8,447.5z"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_15_",
    cx: 282.8432,
    cy: 763.8555,
    r: 47.2903,
    gradientTransform: "matrix(1 0 0 0.8598 0 -208.38)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2772,
    style: {
      stopColor: "#FFA12B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3762,
    style: {
      stopColor: "#FFB353"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5396,
    style: {
      stopColor: "#FFCE90"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6897,
    style: {
      stopColor: "#FFE3C0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8212,
    style: {
      stopColor: "#FFF2E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9291,
    style: {
      stopColor: "#FFFCF7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st112",
    cx: 282.8,
    cy: 448.4,
    rx: 47.3,
    ry: 40.7
  })), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st113",
    d: "M280,411.5h4.1c-0.5-3.6-0.5-7.2,0-10.8H280C280.4,404.3,280.4,407.9,280,411.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st113",
    d: "M267.5,415.9l3.6-2.1c-2.2-2.9-4-6-5.4-9.4l-3.6,2.1C264.3,409.4,266.1,412.6,267.5,415.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st113",
    d: "M259,426l2.1-3.6c-3.4-1.4-6.5-3.2-9.4-5.4l-2,3.6C252.9,422,256.1,423.8,259,426z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st113",
    d: "M256.6,439l0-4.1c-3.6,0.5-7.2,0.5-10.8,0l0,4.1C249.4,438.5,253,438.5,256.6,439z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st113",
    d: "M261,451.4l-2-3.6c-2.9,2.2-6,4-9.4,5.4l2.1,3.6C254.5,454.6,257.7,452.8,261,451.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st113",
    d: "M271.1,460l-3.6-2.1c-1.4,3.4-3.2,6.5-5.4,9.4l3.6,2C267.1,466,268.9,462.9,271.1,460z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st113",
    d: "M284.1,462.3l-4.1,0c0.5,3.6,0.5,7.2,0,10.8l4.1,0C283.6,469.6,283.6,466,284.1,462.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st113",
    d: "M296.5,457.9l-3.6,2c2.2,2.9,4,6,5.4,9.4l3.5-2.1C299.7,464.4,297.9,461.3,296.5,457.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st113",
    d: "M305.1,447.9l-2.1,3.6c3.4,1.4,6.5,3.2,9.4,5.4l2-3.6C311.1,451.9,308,450,305.1,447.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st113",
    d: "M307.5,434.9l0,4.1c3.6-0.5,7.2-0.5,10.8,0v-4.1C314.7,435.3,311.1,435.3,307.5,434.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st113",
    d: "M303,422.4l2,3.6c2.9-2.2,6-4,9.4-5.4l-2-3.5C309.5,419.2,306.4,421,303,422.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st113",
    d: "M293,413.9l3.6,2.1c1.4-3.4,3.2-6.5,5.4-9.4l-3.5-2.1C297,407.8,295.2,411,293,413.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st113",
    d: "M310.9,436.9c0,15.9-12.9,28.9-28.8,28.9c-15.9,0-28.8-12.9-28.8-28.9c0-15.9,12.9-28.8,28.8-28.8 C298,408.1,310.9,421,310.9,436.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st113",
    d: "M310.9,436.9c0,3.5-0.6,6.8-1.7,9.9c-0.7,2-1.6,3.8-2.7,5.5c-3.5,5.6-9,9.9-15.4,12 c-2.8,0.9-5.9,1.4-9,1.4c-15.9,0-28.9-12.9-28.9-28.9c0-3.1,0.5-6.2,1.4-9c2.1-6.4,6.4-11.8,12-15.4c1.7-1.1,3.6-2,5.5-2.7 c3.1-1.1,6.4-1.7,9.9-1.7C298,408.1,310.9,421,310.9,436.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st114",
    d: "M292.4,455.3c0,3.1-0.5,6.2-1.4,9c-2.8,0.9-5.9,1.4-9,1.4c-15.9,0-28.9-12.9-28.9-28.9 c0-3.1,0.5-6.2,1.4-9c2.8-0.9,5.9-1.4,9-1.4C279.5,426.5,292.4,439.4,292.4,455.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st115",
    d: "M310.9,436.9c0,3.5-0.6,6.8-1.7,9.9c-0.7,2-1.6,3.8-2.7,5.5c-4.5,2.8-9.7,4.5-15.4,4.5 c-15.9,0-28.9-12.9-28.9-28.9c0-5.7,1.6-10.9,4.4-15.4c1.7-1.1,3.6-2,5.5-2.7c3.1-1.1,6.4-1.7,9.9-1.7 C298,408.1,310.9,421,310.9,436.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st115",
    d: "M288.6,420.4c0,1.2-1,2.2-2.2,2.2s-2.2-1-2.2-2.2c0-1.2,1-2.2,2.2-2.2S288.6,419.2,288.6,420.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st114",
    d: "M305.1,441.7c0,1.3-1.1,2.4-2.4,2.4c-1.3,0-2.4-1.1-2.4-2.4c0-1.3,1.1-2.4,2.4-2.4 C304,439.3,305.1,440.4,305.1,441.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st114",
    d: "M267.1,435c0,2.4-1.9,4.3-4.3,4.3s-4.3-1.9-4.3-4.3c0-2.4,1.9-4.3,4.3-4.3S267.1,432.6,267.1,435z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st114",
    d: "M291.4,429.3c0,1.8-1.5,3.3-3.3,3.3c-1.8,0-3.3-1.5-3.3-3.3c0-1.8,1.5-3.3,3.3-3.3 C290,425.9,291.4,427.4,291.4,429.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st114",
    d: "M295.9,454.1c0,1-0.8,1.7-1.7,1.7c-1,0-1.7-0.8-1.7-1.7c0-1,0.8-1.7,1.7-1.7 C295.1,452.3,295.9,453.1,295.9,454.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st115",
    d: "M274.8,421.8c0,2.1-1.7,3.8-3.8,3.8c-2.1,0-3.8-1.7-3.8-3.8c0-2.1,1.7-3.8,3.8-3.8 C273.1,418,274.8,419.7,274.8,421.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st114",
    cx: 280.2,
    cy: 415,
    r: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st114",
    d: "M302.1,423.4c0,0.9-0.7,1.7-1.7,1.7c-0.9,0-1.7-0.7-1.7-1.7c0-0.9,0.7-1.7,1.7-1.7 C301.4,421.7,302.1,422.4,302.1,423.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st115",
    d: "M278.9,452.6c0,2.1-1.7,3.8-3.8,3.8c-2.1,0-3.8-1.7-3.8-3.8c0-2.1,1.7-3.8,3.8-3.8 C277.2,448.8,278.9,450.5,278.9,452.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st115",
    d: "M306.6,429.3c0,1-0.8,1.8-1.8,1.8c-1,0-1.8-0.8-1.8-1.8c0-1,0.8-1.8,1.8-1.8 C305.8,427.5,306.6,428.3,306.6,429.3z"
  })))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M261.8,507.9c-0.2,1.7-0.8,3-1.9,4c-1.1,1-2.6,1.4-4.4,1.4c-1.3,0-2.4-0.3-3.4-0.9c-1-0.6-1.7-1.5-2.2-2.6 c-0.5-1.1-0.8-2.4-0.8-3.9v-1.5c0-1.5,0.3-2.8,0.8-4c0.5-1.1,1.3-2,2.3-2.7c1-0.6,2.1-0.9,3.5-0.9c1.8,0,3.2,0.5,4.2,1.4 c1.1,1,1.7,2.3,1.9,4H259c-0.1-1.1-0.5-2-1-2.5c-0.5-0.5-1.3-0.8-2.4-0.8c-1.2,0-2.1,0.4-2.8,1.3c-0.6,0.9-1,2.2-1,3.9v1.4 c0,1.7,0.3,3,0.9,3.9s1.5,1.4,2.7,1.4c1.1,0,1.9-0.2,2.5-0.7c0.5-0.5,0.9-1.3,1-2.4H261.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.1,513.1c-0.1-0.2-0.2-0.6-0.3-1.1c-0.8,0.9-1.9,1.3-3.1,1.3c-1.2,0-2.2-0.3-2.9-1c-0.8-0.7-1.1-1.5-1.1-2.5 c0-1.3,0.5-2.2,1.4-2.9c0.9-0.7,2.3-1,4-1h1.6v-0.8c0-0.6-0.2-1.1-0.5-1.5c-0.3-0.4-0.9-0.6-1.6-0.6c-0.6,0-1.1,0.2-1.5,0.5 c-0.4,0.3-0.6,0.7-0.6,1.2h-2.7c0-0.6,0.2-1.3,0.6-1.8s1-1,1.8-1.3s1.6-0.5,2.5-0.5c1.4,0,2.5,0.3,3.3,1s1.2,1.7,1.3,2.9v5.3 c0,1.1,0.1,1.9,0.4,2.6v0.2H271.1z M268.2,511.2c0.5,0,1-0.1,1.5-0.4c0.5-0.3,0.8-0.6,1-1v-2.2h-1.4c-1,0-1.7,0.2-2.2,0.5 c-0.5,0.3-0.7,0.8-0.7,1.5c0,0.5,0.2,0.9,0.5,1.2S267.6,511.2,268.2,511.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.6,501.2l0.1,1.4c0.9-1.1,2-1.6,3.5-1.6c2.5,0,3.7,1.4,3.8,4.2v7.8h-2.7v-7.7c0-0.8-0.2-1.3-0.5-1.7 s-0.9-0.5-1.6-0.5c-1.1,0-1.9,0.5-2.4,1.5v8.4h-2.7v-11.8H278.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.5,511.2c0.7,0,1.2-0.2,1.7-0.6c0.4-0.4,0.7-0.9,0.7-1.4h2.5c0,0.7-0.3,1.4-0.7,2.1c-0.4,0.6-1,1.1-1.8,1.5 c-0.7,0.4-1.5,0.6-2.4,0.6c-1.7,0-3-0.5-3.9-1.6c-1-1.1-1.5-2.6-1.5-4.4V507c0-1.8,0.5-3.2,1.4-4.3c1-1.1,2.3-1.6,3.9-1.6 c1.4,0,2.6,0.4,3.4,1.2c0.9,0.8,1.4,1.9,1.4,3.2h-2.5c0-0.7-0.3-1.2-0.7-1.7c-0.4-0.4-1-0.7-1.7-0.7c-0.9,0-1.5,0.3-2,0.9 c-0.5,0.6-0.7,1.6-0.7,2.8v0.4c0,1.3,0.2,2.2,0.7,2.9C292,510.9,292.6,511.2,293.5,511.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.6,513.3c-1.7,0-3.1-0.5-4.1-1.6c-1-1.1-1.6-2.5-1.6-4.2v-0.3c0-1.2,0.2-2.2,0.7-3.2c0.5-0.9,1.1-1.7,1.9-2.2 c0.8-0.5,1.7-0.8,2.8-0.8c1.6,0,2.9,0.5,3.7,1.5c0.9,1,1.3,2.5,1.3,4.4v1.1h-7.7c0.1,1,0.4,1.8,1,2.3c0.6,0.6,1.3,0.9,2.2,0.9 c1.2,0,2.2-0.5,3-1.5l1.4,1.4c-0.5,0.7-1.1,1.3-1.9,1.6C307.5,513.1,306.6,513.3,305.6,513.3z M305.3,503.1 c-0.7,0-1.3,0.3-1.8,0.8s-0.7,1.2-0.9,2.1h5.1v-0.2c-0.1-0.9-0.3-1.6-0.7-2S306,503.1,305.3,503.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.6,503.7c-0.4-0.1-0.7-0.1-1.1-0.1c-1.2,0-2,0.5-2.5,1.4v8.1h-2.7v-11.8h2.5l0.1,1.3c0.6-1,1.5-1.5,2.7-1.5 c0.4,0,0.7,0.1,0.9,0.2L318.6,503.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.9,509.9c0-0.5-0.2-0.8-0.6-1.1c-0.4-0.2-1-0.5-1.9-0.7c-0.9-0.2-1.7-0.4-2.3-0.7c-1.3-0.6-2-1.6-2-2.8 c0-1,0.4-1.9,1.3-2.6c0.9-0.7,2-1,3.3-1c1.4,0,2.6,0.4,3.4,1.1c0.9,0.7,1.3,1.6,1.3,2.7h-2.7c0-0.5-0.2-0.9-0.6-1.3 c-0.4-0.3-0.9-0.5-1.5-0.5c-0.6,0-1.1,0.1-1.4,0.4c-0.4,0.3-0.6,0.6-0.6,1.1c0,0.4,0.2,0.7,0.5,1c0.3,0.2,1,0.5,2.1,0.7 c1,0.2,1.9,0.5,2.5,0.8c0.6,0.3,1,0.7,1.3,1.1c0.3,0.4,0.4,1,0.4,1.6c0,1.1-0.4,1.9-1.3,2.6c-0.9,0.7-2,1-3.5,1 c-1,0-1.8-0.2-2.6-0.5c-0.8-0.4-1.4-0.8-1.8-1.4c-0.4-0.6-0.6-1.3-0.6-2h2.6c0,0.6,0.3,1.1,0.7,1.5c0.4,0.3,1,0.5,1.7,0.5 c0.7,0,1.2-0.1,1.6-0.4S326.9,510.3,326.9,509.9z"
  })))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M422.4,509.6h7.2v2.2h-10v-15.9h2.8V509.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.5,496.9c0-0.4,0.1-0.7,0.4-1c0.3-0.3,0.6-0.4,1.1-0.4c0.5,0,0.9,0.1,1.1,0.4c0.3,0.3,0.4,0.6,0.4,1 c0,0.4-0.1,0.7-0.4,1c-0.3,0.3-0.6,0.4-1.1,0.4c-0.5,0-0.9-0.1-1.1-0.4C431.6,497.7,431.5,497.3,431.5,496.9z M434.3,511.9h-2.7 V500h2.7V511.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.1,511.9V502h-1.8v-2h1.8v-1.1c0-1.3,0.4-2.3,1.1-3c0.7-0.7,1.8-1.1,3.1-1.1c0.5,0,1,0.1,1.5,0.2l-0.1,2.1 c-0.3-0.1-0.6-0.1-1-0.1c-1.3,0-1.9,0.7-1.9,2v1.1h2.4v2h-2.4v9.9H438.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.1,512.1c-1.7,0-3.1-0.5-4.1-1.6c-1-1.1-1.6-2.5-1.6-4.2v-0.3c0-1.2,0.2-2.2,0.7-3.2c0.5-0.9,1.1-1.7,1.9-2.2 c0.8-0.5,1.7-0.8,2.8-0.8c1.6,0,2.9,0.5,3.7,1.5s1.3,2.5,1.3,4.4v1.1h-7.7c0.1,1,0.4,1.8,1,2.3c0.6,0.6,1.3,0.9,2.2,0.9 c1.2,0,2.2-0.5,3-1.5l1.4,1.4c-0.5,0.7-1.1,1.3-1.9,1.6S451.1,512.1,450.1,512.1z M449.8,501.9c-0.7,0-1.3,0.3-1.8,0.8 s-0.7,1.2-0.9,2.1h5.1v-0.2c-0.1-0.9-0.3-1.6-0.7-2S450.5,501.9,449.8,501.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.1,507.7c0-0.7-0.2-1.2-0.7-1.6s-1.4-0.8-2.7-1.1c-1.3-0.4-2.3-0.8-3.1-1.3c-1.5-0.9-2.2-2.1-2.2-3.6 c0-1.3,0.5-2.3,1.6-3.2c1-0.8,2.4-1.2,4.1-1.2c1.1,0,2.1,0.2,3,0.6s1.6,1,2,1.7c0.5,0.8,0.7,1.6,0.7,2.5h-2.8c0-0.8-0.3-1.5-0.8-2 c-0.5-0.5-1.3-0.7-2.2-0.7c-0.9,0-1.6,0.2-2.1,0.6c-0.5,0.4-0.8,0.9-0.8,1.6c0,0.6,0.3,1.1,0.8,1.5c0.5,0.4,1.4,0.8,2.7,1.1 c1.2,0.4,2.2,0.8,3,1.3s1.3,1,1.7,1.6c0.4,0.6,0.5,1.3,0.5,2.1c0,1.3-0.5,2.4-1.5,3.2c-1,0.8-2.4,1.2-4.1,1.2 c-1.2,0-2.2-0.2-3.2-0.6c-1-0.4-1.7-1-2.3-1.8c-0.5-0.8-0.8-1.6-0.8-2.6h2.8c0,0.9,0.3,1.6,0.9,2.1s1.5,0.7,2.6,0.7 c1,0,1.7-0.2,2.2-0.6S471.1,508.4,471.1,507.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.4,506c0,1.8-0.4,3.3-1.2,4.4s-1.9,1.6-3.4,1.6c-1.3,0-2.3-0.4-3.1-1.3v5.6h-2.7V500h2.5l0.1,1.2 c0.8-0.9,1.8-1.4,3.2-1.4c1.4,0,2.6,0.5,3.4,1.6c0.8,1.1,1.2,2.6,1.2,4.5V506z M483.8,505.8c0-1.2-0.2-2.1-0.7-2.8 c-0.5-0.7-1.1-1-2-1c-1.1,0-1.9,0.4-2.3,1.3v5.3c0.5,0.9,1.3,1.4,2.4,1.4c0.8,0,1.5-0.3,2-1S483.8,507.2,483.8,505.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.8,511.9c-0.1-0.2-0.2-0.6-0.3-1.1c-0.8,0.9-1.9,1.3-3.1,1.3c-1.2,0-2.2-0.3-2.9-1c-0.8-0.7-1.1-1.5-1.1-2.5 c0-1.3,0.5-2.2,1.4-2.9c0.9-0.7,2.3-1,4-1h1.6v-0.8c0-0.6-0.2-1.1-0.5-1.5c-0.3-0.4-0.9-0.6-1.6-0.6c-0.6,0-1.1,0.2-1.5,0.5 c-0.4,0.3-0.6,0.7-0.6,1.2h-2.7c0-0.6,0.2-1.3,0.6-1.8s1-1,1.8-1.3c0.7-0.3,1.6-0.5,2.5-0.5c1.4,0,2.5,0.3,3.3,1 c0.8,0.7,1.2,1.7,1.3,2.9v5.3c0,1.1,0.1,1.9,0.4,2.6v0.2H495.8z M492.8,509.9c0.5,0,1-0.1,1.5-0.4c0.5-0.3,0.8-0.6,1-1v-2.2h-1.4 c-1,0-1.7,0.2-2.2,0.5c-0.5,0.3-0.7,0.8-0.7,1.5c0,0.5,0.2,0.9,0.5,1.2C491.8,509.8,492.3,509.9,492.8,509.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.3,500l0.1,1.4c0.9-1.1,2-1.6,3.5-1.6c2.5,0,3.7,1.4,3.8,4.2v7.8h-2.7v-7.7c0-0.8-0.2-1.3-0.5-1.7 c-0.3-0.4-0.9-0.5-1.6-0.5c-1.1,0-1.9,0.5-2.4,1.5v8.4h-2.7V500H503.3z"
  })))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    className: "st116"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st117",
    cx: 89.5,
    cy: 431.4,
    r: 41.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st117",
    x1: 59.8,
    y1: 401.1,
    x2: 118.9,
    y2: 460.2
  }))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    className: "st116"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st117",
    cx: 280.4,
    cy: 436,
    r: 41.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st117",
    x1: 250.7,
    y1: 405.6,
    x2: 309.7,
    y2: 464.7
  }))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st118",
    d: "M303.6,33.4L301.5,14c-0.1-0.7,0.4-1.2,1-1.3l0,0c0.7-0.1,1.2,0.4,1.3,1l2.2,19.4c0.1,0.7-0.4,1.2-1,1.3 l0,0C304.3,34.6,303.7,34.1,303.6,33.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st118",
    d: "M286.4,25.7L285.1,14c-0.1-0.7,0.4-1.2,1-1.3l0,0c0.7-0.1,1.2,0.4,1.3,1l1.3,11.7c0.1,0.7-0.4,1.2-1,1.3 l0,0C287.1,26.8,286.5,26.4,286.4,25.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st118",
    d: "M336.1,33.6c-5.1-2-9.9-4.7-14.4-7.8c-2.2-1.5-4.5-3.3-6.5-4.9c-1-0.8-2-1.5-3.1-2.1 c-1.1-0.6-2.2-1.3-3.3-1.9c-4.5-2.3-9.3-3.7-14.3-3.6c-5,0-10.1,1.5-15.1,3.7c3.8-4,9-6.8,14.8-7.7c5.8-0.9,11.8,0.4,16.9,3.1 c1.3,0.7,2.5,1.4,3.7,2.2c1.2,0.8,2.4,1.7,3.5,2.6c1.1,0.9,2,1.9,3,2.8l2.9,2.7C328.1,26.3,332.1,29.8,336.1,33.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st118",
    d: "M268.6,42.7l-1.3-12c-0.1-0.7,0.4-1.2,1-1.3v0c0.7-0.1,1.2,0.4,1.3,1l1.3,12c0.1,0.7-0.4,1.2-1,1.3l0,0 C269.3,43.8,268.7,43.3,268.6,42.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st118",
    d: "M252.2,41.7l-2-18.3c-0.1-0.7,0.4-1.2,1-1.3l0,0c0.7-0.1,1.2,0.4,1.3,1l2,18.3c0.1,0.7-0.4,1.2-1,1.3l0,0 C252.8,42.8,252.2,42.3,252.2,41.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st118",
    d: "M277.4,38.4c-1.6,2.2-3.7,4.1-6.1,5.6c-2.4,1.5-5.2,2.4-8.1,2.8c-5.8,0.8-11.7-0.5-16.8-3 c-2.6-1.3-5-2.7-7.2-4.7l-6-5.3c-4-3.6-8-7.1-11.9-11c5,2.1,9.8,4.8,14.3,7.8c2.3,1.5,4.4,3.1,6.6,4.8c0.6,0.4,1,0.8,1.4,1.1 c0.5,0.3,1,0.7,1.6,1c1.1,0.6,2.2,1.2,3.3,1.8c4.5,2.2,9.4,3.6,14.3,3.6c2.5,0,5-0.4,7.4-1.1C272.7,41,275.1,39.8,277.4,38.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st119",
    d: "M312.7,39.2l-1.6-14.5c-0.1-0.7,0.4-1.2,1-1.3l0,0c0.7-0.1,1.2,0.4,1.3,1L315,39c0.1,0.7-0.4,1.2-1,1.3h0 C313.3,40.4,312.7,39.9,312.7,39.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st119",
    d: "M296,37.2l-2.2-19.4c-0.1-0.7,0.4-1.2,1-1.3l0,0c0.7-0.1,1.2,0.4,1.3,1l2.2,19.4c0.1,0.7-0.4,1.2-1,1.3h0 C296.6,38.4,296,37.9,296,37.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st119",
    d: "M259.9,38.1L258,21c-0.1-0.7,0.4-1.2,1-1.3l0,0c0.7-0.1,1.2,0.4,1.3,1l1.9,17.1c0.1,0.7-0.4,1.2-1,1.3l0,0 C260.6,39.2,260,38.7,259.9,38.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st119",
    d: "M242.7,32.4L241.4,21c-0.1-0.7,0.4-1.2,1-1.3l0,0c0.7-0.1,1.2,0.4,1.3,1l1.3,11.4c0.1,0.7-0.4,1.2-1,1.3 l0,0C243.3,33.5,242.7,33.1,242.7,32.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st119",
    d: "M320.1,36.4c-2.7,2.9-6.2,5.1-10.2,6.4c-4,1.3-8.5,1.2-12.6,0.1c-4.1-1-7.9-2.9-11.3-5.1 c-3.5-2.1-6.6-4.6-9.7-7c-1.6-1.2-3.2-2.7-4.5-3.8c-0.7-0.6-1.3-1.1-2.1-1.5c-0.7-0.5-1.6-1-2.4-1.5c-3.2-1.9-6.4-3.4-9.9-4.1 c-3.5-0.8-7.2-0.8-10.8-0.1C243,20.5,239.4,22,236,24c2.6-3,6-5.4,9.8-7c3.8-1.5,8.1-2.2,12.4-1.7c4.2,0.4,8.3,1.9,12,3.8 c0.9,0.5,1.7,0.9,2.7,1.5c0.9,0.5,1.9,1.2,2.7,1.9c1.6,1.4,3,2.5,4.5,3.7c3.1,2.4,6.1,4.8,9.1,6.9c3.1,2.1,6.2,4,9.6,5.3 c3.3,1.3,6.9,1.9,10.5,1.5C312.9,39.6,316.6,38.2,320.1,36.4z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "layer3",
    transform: "translate(.090382 -1.0316)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2851"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "path6737_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 625.107,
    y1: -342.5451,
    x2: 650.4885,
    y2: -364.7952,
    gradientTransform: "matrix(1 0 0 -1 -176.3301 131.0155)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    id: "path6737",
    className: "st120",
    d: "M464.3,489.2c6.8-0.5-7.3,2.1-8.1,2.3c-4.4,0.5,19.2-4,24-4.6c9.9-0.8-23.3,5.7-24.6,6 c0.4-1.7,29.5-7.7,24.7-4.9c-12.1,3.2-21.9,7.9-0.2,2.5c12-1-12.6,4.2-16.7,5.1c-2.3-1.1,27.3-6,16.6-2.6c-0.7,0.9-10.4,2.3-5.4,1 c0.7-0.2-1.3,0.4-2,0.7c-2.2,0.8-2.3,1.1,0,1.4c2.3,0.3,11.4-0.8,13.7-0.6l-3.9,2.5c-2.3-0.2-10.8-0.4-13.1-0.6 c-6.5-0.9,11.6-7,13.1-5.5c-3,1-24.4,4.9-15.6,2.1c10.3-2,7.2-0.5,0.1,0c-7.1,0.9-9.9,1.2-1.6-2.8c3.5-1.7-16.9,3.7-6.3,0 c4.4-0.8,23.3-3.7,8-0.1c-5.4,0.6-24.9,3.1-7.6-1.2c8-1.6,10.2-1,1.4,0.6L464.3,489.2L464.3,489.2L464.3,489.2z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    id: "path4874",
    className: "st121",
    d: "M460.1,420.4c-6.4-3.5-13.1-5.2-15-9.1c-6.5-13.2-4.5-19.8-5.7-26.3"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    id: "path4876",
    className: "st121",
    d: "M461.1,420.4c5.2-3.4,10.5-4.9,13.9-8.7c2.8-8.6,6-24.4,6-24.4"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    id: "path4878",
    className: "st121",
    d: "M458,452.4c1.9,36.8-3.1,33.4-2.8,34.2c0.3,0.8,0.5,1.9,0.5,1.9"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    id: "path4880",
    className: "st121",
    d: "M460.6,454.2c18.1,8.7,10.8,28.5,11.8,29.5c0.6,0.6,5.6-2.6,5.6-2.6"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    id: "path4882",
    className: "st122",
    d: "M456.4,485.5c-1.3,1.1-4.4,1.1-3,1.8c2.9,1.4,2.7,3.1,4.6,1.4 C460.2,486.8,465.1,488.5,456.4,485.5z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    id: "path5757",
    className: "st122",
    d: "M472.7,482.4c-1.3,2.1-3.1,2.4-1.7,2.4c2.9,0,6.9-0.9,8.9-4.1 C482.1,477.3,481.5,480.7,472.7,482.4L472.7,482.4z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    id: "path5759",
    className: "st122",
    d: "M437.4,384.2c1.9,0,2.8,4.6,2.4,3c-0.9-3.3,2-6.9-0.8-6.8 C435.8,380.4,433.7,375.5,437.4,384.2z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    id: "path5761",
    className: "st122",
    d: "M480.4,384.1c1.3,1.5-0.7,6.1-0.1,4.4c1.3-3.5,5.1-4.4,3.2-6.5 C481.5,379.6,482.7,373.7,480.4,384.1L480.4,384.1z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    id: "path3077",
    className: "st123",
    d: "M461.4,415.6c0.2,1.3-0.1,1.9-0.7,3.5c-3.9,10.3-3.1,36.9-0.7,35.7 c3.6-1.8-1.9-27.2,0.8-35.7C461.1,418,461.5,416.6,461.4,415.6L461.4,415.6z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    id: "path3075",
    className: "st124",
    d: "M453,394.1c2.2-5.6,6.9-6.2,10.6-1.3s4.8,13.4,2.6,19c-2.2,5.6-6.9,6.2-10.6,1.3 c-3.6-4.8-4.8-13.2-2.7-18.8"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    id: "path4833",
    className: "st125",
    d: "M455.6,398.7c0.5-1.1,1.7-1.4,2.7-0.6c1,0.8,1.4,2.3,0.9,3.4s-1.7,1.4-2.7,0.6 C455.5,401.3,455.1,399.8,455.6,398.7"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    id: "path4835",
    className: "st125",
    d: "M461.7,396.9c0.5-1.1,1.7-1.4,2.7-0.6c1,0.8,1.4,2.3,0.9,3.4c-0.5,1.1-1.7,1.4-2.7,0.6 C461.6,399.6,461.2,398.1,461.7,396.9"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    id: "path4837",
    className: "st126",
    d: "M464.5,407.9c-1,3.3-3.3,5.6-7,0.9"
  })))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st96",
    d: "M193.1,72.1"
  }))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st96",
    d: "M279.9,46.3"
  }))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st127",
    x1: 271.4,
    y1: 56.6,
    x2: 271.4,
    y2: 100.3
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st128",
    points: "266.4,96.8 276.9,96.8 271.6,103.8  "
  }))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    className: "st129"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st130",
    x1: 289.8,
    y1: 52.5,
    x2: 347.6,
    y2: 110.3
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st128",
    points: "341.9,110.7 348.8,105.4 348.8,112.6  "
  }))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    className: "st131"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st130",
    x1: 307.8,
    y1: 46.3,
    x2: 456.2,
    y2: 100.3
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st128",
    points: "451.2,103.2 455.5,95.6 458.4,102.3  "
  }))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    className: "st131"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st130",
    x1: 251.8,
    y1: 52.1,
    x2: 201.8,
    y2: 102
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st128",
    points: "201.5,96.4 207.5,102.7 200.3,103.5  "
  }))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    className: "st131"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st130",
    x1: 239.5,
    y1: 45,
    x2: 92.4,
    y2: 104.3
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st128",
    points: "94.5,98.9 97.4,107.1 90.5,105  "
  }))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 271.9,
    y: 220.2,
    className: "st132",
    width: 5,
    height: 56
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st132",
    points: "267.7,273.2 281.3,273.2 274.5,282.2  "
  }))), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 269.9,
    y: 345.8,
    className: "st132",
    width: 13.7,
    height: 26.4
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st132",
    points: "264.9,366.5 289.1,366.5 277,382.5  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTheSolution);
export default __webpack_public_path__ + "static/media/the-solution.64eec592b146cb48dd74b4c6167c7b21.svg";
export { ForwardRef as ReactComponent };